const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShowroomReserveProject(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 263.304,
    height: 227.967,
    viewBox: "0 0 263.304 227.967",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Showroom") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "74.501 60.027 74.388 100.018 58.995 91.132 59.109 51.14 74.501 60.027",
    style: {
      fill: "#d0daee"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70.466 59.869 70.38 90.502 59.327 84.121 59.414 53.487 70.466 59.869",
    style: {
      fill: "#113f54"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.371 84.02 59.563 83.908 61.54 85.049 61.347 85.161 59.371 84.02",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.377 81.751 59.57 81.64 59.563 83.908 59.371 84.02 59.377 81.751",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.384 79.343 59.577 79.231 59.571 81.365 59.378 81.476 59.384 79.343",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.584 85.298 61.777 85.186 63.753 86.327 63.561 86.439 61.584 85.298",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.591 83.029 61.783 82.918 61.777 85.186 61.584 85.298 61.591 83.029",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.378 81.476 59.571 81.365 61.547 82.506 61.355 82.618 59.378 81.476",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.597 80.62 61.79 80.509 61.784 82.643 61.592 82.754 61.597 80.62",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.798 86.576 63.99 86.464 65.967 87.605 65.774 87.717 63.798 86.576",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.804 84.307 63.997 84.196 63.99 86.464 63.798 86.576 63.804 84.307",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.592 82.754 61.784 82.643 63.761 83.784 63.568 83.896 61.592 82.754",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.392 76.664 59.584 76.553 59.578 78.686 59.385 78.798 59.392 76.664",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.385 78.798 59.578 78.686 61.555 79.828 61.362 79.94 59.385 78.798",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.811 81.898 64.004 81.787 63.998 83.92 63.805 84.032 63.811 81.898",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.398 74.256 59.591 74.144 59.585 76.28 59.392 76.392 59.398 74.256",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.011 87.854 66.204 87.742 68.18 88.883 67.988 88.995 66.011 87.854",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.018 85.585 66.21 85.474 66.204 87.742 66.011 87.854 66.018 85.585",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.805 84.032 63.998 83.92 65.974 85.062 65.782 85.174 63.805 84.032",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.605 77.942 61.798 77.831 61.792 79.964 61.599 80.076 61.605 77.942",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.392 76.392 59.585 76.28 61.562 77.422 61.369 77.534 59.392 76.392",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.599 80.076 61.792 79.964 63.768 81.106 63.576 81.218 61.599 80.076",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.024 83.176 66.217 83.065 66.211 85.198 66.019 85.31 66.024 83.176",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.612 75.533 61.805 75.422 61.798 77.558 61.606 77.67 61.612 75.533",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.225 89.132 68.417 89.02 70.394 90.161 70.201 90.273 68.225 89.132",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.231 86.863 68.424 86.752 68.417 89.02 68.225 89.132 68.231 86.863",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.019 85.31 66.211 85.198 68.188 86.34 67.995 86.452 66.019 85.31",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.819 79.22 64.011 79.109 64.005 81.243 63.813 81.354 63.819 79.22",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.606 77.67 61.798 77.558 63.775 78.7 63.583 78.812 61.606 77.67",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.406 71.578 59.599 71.465 59.593 73.6 59.4 73.711 59.406 71.578",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.813 81.354 64.005 81.243 65.982 82.384 65.789 82.496 63.813 81.354",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.4 73.711 59.593 73.6 61.569 74.741 61.377 74.853 59.4 73.711",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.238 84.454 68.431 84.343 68.425 86.476 68.232 86.588 68.238 84.454",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.825 76.812 64.018 76.7 64.012 78.836 63.819 78.948 63.825 76.812",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.413 69.171 59.605 69.06 59.599 71.193 59.407 71.305 59.413 69.171",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.232 86.588 68.425 86.476 70.401 87.618 70.209 87.73 68.232 86.588",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.032 80.499 66.225 80.387 66.219 82.521 66.026 82.632 66.032 80.499",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.819 78.948 64.012 78.836 65.989 79.978 65.796 80.09 63.819 78.948",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.619 72.856 61.812 72.743 61.806 74.877 61.613 74.989 61.619 72.856",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.407 71.305 59.599 71.193 61.576 72.335 61.384 72.447 59.407 71.305",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.026 82.632 66.219 82.521 68.195 83.662 68.003 83.774 66.026 82.632",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.613 74.989 61.806 74.877 63.783 76.019 63.59 76.131 61.613 74.989",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.039 78.089 66.232 77.978 66.226 80.114 66.033 80.226 66.039 78.089",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.626 70.449 61.819 70.338 61.813 72.471 61.62 72.583 61.626 70.449",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.246 81.777 68.438 81.665 68.432 83.799 68.24 83.91 68.246 81.777",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.033 80.226 66.226 80.114 68.202 81.256 68.01 81.367 66.033 80.226",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.833 74.134 64.026 74.021 64.02 76.155 63.827 76.267 63.833 74.134",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.62 72.583 61.813 72.471 63.79 73.613 63.597 73.725 61.62 72.583",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.42 66.49 59.613 66.379 59.607 68.512 59.414 68.624 59.42 66.49",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.24 83.91 68.432 83.799 70.409 84.94 70.216 85.052 68.24 83.91",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.827 76.267 64.02 76.155 65.996 77.297 65.804 77.409 63.827 76.267",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.414 68.624 59.607 68.512 61.584 69.654 61.391 69.766 59.414 68.624",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.253 79.367 68.445 79.256 68.439 81.392 68.246 81.504 68.253 79.367",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.84 71.727 64.032 71.616 64.026 73.749 63.834 73.861 63.84 71.727",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.427 64.085 59.62 63.973 59.614 66.107 59.421 66.218 59.427 64.085",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.246 81.504 68.439 81.392 70.416 82.534 70.223 82.645 68.246 81.504",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.046 75.411 66.239 75.299 66.233 77.433 66.04 77.545 66.046 75.411",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.834 73.861 64.026 73.749 66.003 74.891 65.81 75.003 63.834 73.861",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.634 67.768 61.827 67.657 61.82 69.79 61.628 69.902 61.634 67.768",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.421 66.218 59.614 66.107 61.591 67.248 61.398 67.36 59.421 66.218",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.04 77.545 66.233 77.433 68.21 78.575 68.017 78.687 66.04 77.545",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.628 69.902 61.82 69.79 63.797 70.932 63.605 71.044 61.628 69.902",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.053 73.005 66.246 72.894 66.24 75.027 66.047 75.139 66.053 73.005",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.641 65.363 61.833 65.25 61.827 67.385 61.635 67.496 61.641 65.363",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.26 76.69 68.453 76.577 68.446 78.711 68.254 78.823 68.26 76.69",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.047 75.139 66.24 75.027 68.217 76.169 68.024 76.28 66.047 75.139",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.848 69.046 64.04 68.935 64.034 71.068 63.841 71.18 63.848 69.046",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.635 67.496 61.827 67.385 63.804 68.526 63.611 68.638 61.635 67.496",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.435 61.404 59.627 61.292 59.621 63.428 59.429 63.54 59.435 61.404",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.254 78.823 68.446 78.711 70.423 79.853 70.231 79.965 68.254 78.823",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.841 71.18 64.034 71.068 66.011 72.21 65.818 72.322 63.841 71.18",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.429 63.54 59.621 63.428 61.598 64.57 61.405 64.681 59.429 63.54",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.267 74.283 68.459 74.172 68.453 76.305 68.261 76.417 68.267 74.283",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.854 66.641 64.047 66.529 64.041 68.663 63.848 68.774 63.854 66.641",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.442 58.997 59.634 58.886 59.628 61.019 59.436 61.132 59.442 58.997",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.261 76.417 68.453 76.305 70.43 77.447 70.237 77.558 68.261 76.417",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.061 70.324 66.254 70.213 66.248 72.346 66.055 72.458 66.061 70.324",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.848 68.774 64.041 68.663 66.018 69.804 65.825 69.916 63.848 68.774",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.648 62.682 61.841 62.57 61.835 64.706 61.642 64.818 61.648 62.682",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.436 61.132 59.628 61.019 61.605 62.161 61.412 62.273 59.436 61.132",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.055 72.458 66.248 72.346 68.224 73.488 68.032 73.6 66.055 72.458",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.642 64.818 61.835 64.706 63.811 65.848 63.619 65.96 61.642 64.818",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.068 67.919 66.26 67.806 66.254 69.941 66.062 70.052 66.068 67.919",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.655 60.276 61.848 60.164 61.842 62.297 61.649 62.41 61.655 60.276",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.274 71.602 68.467 71.491 68.461 73.624 68.268 73.736 68.274 71.602",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.062 70.052 66.254 69.941 68.231 71.082 68.039 71.194 66.062 70.052",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.862 63.96 64.054 63.848 64.048 65.984 63.856 66.096 63.862 63.96",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.649 62.41 61.842 62.297 63.818 63.439 63.626 63.551 61.649 62.41",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.449 56.32 59.642 56.208 59.636 58.342 59.443 58.453 59.449 56.32",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.268 73.736 68.461 73.624 70.438 74.766 70.245 74.877 68.268 73.736",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.856 66.096 64.048 65.984 66.025 67.126 65.832 67.237 63.856 66.096",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.443 58.453 59.636 58.342 61.613 59.483 61.42 59.595 59.443 58.453",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.281 69.197 68.474 69.084 68.468 71.218 68.275 71.33 68.281 69.197",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.869 61.553 64.061 61.442 64.055 63.575 63.862 63.688 63.869 61.553",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.275 71.33 68.468 71.218 70.445 72.36 70.252 72.472 68.275 71.33",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.075 65.238 66.268 65.125 66.262 67.262 66.069 67.374 66.075 65.238",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.862 63.688 64.055 63.575 66.032 64.717 65.839 64.829 63.862 63.688",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.663 57.598 61.855 57.485 61.849 59.62 61.657 59.731 61.663 57.598",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.45 56.044 59.643 55.933 61.619 57.074 61.427 57.186 59.45 56.044",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.456 53.776 59.649 53.664 59.643 55.933 59.45 56.044 59.456 53.776",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.069 67.374 66.262 67.262 68.239 68.404 68.046 68.515 66.069 67.374",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.657 59.731 61.849 59.62 63.826 60.761 63.634 60.873 61.657 59.731",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.082 62.831 66.275 62.72 66.269 64.853 66.076 64.965 66.082 62.831",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.289 66.516 68.481 66.404 68.475 68.54 68.283 68.652 68.289 66.516",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.076 64.965 66.269 64.853 68.245 65.995 68.053 66.107 66.076 64.965",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.876 58.875 64.069 58.763 64.063 60.897 63.87 61.009 63.876 58.875",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.664 57.322 61.856 57.211 63.833 58.352 63.64 58.464 61.664 57.322",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.67 55.054 61.863 54.942 61.856 57.211 61.664 57.322 61.67 55.054",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.283 68.652 68.475 68.54 70.452 69.682 70.259 69.793 68.283 68.652",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.87 61.009 64.063 60.897 66.04 62.039 65.847 62.151 63.87 61.009",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.296 64.109 68.488 63.997 68.482 66.131 68.29 66.243 68.296 64.109",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.29 66.243 68.482 66.131 70.459 67.273 70.266 67.385 68.29 66.243",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.09 60.153 66.282 60.041 66.276 62.175 66.084 62.287 66.09 60.153",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.877 58.6 64.07 58.489 66.046 59.63 65.854 59.742 63.877 58.6",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.884 56.332 64.076 56.22 64.07 58.489 63.877 58.6 63.884 56.332",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.084 62.287 66.276 62.175 68.253 63.317 68.06 63.428 66.084 62.287",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.303 61.431 68.496 61.319 68.49 63.453 68.297 63.565 68.303 61.431",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.091 59.878 66.283 59.767 68.26 60.908 68.067 61.02 66.091 59.878",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.097 57.61 66.29 57.498 66.283 59.767 66.091 59.878 66.097 57.61",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.297 63.565 68.49 63.453 70.466 64.595 70.274 64.707 68.297 63.565",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.304 61.156 68.497 61.045 70.473 62.186 70.281 62.298 68.304 61.156",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.311 58.888 68.503 58.776 68.497 61.045 68.304 61.156 68.311 58.888",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "59.105 51.14 59.158 51.169 59.109 51.14 65.988 47.143 81.38 56.029 74.501 60.027 74.49 60.021 74.497 60.027 74.304 60.139 58.912 51.253 59.105 51.14",
    style: {
      fill: "#c8e6ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.912,51.253,58.8,91.241l15.393,8.886L74.3,60.139Zm2.435,33.908L59.371,84.02l.006-2.269,1.977,1.142Zm.008-2.543-1.977-1.142.006-2.133,1.977,1.141Zm.007-2.678L59.385,78.8l.007-2.134,1.976,1.142Zm.007-2.406-1.977-1.142.006-2.136L61.375,75.4Zm.008-2.681L59.4,73.711l.006-2.133,1.977,1.141Zm.007-2.406-1.977-1.142.006-2.134,1.976,1.142Zm.007-2.681-1.977-1.142.006-2.134L61.4,67.632ZM61.4,67.36l-1.977-1.142.006-2.133L61.4,65.226Zm.007-2.679L59.429,63.54l.006-2.136,1.976,1.141Zm.007-2.408-1.976-1.141L59.442,59l1.976,1.142ZM61.42,59.6l-1.977-1.142.006-2.133,1.977,1.141Zm.007-2.409L59.45,56.044l.006-2.268,1.977,1.141Zm2.134,29.253L61.584,85.3l.007-2.269,1.976,1.142Zm.007-2.543-1.976-1.142L61.6,80.62l1.977,1.142Zm.008-2.678L61.6,80.076l.006-2.134,1.977,1.142Zm.007-2.406L61.606,77.67l.006-2.137,1.977,1.142Zm.007-2.681-1.976-1.142.005-2.133L63.6,74Zm.007-2.406L61.62,72.583l.006-2.134L63.6,71.591Zm.008-2.681L61.628,69.9l.006-2.134,1.977,1.142Zm.006-2.406L61.635,67.5l.006-2.133L63.618,66.5Zm.008-2.678-1.977-1.142.006-2.136,1.977,1.141Zm.007-2.409L61.649,62.41l.006-2.134,1.977,1.141Zm.008-2.678-1.977-1.142.006-2.133,1.976,1.141Zm.006-2.409-1.976-1.142.006-2.268L63.647,56.2Zm2.134,29.253L63.8,86.576l.006-2.269,1.977,1.142Zm.008-2.543-1.977-1.142.006-2.134,1.977,1.142Zm.007-2.678-1.976-1.142.006-2.134L65.8,80.362ZM65.8,80.09l-1.977-1.142.006-2.137L65.8,77.953Zm.008-2.681-1.977-1.142.006-2.133,1.977,1.141ZM65.81,75l-1.976-1.142.006-2.134,1.976,1.142Zm.008-2.681L63.841,71.18l.007-2.134,1.976,1.142Zm.007-2.406-1.977-1.142.006-2.133,1.977,1.141Zm.007-2.679L63.856,66.1l.006-2.136L65.839,65.1Zm.007-2.408-1.977-1.141.007-2.135L65.845,62.7Zm.008-2.678L63.87,61.009l.006-2.134,1.977,1.142Zm.007-2.409L63.877,58.6l.007-2.268,1.976,1.141ZM67.988,89l-1.977-1.141.007-2.269,1.976,1.142ZM68,86.452,66.019,85.31l0-2.134L68,84.318ZM68,83.774l-1.977-1.142.006-2.133,1.977,1.141Zm.007-2.407-1.977-1.141.006-2.137,1.977,1.142Zm.007-2.68L66.04,77.545l.006-2.134,1.977,1.142Zm.007-2.407-1.977-1.141.006-2.134,1.977,1.142Zm.008-2.68-1.977-1.142.006-2.134,1.977,1.142Zm.006-2.406-1.976-1.142.006-2.133,1.976,1.141Zm.008-2.679-1.977-1.141.006-2.136,1.977,1.141Zm.007-2.408-1.977-1.142.006-2.134,1.977,1.142Zm.007-2.679-1.976-1.141.006-2.134L68.066,61.3Zm.007-2.408-1.976-1.142L66.1,57.61l1.977,1.141ZM70.2,90.273l-1.976-1.141.006-2.269,1.977,1.142Zm.008-2.544-1.977-1.141.006-2.134L70.215,85.6Zm.007-2.677L68.24,83.91l.006-2.133,1.976,1.141Zm.007-2.407L68.246,81.5l.007-2.137,1.976,1.142Zm.008-2.68-1.977-1.142.006-2.133,1.977,1.141Zm.006-2.407-1.976-1.141.006-2.134,1.977,1.142Zm.008-2.681-1.977-1.141.006-2.134,1.977,1.142Zm.007-2.405L68.275,71.33l.006-2.133,1.977,1.141Zm.007-2.679-1.976-1.141.006-2.136,1.977,1.141Zm.007-2.408L68.29,66.243l.006-2.134,1.976,1.142Zm.008-2.679L68.3,63.565l.006-2.134,1.977,1.142Zm.007-2.408L68.3,61.156l.007-2.268,1.976,1.141Z",
    style: {
      fill: "#97c6de"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.191 100.127 74.304 60.139 74.497 60.027 74.501 60.05 74.501 60.027 81.38 56.029 81.267 96.021 74.388 100.018 74.388 99.908 74.384 100.016 74.191 100.127",
    style: {
      fill: "#89bcd6"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "65.867 55.331 65.861 57.465 63.884 56.323 63.89 54.19 65.867 55.331",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "61.44 52.775 61.434 54.909 59.457 53.767 59.463 51.634 61.44 52.775",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.653 54.053 63.647 56.187 61.67 55.045 61.676 52.912 63.653 54.053",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70.294 57.887 70.288 60.021 68.311 58.879 68.317 56.746 70.294 57.887",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "58.82 83.877 74.212 92.763 74.191 100.127 58.798 91.241 58.82 83.877",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.08 56.609 68.074 58.743 66.097 57.601 66.104 55.468 68.08 56.609",
    style: {
      fill: "#2a6690"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "74.191 100.127 74.304 60.139 74.304 60.139 74.212 92.764 74.405 92.652 74.409 92.545 74.409 92.655 81.288 88.657 81.267 96.021 74.388 100.018 74.388 99.908 74.384 100.016 74.191 100.127",
    style: {
      fill: "#1f5779"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "70.785 55.417 76.289 52.219 76.283 54.287 70.78 57.485 70.785 55.417",
    style: {
      fill: "#89bcd6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "62.754 50.781 68.257 47.582 76.289 52.219 70.785 55.417 62.754 50.781",
    style: {
      fill: "#97c6de"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70.785 55.417 70.78 57.485 62.748 52.848 62.754 50.781 70.785 55.417",
    style: {
      fill: "#1f5779"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "68.422 47.737 68.42 48.373 64.079 50.896 64.081 50.26 68.422 47.737",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.97 51.518 74.969 52.154 68.42 48.373 68.422 47.737 74.97 51.518",
    style: {
      fill: "#89bcd6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70.79 54.808 70.788 55.444 62.754 50.806 62.756 50.169 70.79 54.808",
    style: {
      fill: "#89bcd6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.295 51.609 76.293 52.245 70.788 55.444 70.79 54.808 76.295 51.609",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.261,46.97l-5.5,3.2,8.034,4.639,5.5-3.2Zm2.368,7.071L64.081,50.26l4.341-2.523,6.548,3.781Z",
    style: {
      fill: "#f5f5f3"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "66.89 49.304 66.892 48.716 66.892 48.716 66.892 47.413 69.177 48.733 69.176 50.042 69.175 50.042 69.174 50.623 66.89 49.304",
    style: {
      fill: "#1f5779"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.174 50.623 69.175 50.035 69.176 50.034 69.177 48.733 70.742 47.823 70.742 49.133 70.741 49.134 70.739 49.714 69.174 50.623",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.838 50.254 69.839 48.984 70.438 48.635 70.437 49.906 69.838 50.254",
    style: {
      fill: "#113f54"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.458,46.5l-1.566.909,2.285,1.32,1.565-.91Z",
    style: {
      fill: "#f5f5f3"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "68.286 98.507 69.662 97.707 69.661 98.063 68.285 98.862 68.286 98.507",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "62.321 95.063 63.697 94.264 69.662 97.707 68.286 98.507 62.321 95.063",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.286 98.507 68.285 98.862 62.32 95.419 62.321 95.063 68.286 98.507",
    style: {
      fill: "#1f5779"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "68.836 92.732 68.823 97.243 64.037 94.48 64.05 89.968 68.836 92.732",
    style: {
      fill: "#1f3b66"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "63.975 91.315 64.168 91.204 64.158 94.54 63.965 94.652 63.975 91.315",
    style: {
      fill: "#bcc5d9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.978 90.167 64.171 90.055 64.168 90.931 63.976 91.043 63.978 90.167",
    style: {
      fill: "#bcc5d9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.149 91.993 65.342 91.881 65.332 95.218 65.139 95.33 65.149 91.993",
    style: {
      fill: "#bcc5d9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.976 91.043 64.168 90.931 65.105 91.473 64.913 91.585 63.976 91.043",
    style: {
      fill: "#dfe9fd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.152 90.845 65.345 90.733 65.342 91.609 65.15 91.721 65.152 90.845",
    style: {
      fill: "#bcc5d9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.488 92.766 66.68 92.654 66.67 96.051 66.478 96.163 66.488 92.766",
    style: {
      fill: "#bcc5d9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "67.826 93.539 68.019 93.427 68.009 96.764 67.817 96.876 67.826 93.539",
    style: {
      fill: "#bcc5d9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.15 91.721 65.342 91.609 67.783 93.018 67.59 93.13 65.15 91.721",
    style: {
      fill: "#dfe9fd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "67.829 92.39 68.022 92.278 68.02 93.155 67.827 93.267 67.829 92.39",
    style: {
      fill: "#bcc5d9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "67.827 93.267 68.02 93.155 68.954 93.695 68.762 93.806 67.827 93.267",
    style: {
      fill: "#dfe9fd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "63.789 89.857 63.982 89.745 69.149 92.728 68.957 92.84 63.789 89.857",
    style: {
      fill: "#bbc6d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.789,89.857l-.013,4.686.189.109.01-3.337.937.541L64.9,95.193l.236.137.01-3.337,1.1.636-.01,3.4.237.136.01-3.4,1.1.636-.009,3.337.237.137.009-3.337.935.54-.009,3.337.191.11.014-4.686Zm1.124,1.728-.937-.542,0-.876.938.541ZM67.59,93.13l-2.44-1.409,0-.876,2.44,1.409Zm1.172.676-.935-.539,0-.877.935.54Z",
    style: {
      fill: "#d0daee"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "68.957 92.84 69.149 92.728 69.136 97.415 68.943 97.526 68.957 92.84",
    style: {
      fill: "#bcc5d9"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "66.666 93.787 66.803 93.706 66.923 93.775 66.785 93.856 66.666 93.787",
    style: {
      fill: "#bbc6d9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.785 93.856 66.923 93.775 66.918 95.48 66.781 95.56 66.785 93.856",
    style: {
      fill: "#bcc5d9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.666 93.787 66.785 93.856 66.781 95.56 66.661 95.491 66.666 93.787",
    style: {
      fill: "#6f798a"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "65.888 93.337 66.025 93.258 66.145 93.327 66.008 93.407 65.888 93.337",
    style: {
      fill: "#bbc6d9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "66.008 93.407 66.145 93.327 66.14 95.031 66.003 95.111 66.008 93.407",
    style: {
      fill: "#bcc5d9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "65.883 95.042 65.888 93.337 66.008 93.407 66.003 95.111 65.883 95.042",
    style: {
      fill: "#6f798a"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "58.246 90.864 58.788 90.55 63.038 93.003 62.496 93.318 58.246 90.864",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.965,89.379l-.542.315c0,.862-.011,1.725-.018,2.584-.007.715-.014,1.435-.017,2.145,0,.154,0,.308,0,.463l.542-.315c0-.865.01-1.734.018-2.608.007-.7.013-1.4.017-2.109C63.963,89.7,63.964,89.537,63.965,89.379Z",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.413 97.312 69.955 96.997 74.205 99.322 74.151 99.975 69.413 97.312",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.428 92.05 69.97 91.736 69.955 96.997 69.413 97.312 69.428 92.05",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "62.511 88.057 63.052 87.742 69.97 91.736 69.428 92.05 62.511 88.057",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.428,92.05l-.015,5.262,4.738,2.581,0,1.052-5.634-3.1c.005-1.714-.009-3.476,0-5.216l-5.086-2.936c-.005,1.739-.032,3.477-.037,5.192l-5.143-2.97,0-1.052,4.25,2.454.015-5.261Z",
    style: {
      fill: "#1f5779"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "74.151 99.926 74.193 99.288 81.334 95.119 82.051 95.342 74.151 99.926",
    style: {
      fill: "#89bcd6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.051 95.342 74.15 99.902 74.153 100.97 82.051 96.413 82.051 95.342",
    style: {
      fill: "#89bcd6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "74.048 77.42 58.4 68.326 58.401 68.777 74.049 77.871 74.048 77.42",
    style: {
      fill: "#1f5779"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.469 77.177 58.821 68.083 58.4 68.326 74.048 77.42 74.469 77.177",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "74.048 77.42 74.049 77.871 74.471 77.628 74.469 77.177 74.048 77.42",
    style: {
      fill: "#ebe7dd"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "75.658 63.469 74.877 63.016 74.878 63.238 75.659 63.691 75.658 63.469",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.929 62.736 76.148 62.282 74.877 63.016 75.658 63.469 76.929 62.736",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.658 63.469 75.659 63.691 76.93 62.958 76.929 62.736 75.658 63.469",
    style: {
      fill: "#d8d4cb"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "75.094 60.86 75.1 63.027 76.205 62.389 76.199 60.222 75.094 60.86",
    style: {
      fill: "#1f3b66"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "76.332 62.389 76.072 62.238 74.966 62.876 75.227 63.027 76.332 62.389",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.326 60.222 76.066 60.071 76.072 62.238 76.332 62.389 76.326 60.222",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.138 60.807 74.877 60.656 74.884 63.024 75.145 63.175 75.138 60.807",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.408 60.074 76.148 59.923 74.877 60.656 75.138 60.807 76.408 60.074",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.138,60.807l.007,2.368,1.27-.734-.006-2.367Zm.083.053,1.1-.638.006,2.167-1.1.638Z",
    style: {
      fill: "#d8d4cb"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "77.914 62.185 77.134 61.731 77.134 61.953 77.915 62.407 77.914 62.185",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.185 61.451 78.404 60.998 77.134 61.731 77.914 62.185 79.185 61.451",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.914 62.185 77.915 62.407 79.186 61.673 79.185 61.451 77.914 62.185",
    style: {
      fill: "#d8d4cb"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "77.35 59.576 77.356 61.743 78.461 61.104 78.455 58.937 77.35 59.576",
    style: {
      fill: "#1f3b66"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "78.588 61.104 78.328 60.953 77.223 61.591 77.483 61.743 78.588 61.104",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.582 58.937 78.322 58.786 78.328 60.953 78.588 61.104 78.582 58.937",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.394 59.523 77.134 59.372 77.14 61.739 77.4 61.891 77.394 59.523",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.665 58.79 78.404 58.638 77.134 59.372 77.394 59.523 78.665 58.79",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.394,59.523l.006,2.368,1.271-.734-.006-2.367Zm.083.053,1.1-.639.006,2.167-1.1.639Z",
    style: {
      fill: "#d8d4cb"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "80.044 60.918 79.263 60.464 79.264 60.686 80.045 61.14 80.044 60.918",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.315 60.184 80.534 59.73 79.263 60.464 80.044 60.918 81.315 60.184",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.044 60.918 80.045 61.14 81.316 60.406 81.315 60.184 80.044 60.918",
    style: {
      fill: "#d8d4cb"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "79.479 58.308 79.486 60.476 80.591 59.837 80.585 57.67 79.479 58.308",
    style: {
      fill: "#1f3b66"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "80.718 59.837 80.458 59.686 79.352 60.324 79.613 60.476 80.718 59.837",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.712 57.67 80.452 57.519 80.458 59.686 80.718 59.837 80.712 57.67",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.524 58.256 79.263 58.105 79.27 60.472 79.53 60.623 79.524 58.256",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.795 57.522 80.534 57.371 79.263 58.105 79.524 58.256 80.795 57.522",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.524,58.256l.006,2.367L80.8,59.89,80.8,57.522Zm.083.052,1.105-.638.006,2.167-1.105.639Z",
    style: {
      fill: "#d8d4cb"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "75.658 67.585 74.877 67.131 74.878 67.354 75.659 67.807 75.658 67.585",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.929 66.852 76.148 66.398 74.877 67.131 75.658 67.585 76.929 66.852",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.658 67.585 75.659 67.807 76.93 67.074 76.929 66.852 75.658 67.585",
    style: {
      fill: "#d8d4cb"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "75.094 64.976 75.1 67.143 76.205 66.505 76.199 64.338 75.094 64.976",
    style: {
      fill: "#1f3b66"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "76.332 66.505 76.072 66.353 74.966 66.992 75.227 67.143 76.332 66.505",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.326 64.338 76.066 64.186 76.072 66.353 76.332 66.505 76.326 64.338",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.138 64.923 74.877 64.772 74.884 67.14 75.145 67.291 75.138 64.923",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.408 64.19 76.148 64.038 74.877 64.772 75.138 64.923 76.408 64.19",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.138,64.923l.007,2.368,1.27-.734-.006-2.367Zm.083.053,1.1-.638.006,2.167-1.1.638Z",
    style: {
      fill: "#d8d4cb"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "77.914 66.301 77.134 65.847 77.134 66.069 77.915 66.523 77.914 66.301",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.185 65.567 78.404 65.114 77.134 65.847 77.914 66.301 79.185 65.567",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.914 66.301 77.915 66.523 79.186 65.789 79.185 65.567 77.914 66.301",
    style: {
      fill: "#d8d4cb"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "77.35 63.692 77.356 65.859 78.461 65.22 78.455 63.053 77.35 63.692",
    style: {
      fill: "#1f3b66"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "78.588 65.22 78.328 65.069 77.223 65.707 77.483 65.859 78.588 65.22",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.582 63.053 78.322 62.902 78.328 65.069 78.588 65.22 78.582 63.053",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.394 63.639 77.134 63.488 77.14 65.855 77.4 66.006 77.394 63.639",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.665 62.906 78.404 62.754 77.134 63.488 77.394 63.639 78.665 62.906",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.394,63.639l.006,2.367,1.271-.733-.006-2.367Zm.083.053,1.1-.639.006,2.167-1.1.639Z",
    style: {
      fill: "#d8d4cb"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "80.044 65.033 79.263 64.58 79.264 64.802 80.045 65.256 80.044 65.033",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.315 64.3 80.534 63.846 79.263 64.58 80.044 65.033 81.315 64.3",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.044 65.033 80.045 65.256 81.316 64.522 81.315 64.3 80.044 65.033",
    style: {
      fill: "#d8d4cb"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "79.479 62.424 79.486 64.591 80.591 63.953 80.585 61.786 79.479 62.424",
    style: {
      fill: "#1f3b66"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "80.718 63.953 80.458 63.802 79.352 64.44 79.613 64.591 80.718 63.953",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.712 61.786 80.452 61.635 80.458 63.802 80.718 63.953 80.712 61.786",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.524 62.372 79.263 62.22 79.27 64.588 79.53 64.739 79.524 62.372",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.795 61.638 80.534 61.487 79.263 62.22 79.524 62.372 80.795 61.638",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.524,62.372l.006,2.367,1.271-.734L80.8,61.638Zm.083.052,1.105-.638.006,2.167-1.105.638Z",
    style: {
      fill: "#d8d4cb"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "75.658 71.735 74.877 71.281 74.878 71.503 75.659 71.957 75.658 71.735",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.929 71.001 76.148 70.547 74.877 71.281 75.658 71.735 76.929 71.001",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.658 71.735 75.659 71.957 76.93 71.223 76.929 71.001 75.658 71.735",
    style: {
      fill: "#d8d4cb"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "75.094 69.125 75.1 71.292 76.205 70.654 76.199 68.487 75.094 69.125",
    style: {
      fill: "#1f3b66"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "76.332 70.654 76.072 70.503 74.966 71.141 75.227 71.292 76.332 70.654",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.326 68.487 76.066 68.336 76.072 70.503 76.332 70.654 76.326 68.487",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.138 69.073 74.877 68.921 74.884 71.289 75.145 71.44 75.138 69.073",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.408 68.339 76.148 68.188 74.877 68.921 75.138 69.073 76.408 68.339",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.138,69.073l.007,2.367,1.27-.733-.006-2.368Zm.083.052,1.1-.638.006,2.167-1.1.638Z",
    style: {
      fill: "#d8d4cb"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "77.914 70.45 77.134 69.997 77.134 70.218 77.915 70.672 77.914 70.45",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.185 69.717 78.404 69.263 77.134 69.997 77.914 70.45 79.185 69.717",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.914 70.45 77.915 70.672 79.186 69.939 79.185 69.717 77.914 70.45",
    style: {
      fill: "#d8d4cb"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "77.35 67.841 77.356 70.008 78.461 69.369 78.455 67.202 77.35 67.841",
    style: {
      fill: "#1f3b66"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "78.588 69.369 78.328 69.218 77.223 69.857 77.483 70.008 78.588 69.369",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.582 67.202 78.322 67.051 78.328 69.218 78.588 69.369 78.582 67.202",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.394 67.788 77.134 67.637 77.14 70.005 77.4 70.156 77.394 67.788",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.665 67.055 78.404 66.903 77.134 67.637 77.394 67.788 78.665 67.055",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.394,67.788l.006,2.368,1.271-.734-.006-2.367Zm.083.053,1.1-.639.006,2.167-1.1.639Z",
    style: {
      fill: "#d8d4cb"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "80.044 69.183 79.263 68.729 79.264 68.951 80.045 69.405 80.044 69.183",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.315 68.449 80.534 67.995 79.263 68.729 80.044 69.183 81.315 68.449",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.044 69.183 80.045 69.405 81.316 68.671 81.315 68.449 80.044 69.183",
    style: {
      fill: "#d8d4cb"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "79.479 66.574 79.486 68.741 80.591 68.102 80.585 65.935 79.479 66.574",
    style: {
      fill: "#1f3b66"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "80.718 68.102 80.458 67.951 79.352 68.589 79.613 68.741 80.718 68.102",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.712 65.935 80.452 65.784 80.458 67.951 80.718 68.102 80.712 65.935",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.524 66.521 79.263 66.37 79.27 68.737 79.53 68.888 79.524 66.521",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.795 65.787 80.534 65.636 79.263 66.37 79.524 66.521 80.795 65.787",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.524,66.521l.006,2.367,1.271-.733L80.8,65.787Zm.083.053,1.105-.639.006,2.167-1.105.639Z",
    style: {
      fill: "#d8d4cb"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "75.658 75.85 74.877 75.397 74.878 75.619 75.659 76.072 75.658 75.85",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.929 75.117 76.148 74.663 74.877 75.397 75.658 75.85 76.929 75.117",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.658 75.85 75.659 76.072 76.93 75.339 76.929 75.117 75.658 75.85",
    style: {
      fill: "#d8d4cb"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "75.094 73.241 75.1 75.408 76.205 74.77 76.199 72.603 75.094 73.241",
    style: {
      fill: "#1f3b66"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "76.332 74.77 76.072 74.619 74.966 75.257 75.227 75.408 76.332 74.77",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.326 72.603 76.066 72.452 76.072 74.619 76.332 74.77 76.326 72.603",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.138 73.188 74.877 73.037 74.884 75.405 75.145 75.556 75.138 73.188",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.408 72.455 76.148 72.304 74.877 73.037 75.138 73.188 76.408 72.455",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.138,73.188l.007,2.368,1.27-.734-.006-2.367Zm.083.053,1.1-.638.006,2.167-1.1.638Z",
    style: {
      fill: "#d8d4cb"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "77.914 74.566 77.134 74.112 77.134 74.334 77.915 74.788 77.914 74.566",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.185 73.832 78.404 73.379 77.134 74.112 77.914 74.566 79.185 73.832",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.914 74.566 77.915 74.788 79.186 74.054 79.185 73.832 77.914 74.566",
    style: {
      fill: "#d8d4cb"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "77.35 71.957 77.356 74.124 78.461 73.485 78.455 71.318 77.35 71.957",
    style: {
      fill: "#1f3b66"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "78.588 73.485 78.328 73.334 77.223 73.973 77.483 74.124 78.588 73.485",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.582 71.318 78.322 71.167 78.328 73.334 78.588 73.485 78.582 71.318",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.394 71.904 77.134 71.753 77.14 74.12 77.4 74.272 77.394 71.904",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.665 71.171 78.404 71.019 77.134 71.753 77.394 71.904 78.665 71.171",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.394,71.9l.006,2.368,1.271-.734-.006-2.367Zm.083.053,1.1-.639.006,2.167-1.1.639Z",
    style: {
      fill: "#d8d4cb"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "80.044 73.299 79.263 72.845 79.264 73.067 80.045 73.521 80.044 73.299",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.315 72.565 80.534 72.111 79.263 72.845 80.044 73.299 81.315 72.565",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.044 73.299 80.045 73.521 81.316 72.787 81.315 72.565 80.044 73.299",
    style: {
      fill: "#d8d4cb"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "79.479 70.689 79.486 72.857 80.591 72.218 80.585 70.051 79.479 70.689",
    style: {
      fill: "#1f3b66"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "80.718 72.218 80.458 72.067 79.352 72.705 79.613 72.857 80.718 72.218",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.712 70.051 80.452 69.9 80.458 72.067 80.718 72.218 80.712 70.051",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.524 70.637 79.263 70.486 79.27 72.853 79.53 73.004 79.524 70.637",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.795 69.903 80.534 69.752 79.263 70.486 79.524 70.637 80.795 69.903",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.524,70.637,79.53,73l1.271-.733L80.8,69.9Zm.083.052,1.105-.638.006,2.167-1.105.639Z",
    style: {
      fill: "#d8d4cb"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "75.658 79.931 74.877 79.477 74.878 79.699 75.659 80.153 75.658 79.931",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.929 79.197 76.148 78.743 74.877 79.477 75.658 79.931 76.929 79.197",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.658 79.931 75.659 80.153 76.93 79.419 76.929 79.197 75.658 79.931",
    style: {
      fill: "#d8d4cb"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "75.094 77.321 75.1 79.488 76.205 78.85 76.199 76.683 75.094 77.321",
    style: {
      fill: "#1f3b66"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "76.332 78.85 76.072 78.699 74.966 79.337 75.227 79.488 76.332 78.85",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.326 76.683 76.066 76.532 76.072 78.699 76.332 78.85 76.326 76.683",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.138 77.269 74.877 77.118 74.884 79.485 75.145 79.636 75.138 77.269",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.408 76.535 76.148 76.384 74.877 77.118 75.138 77.269 76.408 76.535",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.138,77.269l.007,2.367,1.27-.733-.006-2.368Zm.083.052,1.1-.638.006,2.167-1.1.638Z",
    style: {
      fill: "#d8d4cb"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "77.914 78.646 77.134 78.193 77.134 78.415 77.915 78.868 77.914 78.646",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.185 77.913 78.404 77.459 77.134 78.193 77.914 78.646 79.185 77.913",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.914 78.646 77.915 78.868 79.186 78.135 79.185 77.913 77.914 78.646",
    style: {
      fill: "#d8d4cb"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "77.35 76.037 77.356 78.204 78.461 77.566 78.455 75.399 77.35 76.037",
    style: {
      fill: "#1f3b66"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "78.588 77.566 78.328 77.414 77.223 78.053 77.483 78.204 78.588 77.566",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.582 75.399 78.322 75.247 78.328 77.414 78.588 77.566 78.582 75.399",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.394 75.985 77.134 75.833 77.14 78.201 77.4 78.352 77.394 75.985",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.665 75.251 78.404 75.1 77.134 75.833 77.394 75.985 78.665 75.251",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.394,75.985l.006,2.367,1.271-.734-.006-2.367Zm.083.052,1.1-.638.006,2.167-1.1.638Z",
    style: {
      fill: "#d8d4cb"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "80.044 77.379 79.263 76.925 79.264 77.147 80.045 77.601 80.044 77.379",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.315 76.645 80.534 76.192 79.263 76.925 80.044 77.379 81.315 76.645",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.044 77.379 80.045 77.601 81.316 76.868 81.315 76.645 80.044 77.379",
    style: {
      fill: "#d8d4cb"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "79.479 74.77 79.486 76.937 80.591 76.299 80.585 74.131 79.479 74.77",
    style: {
      fill: "#1f3b66"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "80.718 76.299 80.458 76.147 79.352 76.786 79.613 76.937 80.718 76.299",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.712 74.131 80.452 73.98 80.458 76.147 80.718 76.299 80.712 74.131",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.524 74.717 79.263 74.566 79.27 76.933 79.53 77.085 79.524 74.717",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.795 73.984 80.534 73.832 79.263 74.566 79.524 74.717 80.795 73.984",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.524,74.717l.006,2.368,1.271-.734L80.8,73.984Zm.083.053,1.105-.639.006,2.168-1.105.638Z",
    style: {
      fill: "#d8d4cb"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "75.658 84.047 74.877 83.593 74.878 83.815 75.659 84.269 75.658 84.047",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.929 83.313 76.148 82.859 74.877 83.593 75.658 84.047 76.929 83.313",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.658 84.047 75.659 84.269 76.93 83.535 76.929 83.313 75.658 84.047",
    style: {
      fill: "#d8d4cb"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "75.094 81.437 75.1 83.604 76.205 82.966 76.199 80.799 75.094 81.437",
    style: {
      fill: "#1f3b66"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "76.332 82.966 76.072 82.815 74.966 83.453 75.227 83.604 76.332 82.966",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.326 80.799 76.066 80.648 76.072 82.815 76.332 82.966 76.326 80.799",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.138 81.385 74.877 81.233 74.884 83.601 75.145 83.752 75.138 81.385",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.408 80.651 76.148 80.5 74.877 81.233 75.138 81.385 76.408 80.651",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.138,81.385l.007,2.367,1.27-.733-.006-2.368Zm.083.052,1.1-.638.006,2.167-1.1.638Z",
    style: {
      fill: "#d8d4cb"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "77.914 82.762 77.134 82.309 77.134 82.531 77.915 82.984 77.914 82.762",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.185 82.029 78.404 81.575 77.134 82.309 77.914 82.762 79.185 82.029",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.914 82.762 77.915 82.984 79.186 82.251 79.185 82.029 77.914 82.762",
    style: {
      fill: "#d8d4cb"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "77.35 80.153 77.356 82.32 78.461 81.682 78.455 79.514 77.35 80.153",
    style: {
      fill: "#1f3b66"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "78.588 81.682 78.328 81.531 77.223 82.169 77.483 82.32 78.588 81.682",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.582 79.514 78.322 79.363 78.328 81.531 78.588 81.682 78.582 79.514",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.394 80.1 77.134 79.949 77.14 82.317 77.4 82.468 77.394 80.1",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.665 79.367 78.404 79.216 77.134 79.949 77.394 80.1 78.665 79.367",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.394,80.1l.006,2.368,1.271-.734-.006-2.367Zm.083.053,1.1-.639.006,2.168-1.1.638Z",
    style: {
      fill: "#d8d4cb"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "80.044 81.495 79.263 81.041 79.264 81.263 80.045 81.717 80.044 81.495",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.315 80.761 80.534 80.307 79.263 81.041 80.044 81.495 81.315 80.761",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.044 81.495 80.045 81.717 81.316 80.983 81.315 80.761 80.044 81.495",
    style: {
      fill: "#d8d4cb"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "79.479 78.886 79.486 81.052 80.591 80.414 80.585 78.247 79.479 78.886",
    style: {
      fill: "#1f3b66"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "80.718 80.414 80.458 80.263 79.352 80.901 79.613 81.052 80.718 80.414",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.712 78.247 80.452 78.096 80.458 80.263 80.718 80.414 80.712 78.247",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.524 78.833 79.263 78.682 79.27 81.049 79.53 81.2 79.524 78.833",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.795 78.099 80.534 77.948 79.263 78.682 79.524 78.833 80.795 78.099",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.524,78.833,79.53,81.2l1.271-.733L80.8,78.1Zm.083.053,1.105-.639.006,2.167-1.105.638Z",
    style: {
      fill: "#d8d4cb"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "75.658 88.196 74.877 87.742 74.878 87.964 75.659 88.418 75.658 88.196",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.929 87.462 76.148 87.009 74.877 87.742 75.658 88.196 76.929 87.462",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.658 88.196 75.659 88.418 76.93 87.684 76.929 87.462 75.658 88.196",
    style: {
      fill: "#d8d4cb"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "75.094 85.587 75.1 87.754 76.205 87.115 76.199 84.948 75.094 85.587",
    style: {
      fill: "#1f3b66"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "76.332 87.115 76.072 86.964 74.966 87.603 75.227 87.754 76.332 87.115",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.326 84.948 76.066 84.797 76.072 86.964 76.332 87.115 76.326 84.948",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.138 85.534 74.877 85.383 74.884 87.75 75.145 87.901 75.138 85.534",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.408 84.8 76.148 84.649 74.877 85.383 75.138 85.534 76.408 84.8",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.138,85.534l.007,2.367,1.27-.733L76.409,84.8Zm.083.053,1.1-.639.006,2.167-1.1.639Z",
    style: {
      fill: "#d8d4cb"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "77.914 86.911 77.134 86.458 77.134 86.68 77.915 87.133 77.914 86.911",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.185 86.178 78.404 85.724 77.134 86.458 77.914 86.911 79.185 86.178",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.914 86.911 77.915 87.133 79.186 86.4 79.185 86.178 77.914 86.911",
    style: {
      fill: "#d8d4cb"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "77.35 84.302 77.356 86.469 78.461 85.831 78.455 83.664 77.35 84.302",
    style: {
      fill: "#1f3b66"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "78.588 85.831 78.328 85.68 77.223 86.318 77.483 86.469 78.588 85.831",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.582 83.664 78.322 83.513 78.328 85.68 78.588 85.831 78.582 83.664",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.394 84.25 77.134 84.098 77.14 86.466 77.4 86.617 77.394 84.25",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.665 83.516 78.404 83.365 77.134 84.098 77.394 84.25 78.665 83.516",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.394,84.25l.006,2.367,1.271-.734-.006-2.367Zm.083.052,1.1-.638.006,2.167-1.1.638Z",
    style: {
      fill: "#d8d4cb"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "80.044 85.644 79.263 85.191 79.264 85.413 80.045 85.866 80.044 85.644",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.315 84.911 80.534 84.457 79.263 85.191 80.044 85.644 81.315 84.911",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.044 85.644 80.045 85.866 81.316 85.133 81.315 84.911 80.044 85.644",
    style: {
      fill: "#d8d4cb"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "79.479 83.035 79.486 85.202 80.591 84.564 80.585 82.397 79.479 83.035",
    style: {
      fill: "#1f3b66"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "80.718 84.564 80.458 84.412 79.352 85.051 79.613 85.202 80.718 84.564",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.712 82.397 80.452 82.245 80.458 84.412 80.718 84.564 80.712 82.397",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.524 82.983 79.263 82.831 79.27 85.199 79.53 85.35 79.524 82.983",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.795 82.249 80.534 82.098 79.263 82.831 79.524 82.983 80.795 82.249",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.524,82.983l.006,2.367,1.271-.734L80.8,82.249Zm.083.052,1.105-.638.006,2.167-1.105.638Z",
    style: {
      fill: "#d8d4cb"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "75.658 92.312 74.877 91.858 74.878 92.08 75.659 92.534 75.658 92.312",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.929 91.578 76.148 91.124 74.877 91.858 75.658 92.312 76.929 91.578",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.658 92.312 75.659 92.534 76.93 91.8 76.929 91.578 75.658 92.312",
    style: {
      fill: "#d8d4cb"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "75.094 89.703 75.1 91.87 76.205 91.231 76.199 89.064 75.094 89.703",
    style: {
      fill: "#1f3b66"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "76.332 91.231 76.072 91.08 74.966 91.718 75.227 91.87 76.332 91.231",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.326 89.064 76.066 88.913 76.072 91.08 76.332 91.231 76.326 89.064",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.138 89.65 74.877 89.499 74.884 91.866 75.145 92.017 75.138 89.65",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.408 88.916 76.148 88.765 74.877 89.499 75.138 89.65 76.408 88.916",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.138,89.65l.007,2.367,1.27-.733-.006-2.368Zm.083.053,1.1-.639.006,2.167-1.1.639Z",
    style: {
      fill: "#d8d4cb"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "77.914 91.027 77.134 90.573 77.134 90.796 77.915 91.249 77.914 91.027",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.185 90.294 78.404 89.84 77.134 90.573 77.914 91.027 79.185 90.294",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.914 91.027 77.915 91.249 79.186 90.516 79.185 90.294 77.914 91.027",
    style: {
      fill: "#d8d4cb"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "77.35 88.418 77.356 90.585 78.461 89.947 78.455 87.78 77.35 88.418",
    style: {
      fill: "#1f3b66"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "78.588 89.947 78.328 89.795 77.223 90.434 77.483 90.585 78.588 89.947",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.582 87.78 78.322 87.628 78.328 89.795 78.588 89.947 78.582 87.78",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.394 88.365 77.134 88.214 77.14 90.582 77.4 90.733 77.394 88.365",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.665 87.632 78.404 87.481 77.134 88.214 77.394 88.365 78.665 87.632",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.394,88.365l.006,2.368L78.671,90l-.006-2.367Zm.083.053,1.1-.638.006,2.167-1.1.638Z",
    style: {
      fill: "#d8d4cb"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "80.044 89.76 79.263 89.306 79.264 89.528 80.045 89.982 80.044 89.76",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.315 89.027 80.534 88.573 79.263 89.306 80.044 89.76 81.315 89.027",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.044 89.76 80.045 89.982 81.316 89.249 81.315 89.027 80.044 89.76",
    style: {
      fill: "#d8d4cb"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "79.479 87.151 79.486 89.318 80.591 88.679 80.585 86.512 79.479 87.151",
    style: {
      fill: "#1f3b66"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "80.718 88.679 80.458 88.528 79.352 89.167 79.613 89.318 80.718 88.679",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.712 86.512 80.452 86.361 80.458 88.528 80.718 88.679 80.712 86.512",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.524 87.098 79.263 86.947 79.27 89.314 79.53 89.466 79.524 87.098",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.795 86.365 80.534 86.214 79.263 86.947 79.524 87.098 80.795 86.365",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.524,87.1l.006,2.368,1.271-.734L80.8,86.365Zm.083.053,1.105-.639.006,2.167-1.105.639Z",
    style: {
      fill: "#d8d4cb"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "75.721 96.44 74.94 95.986 74.941 96.208 75.722 96.662 75.721 96.44",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.992 95.706 76.211 95.253 74.94 95.986 75.721 96.44 76.992 95.706",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.721 96.44 75.722 96.662 76.992 95.928 76.992 95.706 75.721 96.44",
    style: {
      fill: "#d8d4cb"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "75.156 93.831 75.162 95.998 76.268 95.359 76.262 93.192 75.156 93.831",
    style: {
      fill: "#1f3b66"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "76.395 95.359 76.135 95.208 75.029 95.847 75.29 95.998 76.395 95.359",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.389 93.192 76.129 93.041 76.135 95.208 76.395 95.359 76.389 93.192",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "75.201 93.778 74.94 93.627 74.947 95.994 75.207 96.146 75.201 93.778",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.471 93.045 76.211 92.894 74.94 93.627 75.201 93.778 76.471 93.045",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.2,93.778l.006,2.368,1.271-.734-.007-2.367Zm.082.053,1.106-.639.006,2.167L75.29,96Z",
    style: {
      fill: "#d8d4cb"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "77.977 95.156 77.196 94.702 77.197 94.924 77.978 95.377 77.977 95.156",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.248 94.422 78.467 93.968 77.196 94.702 77.977 95.156 79.248 94.422",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.977 95.156 77.978 95.377 79.249 94.644 79.248 94.422 77.977 95.156",
    style: {
      fill: "#d8d4cb"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "77.412 92.547 77.419 94.714 78.524 94.075 78.518 91.908 77.412 92.547",
    style: {
      fill: "#1f3b66"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "78.651 94.075 78.391 93.924 77.285 94.562 77.546 94.714 78.651 94.075",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.645 91.908 78.385 91.757 78.391 93.924 78.651 94.075 78.645 91.908",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.457 92.494 77.196 92.343 77.203 94.71 77.463 94.861 77.457 92.494",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "78.727 91.76 78.467 91.609 77.196 92.343 77.457 92.494 78.727 91.76",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.457,92.494l.006,2.367,1.271-.733-.007-2.368Zm.082.053,1.106-.639.006,2.167-1.1.639Z",
    style: {
      fill: "#d8d4cb"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "80.107 93.889 79.326 93.435 79.327 93.657 80.108 94.111 80.107 93.889",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.378 93.155 80.597 92.701 79.326 93.435 80.107 93.889 81.378 93.155",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.107 93.889 80.108 94.111 81.378 93.377 81.378 93.155 80.107 93.889",
    style: {
      fill: "#d8d4cb"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "79.542 91.279 79.548 93.446 80.654 92.808 80.648 90.641 79.542 91.279",
    style: {
      fill: "#1f3b66"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "80.781 92.808 80.521 92.657 79.415 93.295 79.676 93.446 80.781 92.808",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.775 90.641 80.515 90.49 80.521 92.657 80.781 92.808 80.775 90.641",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.587 91.227 79.326 91.075 79.333 93.443 79.593 93.594 79.587 91.227",
    style: {
      fill: "#8e806a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "80.857 90.493 80.597 90.342 79.326 91.075 79.587 91.227 80.857 90.493",
    style: {
      fill: "#f5f5f3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.587,91.227l.006,2.367,1.271-.733-.007-2.368Zm.082.052,1.106-.638.006,2.167-1.105.638Z",
    style: {
      fill: "#d8d4cb"
    }
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "109.838 74.381 110.445 74.028 110.443 74.658 109.836 75.011 109.838 74.381",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.832 70.334 103.439 69.982 110.445 74.028 109.838 74.381 102.832 70.334",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.838 74.381 109.836 75.011 102.83 70.964 102.832 70.334 109.838 74.381",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.837 73.537 109.469 74.028 95.738 82.113 95.239 81.334 108.837 73.537",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.198 63.562 83.054 56.504 83.1 74.732 95.244 81.789 95.198 63.562",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.089 55.542 96.945 48.485 83.054 56.504 95.198 63.562 109.089 55.542",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.198 63.562 95.244 81.789 109.135 73.769 109.089 55.542 95.198 63.562",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.639 64.428 95.569 77.71 109.127 69.547 109.092 56.566 95.639 64.428",
    style: {
      fill: "#97c6de"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.58 78.027 95.59 81.596 109.181 73.751 109.171 70.182 95.58 78.027",
    style: {
      fill: "#97c6de"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.242 72.326 108.976 72.171 108.98 73.861 109.247 74.015 109.242 72.326",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.242 72.019 108.975 71.863 108.976 72.171 109.242 72.326 109.242 72.019",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.126 72.662 107.859 72.507 107.86 72.815 108.127 72.97 108.126 72.662",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.242 72.019 108.975 71.863 107.859 72.507 108.126 72.662 109.242 72.019",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.242 72.326 109.242 72.019 108.126 72.662 108.127 72.97 109.242 72.326",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.237 70.363 108.97 70.208 108.975 71.863 109.242 72.019 109.237 70.363",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.371 70.286 109.104 70.131 108.97 70.208 109.237 70.363 109.371 70.286",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.237 70.363 109.242 72.019 109.242 72.326 109.247 74.015 109.381 73.938 109.371 70.286 109.237 70.363",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.993 73.047 107.727 72.892 107.731 74.582 107.998 74.737 107.993 73.047",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.992 72.74 107.726 72.584 107.727 72.892 107.993 73.047 107.992 72.74",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.877 73.384 106.61 73.228 106.611 73.536 106.878 73.691 106.877 73.384",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.988 71.084 107.992 72.74 107.993 73.047 107.998 74.737 108.132 74.659 108.127 72.97 108.126 72.662 108.122 71.007 107.988 71.084",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.992 72.74 107.726 72.584 106.61 73.228 106.877 73.384 107.992 72.74",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.993 73.047 107.992 72.74 106.877 73.384 106.878 73.691 107.993 73.047",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.988 71.084 107.721 70.929 107.726 72.584 107.992 72.74 107.988 71.084",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.122 71.007 107.855 70.852 107.721 70.929 107.988 71.084 108.122 71.007",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.744 73.768 106.477 73.613 106.482 75.303 106.749 75.458 106.744 73.768",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.743 73.461 106.477 73.305 106.477 73.613 106.744 73.768 106.743 73.461",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.628 74.105 105.361 73.949 105.362 74.257 105.629 74.412 105.628 74.105",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.743 73.461 106.477 73.305 105.361 73.949 105.628 74.105 106.743 73.461",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.744 73.768 106.743 73.461 105.628 74.105 105.629 74.412 106.744 73.768",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.738 71.805 106.472 71.65 106.477 73.305 106.743 73.461 106.738 71.805",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.872 71.728 106.606 71.573 106.472 71.65 106.738 71.805 106.872 71.728",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.738 71.805 106.743 73.461 106.744 73.768 106.749 75.458 106.883 75.38 106.878 73.691 106.877 73.384 106.872 71.728 106.738 71.805",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.495 74.489 105.228 74.335 105.233 76.024 105.5 76.179 105.495 74.489",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.494 74.182 105.228 74.027 105.228 74.335 105.495 74.489 105.494 74.182",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.379 74.826 104.112 74.671 104.113 74.978 104.38 75.133 104.379 74.826",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.489 72.527 105.223 72.372 105.228 74.027 105.494 74.182 105.489 72.527",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.489 72.527 105.494 74.182 105.495 74.489 105.5 76.179 105.634 76.102 105.629 74.412 105.628 74.105 105.623 72.449 105.489 72.527",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.494 74.182 105.228 74.027 104.112 74.671 104.379 74.826 105.494 74.182",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.495 74.489 105.494 74.182 104.379 74.826 104.38 75.133 105.495 74.489",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.623 72.449 105.356 72.294 105.223 72.372 105.489 72.527 105.623 72.449",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.246 75.211 103.979 75.056 103.984 76.745 104.251 76.9 104.246 75.211",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.245 74.903 103.978 74.748 103.979 75.056 104.246 75.211 104.245 74.903",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.13 75.547 102.863 75.392 102.864 75.7 103.131 75.854 103.13 75.547",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.245 74.903 103.978 74.748 102.863 75.392 103.13 75.547 104.245 74.903",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.246 75.211 104.245 74.903 103.13 75.547 103.131 75.854 104.246 75.211",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.24 73.248 103.974 73.093 103.978 74.748 104.245 74.903 104.24 73.248",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.374 73.171 104.108 73.015 103.974 73.093 104.24 73.248 104.374 73.171",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.24 73.248 104.245 74.903 104.246 75.211 104.251 76.9 104.385 76.823 104.38 75.133 104.379 74.826 104.374 73.171 104.24 73.248",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.997 75.932 102.73 75.777 102.735 77.466 103.002 77.621 102.997 75.932",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.996 75.624 102.729 75.469 102.73 75.777 102.997 75.932 102.996 75.624",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.881 76.268 101.614 76.113 101.615 76.421 101.882 76.576 101.881 76.268",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.991 73.969 102.996 75.624 102.997 75.932 103.002 77.621 103.136 77.544 103.131 75.854 103.13 75.547 103.125 73.892 102.991 73.969",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.996 75.624 102.729 75.469 101.614 76.113 101.881 76.268 102.996 75.624",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.997 75.932 102.996 75.624 101.881 76.268 101.882 76.576 102.997 75.932",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.991 73.969 102.724 73.814 102.729 75.469 102.996 75.624 102.991 73.969",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.125 73.892 102.858 73.737 102.724 73.814 102.991 73.969 103.125 73.892",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.748 76.653 101.481 76.498 101.486 78.187 101.752 78.343 101.748 76.653",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.747 76.345 101.48 76.19 101.481 76.498 101.748 76.653 101.747 76.345",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.631 76.989 100.365 76.834 100.366 77.142 100.632 77.297 100.631 76.989",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.747 76.345 101.48 76.19 100.365 76.834 100.631 76.989 101.747 76.345",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.748 76.653 101.747 76.345 100.631 76.989 100.632 77.297 101.748 76.653",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.742 74.69 101.475 74.535 101.48 76.19 101.747 76.345 101.742 74.69",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.876 74.613 101.609 74.458 101.475 74.535 101.742 74.69 101.876 74.613",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.742 74.69 101.747 76.345 101.748 76.653 101.752 78.343 101.886 78.265 101.882 76.576 101.881 76.268 101.876 74.613 101.742 74.69",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.499 77.374 100.232 77.219 100.237 78.908 100.503 79.064 100.499 77.374",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.498 77.067 100.231 76.912 100.232 77.219 100.499 77.374 100.498 77.067",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.382 77.71 99.116 77.555 99.117 77.863 99.383 78.018 99.382 77.71",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.493 75.411 100.226 75.256 100.231 76.912 100.498 77.067 100.493 75.411",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.493 75.411 100.498 77.067 100.499 77.374 100.503 79.064 100.637 78.987 100.632 77.297 100.631 76.989 100.627 75.334 100.493 75.411",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.498 77.067 100.231 76.912 99.116 77.555 99.382 77.71 100.498 77.067",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.499 77.374 100.498 77.067 99.382 77.71 99.383 78.018 100.499 77.374",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.627 75.334 100.36 75.179 100.226 75.256 100.493 75.411 100.627 75.334",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.25 78.095 98.983 77.94 98.988 79.63 99.254 79.785 99.25 78.095",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.249 77.788 98.982 77.633 98.983 77.94 99.25 78.095 99.249 77.788",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.133 78.432 97.867 78.277 97.868 78.584 98.134 78.739 98.133 78.432",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.244 76.133 98.977 75.977 98.982 77.633 99.249 77.788 99.244 76.133",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.249 77.788 98.982 77.633 97.867 78.277 98.133 78.432 99.249 77.788",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.25 78.095 99.249 77.788 98.133 78.432 98.134 78.739 99.25 78.095",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.378 76.055 99.111 75.9 98.977 75.977 99.244 76.133 99.378 76.055",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.244 76.133 99.249 77.788 99.25 78.095 99.254 79.785 99.388 79.708 99.383 78.018 99.382 77.71 99.378 76.055 99.244 76.133",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.001 78.817 97.734 78.661 97.738 80.351 98.005 80.506 98.001 78.817",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98 78.509 97.733 78.354 97.734 78.661 98.001 78.817 98 78.509",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.884 79.153 96.617 78.998 96.618 79.305 96.885 79.46 96.884 79.153",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.995 76.854 98 78.509 98.001 78.817 98.005 80.506 98.139 80.429 98.134 78.739 98.133 78.432 98.129 76.777 97.995 76.854",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98 78.509 97.733 78.354 96.617 78.998 96.884 79.153 98 78.509",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.001 78.817 98 78.509 96.884 79.153 96.885 79.46 98.001 78.817",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.995 76.854 97.728 76.698 97.733 78.354 98 78.509 97.995 76.854",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.129 76.777 97.862 76.621 97.728 76.698 97.995 76.854 98.129 76.777",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.751 79.538 96.484 79.383 96.489 81.072 96.756 81.227 96.751 79.538",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.75 79.23 96.484 79.075 96.484 79.383 96.751 79.538 96.75 79.23",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.635 79.874 95.368 79.719 95.369 80.026 95.636 80.182 95.635 79.874",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.75 79.23 96.484 79.075 95.368 79.719 95.635 79.874 96.75 79.23",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.75 79.23 95.635 79.874 95.636 80.182 96.751 79.538 96.75 79.23",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.746 77.575 96.479 77.419 96.484 79.075 96.75 79.23 96.746 77.575",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.88 77.498 96.613 77.342 96.479 77.419 96.746 77.575 96.88 77.498",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.746 77.575 96.75 79.23 96.751 79.538 96.756 81.227 96.89 81.15 96.885 79.46 96.884 79.153 96.88 77.498 96.746 77.575",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.497 78.296 95.23 78.141 95.24 81.793 95.507 81.948 95.497 78.296",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.63 78.219 95.364 78.063 95.23 78.141 95.497 78.296 95.63 78.219",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.497 78.296 95.507 81.948 95.641 81.871 95.636 80.182 95.635 79.874 95.63 78.219 95.497 78.296",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.1 68.926 108.837 68.773 108.839 69.598 109.102 69.751 109.1 68.926",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.102 69.751 108.839 69.598 107.26 70.51 107.523 70.663 109.102 69.751",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.097 67.923 108.834 67.77 108.836 68.598 109.099 68.751 109.097 67.923",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.099 68.751 108.836 68.598 107.257 69.509 107.521 69.662 109.099 68.751",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.094 66.922 108.831 66.769 108.833 67.595 109.096 67.748 109.094 66.922",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.015 70.129 106.752 69.977 106.754 70.802 107.017 70.955 107.015 70.129",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.096 67.748 108.833 67.595 107.255 68.506 107.518 68.659 109.096 67.748",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.091 65.921 108.828 65.768 108.831 66.594 109.094 66.747 109.091 65.921",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.012 69.127 106.749 68.973 106.751 69.801 107.015 69.954 107.012 69.127",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.094 66.747 108.831 66.594 107.252 67.506 107.515 67.658 109.094 66.747",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.088 64.918 108.825 64.765 108.828 65.594 109.091 65.746 109.088 64.918",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.009 68.126 106.746 67.973 106.749 68.799 107.012 68.951 107.009 68.126",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.091 65.746 108.828 65.594 107.249 66.505 107.512 66.658 109.091 65.746",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.086 63.917 108.822 63.765 108.825 64.59 109.088 64.744 109.086 63.917",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.006 67.125 106.743 66.972 106.746 67.798 107.009 67.951 107.006 67.125",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.088 64.744 108.825 64.59 107.246 65.502 107.509 65.655 109.088 64.744",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.083 62.917 108.82 62.764 108.822 63.59 109.085 63.743 109.083 62.917",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.004 66.122 106.741 65.969 106.743 66.797 107.006 66.95 107.004 66.122",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.085 63.743 108.822 63.59 107.243 64.501 107.506 64.654 109.085 63.743",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.08 61.914 108.817 61.761 108.819 62.589 109.082 62.742 109.08 61.914",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.001 65.121 106.738 64.968 106.74 65.794 107.003 65.947 107.001 65.121",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.082 62.742 108.819 62.589 107.24 63.5 107.504 63.654 109.082 62.742",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.077 60.913 108.814 60.761 108.816 61.586 109.079 61.739 109.077 60.913",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.998 64.12 106.735 63.968 106.737 64.793 107 64.946 106.998 64.12",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.079 61.739 108.816 61.586 107.238 62.498 107.501 62.65 109.079 61.739",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.074 59.913 108.811 59.759 108.814 60.585 109.077 60.738 109.074 59.913",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.995 63.118 106.732 62.964 106.734 63.793 106.998 63.945 106.995 63.118",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.077 60.738 108.814 60.585 107.235 61.497 107.498 61.65 109.077 60.738",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.071 58.91 108.808 58.757 108.81 59.585 109.074 59.738 109.071 58.91",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.992 62.117 106.729 61.964 106.732 62.79 106.995 62.943 106.992 62.117",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.074 59.738 108.81 59.585 107.232 60.496 107.495 60.649 109.074 59.738",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.069 57.909 108.805 57.756 108.808 58.582 109.071 58.735 109.069 57.909",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.989 61.116 106.726 60.963 106.729 61.789 106.992 61.942 106.989 61.116",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.017 70.955 106.754 70.802 97.75 76.001 98.013 76.154 107.017 70.955",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.071 58.735 108.808 58.582 107.229 59.493 107.492 59.646 109.071 58.735",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.066 56.908 108.803 56.755 108.805 57.581 109.068 57.734 109.066 56.908",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.987 60.113 106.724 59.96 106.726 60.788 106.989 60.941 106.987 60.113",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.015 69.954 106.751 69.801 97.747 75 98.01 75.153 107.015 69.954",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.068 57.734 108.805 57.581 107.226 58.493 107.489 58.645 109.068 57.734",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.505 75.62 97.241 75.467 97.244 76.293 97.507 76.446 97.505 75.62",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.984 59.112 106.721 58.96 106.723 59.785 106.986 59.938 106.984 59.112",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.012 68.951 106.749 68.799 97.744 73.997 98.007 74.15 107.012 68.951",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.502 74.617 97.239 74.465 97.241 75.292 97.504 75.445 97.502 74.617",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.507 76.446 97.244 76.293 95.5 77.3 95.763 77.452 97.507 76.446",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.981 58.112 106.718 57.959 106.72 58.784 106.983 58.938 106.981 58.112",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.009 67.951 106.746 67.798 97.741 72.996 98.004 73.149 107.009 67.951",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.499 73.617 97.236 73.463 97.238 74.289 97.501 74.442 97.499 73.617",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.504 75.445 97.241 75.292 95.497 76.299 95.76 76.452 97.504 75.445",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.006 66.95 106.743 66.797 97.738 71.996 98.002 72.148 107.006 66.95",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.496 72.616 97.233 72.463 97.235 73.289 97.498 73.442 97.496 72.616",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.501 74.442 97.238 74.289 95.494 75.296 95.758 75.449 97.501 74.442",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.003 65.947 106.74 65.794 97.736 70.993 97.999 71.146 107.003 65.947",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.493 71.613 97.23 71.46 97.233 72.288 97.496 72.441 97.493 71.613",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.498 73.442 97.235 73.289 95.492 74.296 95.755 74.448 97.498 73.442",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107 64.946 106.737 64.793 97.733 69.992 97.996 70.145 107 64.946",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.49 70.612 97.227 70.459 97.229 71.285 97.493 71.438 97.49 70.612",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.496 72.441 97.233 72.288 95.489 73.295 95.752 73.448 97.496 72.441",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.998 63.945 106.734 63.793 97.73 68.992 97.993 69.144 106.998 63.945",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.488 69.611 97.224 69.458 97.227 70.285 97.49 70.437 97.488 69.611",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.493 71.438 97.229 71.285 95.486 72.292 95.749 72.445 97.493 71.438",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.995 62.943 106.732 62.79 97.727 67.988 97.99 68.142 106.995 62.943",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.485 68.608 97.222 68.456 97.224 69.283 97.487 69.437 97.485 68.608",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.49 70.437 97.227 70.285 95.483 71.291 95.746 71.444 97.49 70.437",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.992 61.942 106.729 61.789 97.724 66.988 97.987 67.141 106.992 61.942",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.482 67.608 97.219 67.455 97.221 68.281 97.484 68.433 97.482 67.608",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.487 69.437 97.224 69.283 95.48 70.29 95.743 70.443 97.487 69.437",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.989 60.941 106.726 60.788 97.721 65.987 97.985 66.14 106.989 60.941",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.479 66.607 97.216 66.454 97.218 67.28 97.481 67.433 97.479 66.607",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.484 68.433 97.221 68.281 95.477 69.287 95.741 69.44 97.484 68.433",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.986 59.938 106.723 59.785 97.719 64.984 97.982 65.137 106.986 59.938",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.476 65.604 97.213 65.451 97.215 66.279 97.479 66.432 97.476 65.604",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.481 67.433 97.218 67.28 95.474 68.287 95.738 68.439 97.481 67.433",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.983 58.938 106.72 58.784 97.716 63.983 97.979 64.136 106.983 58.938",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.473 64.604 97.21 64.45 97.212 65.276 97.476 65.429 97.473 64.604",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.479 66.432 97.215 66.279 95.472 67.286 95.735 67.439 97.479 66.432",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.471 63.602 97.207 63.45 97.21 64.276 97.473 64.428 97.471 63.602",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.476 65.429 97.212 65.276 95.469 66.283 95.732 66.436 97.476 65.429",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.473 64.428 97.21 64.276 95.466 65.283 95.729 65.435 97.473 64.428",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.34 55.701 109.076 55.548 95.186 63.568 95.449 63.721 109.34 55.701",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.449,63.721l.041,14.607,13.891-8.02L109.34,55.7Zm12.072,6.116,1.579-.911,0,.825-1.579.912Zm0-1,1.579-.911,0,.828-1.578.911Zm0-1,1.579-.912,0,.826-1.578.911Zm0-1,1.578-.912,0,.826-1.579.911Zm0-1,1.578-.912,0,.828-1.579.912Zm0-1,1.579-.912,0,.827-1.579.911Zm0-1,1.579-.911,0,.826-1.579.911Zm0-1,1.579-.911,0,.828-1.578.912Zm0-1,1.579-.912,0,.826-1.578.911Zm0-1,1.579-.911,0,.825-1.579.912Zm0-1,1.578-.912,0,.829-1.579.911Zm0-1,1.579-.911,0,.826-1.579.911Zm0-1,1.579-.911,0,.826-1.579.911ZM98.011,75.328l9-5.2,0,.826-9,5.2Zm0-1,9-5.2,0,.827-9,5.2Zm0-1,9-5.2,0,.825-9,5.2Zm0-1,9-5.2,0,.826-9,5.2Zm0-1,9.005-5.2,0,.828-9,5.2Zm0-1,9.005-5.2,0,.826-9,5.2Zm0-1,9-5.2,0,.826-9,5.2Zm0-1,9-5.2,0,.827-9.005,5.2Zm0-1,9-5.2,0,.826-9.005,5.2Zm0-1,9-5.2,0,.826-9.005,5.2Zm0-1,9-5.2,0,.828-9,5.2Zm0-1,9-5.2,0,.826-9,5.2Zm0-1,9-5.2,0,.826-9,5.2ZM95.761,76.627l1.744-1.007,0,.826-1.744,1.006Zm0-1L97.5,74.617l0,.828L95.76,76.452Zm0-1L97.5,73.617l0,.825-1.743,1.007Zm0-1L97.5,72.616l0,.826-1.743,1.006Zm0-1,1.744-1.006,0,.828-1.744,1.007Zm0-1,1.743-1.007,0,.826-1.744,1.007Zm0-1,1.744-1.007,0,.826-1.744,1.007Zm0-1,1.744-1.007,0,.829-1.744,1.006Zm0-1,1.744-1.007,0,.825L95.741,69.44Zm0-1,1.744-1.007,0,.826-1.743,1.006Zm0-1L97.476,65.6l0,.828-1.744,1.007Zm0-1L97.473,64.6l0,.825-1.744,1.007Zm0-1L97.471,63.6l0,.826-1.744,1.007Z",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.449 63.721 95.186 63.568 95.227 78.175 95.49 78.328 95.449 63.721",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.824 60.791 85.703 54.91 85.707 56.237 95.827 62.119 95.824 60.791",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.731 54.493 96.611 48.612 85.703 54.91 95.824 60.791 106.731 54.493",
    style: {
      fill: "#96a1b5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.824 60.791 95.827 62.119 106.735 55.821 106.731 54.493 95.824 60.791",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.921 54.33 83.26 46.971 83.28 54.061 95.942 61.419 95.921 54.33",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.908 46.832 96.246 39.474 83.26 46.971 95.921 54.33 108.908 46.832",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.921 54.33 95.942 61.419 108.928 53.921 108.908 46.832 95.921 54.33",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.382 54.471 96.4 60.883 108.704 53.78 108.686 47.368 96.382 54.471",
    style: {
      fill: "#97c6de"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.729 52.349 108.518 52.226 108.521 53.546 108.733 53.669 108.729 52.349",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.733 53.669 108.521 53.546 107.3 54.252 107.511 54.374 108.733 53.669",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.724 50.861 108.514 50.739 108.517 52.057 108.728 52.18 108.724 50.861",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.36 53.139 107.149 53.017 107.153 54.337 107.364 54.459 107.36 53.139",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.728 52.18 108.517 52.057 107.296 52.762 107.507 52.885 108.728 52.18",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.364 54.459 107.153 54.337 105.931 55.042 106.142 55.165 107.364 54.459",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.356 51.652 107.145 51.529 107.149 52.847 107.36 52.97 107.356 51.652",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.993 53.929 105.782 53.806 105.786 55.126 105.997 55.249 105.993 53.929",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.36 52.97 107.149 52.847 105.927 53.553 106.138 53.675 107.36 52.97",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.72 49.205 108.509 49.083 108.513 50.401 108.724 50.524 108.72 49.205",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.997 55.249 105.786 55.126 104.564 55.831 104.775 55.954 105.997 55.249",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.724 50.524 108.513 50.401 107.291 51.106 107.502 51.229 108.724 50.524",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.989 52.441 105.778 52.318 105.782 53.637 105.993 53.759 105.989 52.441",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.624 54.719 104.413 54.596 104.417 55.916 104.628 56.039 104.624 54.719",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.993 53.759 105.782 53.637 104.56 54.342 104.771 54.464 105.993 53.759",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.351 49.996 107.14 49.873 107.144 51.191 107.355 51.314 107.351 49.996",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.719 49.036 108.508 48.914 107.287 49.619 107.498 49.742 108.719 49.036",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.715 47.633 108.504 47.51 108.508 48.914 108.719 49.036 108.715 47.633",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.628 56.039 104.417 55.916 103.195 56.622 103.407 56.744 104.628 56.039",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.355 51.314 107.144 51.191 105.922 51.896 106.133 52.019 107.355 51.314",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.62 53.231 104.409 53.109 104.413 54.427 104.624 54.55 104.62 53.231",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.256 55.509 103.044 55.386 103.048 56.706 103.259 56.829 103.256 55.509",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.624 54.55 104.413 54.427 103.191 55.132 103.402 55.255 104.624 54.55",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.984 50.785 105.773 50.662 105.777 51.98 105.988 52.103 105.984 50.785",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.351 49.826 107.14 49.704 105.918 50.409 106.129 50.532 107.351 49.826",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "107.347 48.423 107.136 48.3 107.14 49.704 107.351 49.826 107.347 48.423",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.259 56.829 103.048 56.706 101.827 57.412 102.038 57.535 103.259 56.829",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.988 52.103 105.777 51.98 104.555 52.685 104.766 52.808 105.988 52.103",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.251 54.022 103.04 53.899 103.044 55.217 103.255 55.34 103.251 54.022",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.889 56.298 101.678 56.176 101.681 57.496 101.892 57.618 101.889 56.298",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.255 55.34 103.044 55.217 101.822 55.922 102.033 56.045 103.255 55.34",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.615 51.575 104.404 51.453 104.408 52.771 104.619 52.893 104.615 51.575",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.984 50.616 105.773 50.493 104.551 51.198 104.762 51.321 105.984 50.616",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.98 49.212 105.769 49.089 105.773 50.493 105.984 50.616 105.98 49.212",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.892 57.618 101.681 57.496 100.46 58.201 100.671 58.324 101.892 57.618",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.619 52.893 104.408 52.771 103.187 53.476 103.398 53.598 104.619 52.893",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.884 54.811 101.673 54.688 101.677 56.006 101.888 56.129 101.884 54.811",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.52 57.089 100.309 56.966 100.313 58.286 100.524 58.408 100.52 57.089",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.888 56.129 101.677 56.006 100.456 56.711 100.667 56.834 101.888 56.129",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.247 52.366 103.036 52.243 103.039 53.561 103.25 53.684 103.247 52.366",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.615 51.406 104.404 51.283 103.182 51.989 103.393 52.111 104.615 51.406",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.611 50.002 104.4 49.88 104.404 51.283 104.615 51.406 104.611 50.002",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.524 58.408 100.313 58.286 99.091 58.991 99.302 59.114 100.524 58.408",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.25 53.684 103.039 53.561 101.818 54.266 102.029 54.389 103.25 53.684",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.516 55.601 100.305 55.478 100.308 56.797 100.519 56.919 100.516 55.601",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.151 57.879 98.94 57.756 98.944 59.076 99.155 59.199 99.151 57.879",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.519 56.919 100.308 56.797 99.087 57.502 99.298 57.624 100.519 56.919",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.88 53.155 101.669 53.032 101.673 54.35 101.883 54.473 101.88 53.155",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.246 52.196 103.035 52.074 101.814 52.779 102.024 52.902 103.246 52.196",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.242 50.792 103.031 50.67 103.035 52.074 103.246 52.196 103.242 50.792",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.155 59.199 98.944 59.076 97.722 59.782 97.933 59.904 99.155 59.199",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.883 54.473 101.673 54.35 100.451 55.055 100.662 55.178 101.883 54.473",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.147 56.391 98.936 56.269 98.94 57.587 99.15 57.71 99.147 56.391",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.784 58.668 97.573 58.545 97.577 59.865 97.788 59.988 97.784 58.668",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.15 57.71 98.94 57.587 97.718 58.292 97.929 58.415 99.15 57.71",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.511 53.945 100.3 53.822 100.304 55.14 100.515 55.263 100.511 53.945",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.879 52.985 101.668 52.863 100.446 53.568 100.658 53.691 101.879 52.985",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.875 51.582 101.664 51.459 101.668 52.863 101.879 52.985 101.875 51.582",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.788 59.988 97.577 59.865 96.355 60.571 96.566 60.693 97.788 59.988",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.515 55.263 100.304 55.14 99.082 55.845 99.293 55.968 100.515 55.263",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.78 57.18 97.569 57.058 97.573 58.376 97.784 58.499 97.78 57.18",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.784 58.499 97.573 58.376 96.351 59.081 96.562 59.204 97.784 58.499",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.142 54.735 98.931 54.613 98.935 55.931 99.146 56.053 99.142 54.735",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.51 53.776 100.299 53.653 99.078 54.358 99.289 54.481 100.51 53.776",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.506 52.372 100.296 52.249 100.299 53.653 100.51 53.776 100.506 52.372",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.146 56.053 98.935 55.931 97.713 56.636 97.924 56.758 99.146 56.053",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.775 55.524 97.564 55.402 97.568 56.72 97.779 56.842 97.775 55.524",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.142 54.566 98.931 54.443 97.709 55.149 97.92 55.271 99.142 54.566",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.138 53.162 98.927 53.04 98.931 54.443 99.142 54.566 99.138 53.162",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.779 56.842 97.568 56.72 96.346 57.425 96.557 57.548 97.779 56.842",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.775 55.355 97.564 55.232 96.342 55.938 96.553 56.06 97.775 55.355",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.771 53.951 97.56 53.829 97.564 55.232 97.775 55.355 97.771 53.951",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.123 46.955 108.912 46.832 95.926 54.33 96.137 54.452 109.123 46.955",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.137,54.452l.02,7.087,12.986-7.5-.02-7.086Zm11.37-1.4,1.222-.705,0,1.32-1.222.705Zm0-1.487,1.221-.706,0,1.319-1.221.7Zm0-1.656,1.222-.706,0,1.319-1.222.7Zm0-1.573,1.221-.7,0,1.4-1.221.706Zm-1.356,5.506,1.222-.7,0,1.32-1.222.706Zm0-1.487,1.222-.7,0,1.318-1.221.7Zm0-1.656,1.221-.7,0,1.318-1.222.7Zm0-1.573,1.222-.7,0,1.4-1.222.706Zm-1.353,5.505,1.221-.7,0,1.32-1.222.7Zm-.005-1.486,1.222-.706,0,1.318-1.222.7Zm0-1.657,1.222-.705,0,1.318-1.222.7Zm0-1.573,1.222-.7,0,1.4-1.222.7ZM103.4,55.424l1.221-.7,0,1.32-1.221.7Zm-.005-1.487,1.222-.706,0,1.319-1.222.705Zm0-1.657,1.221-.7,0,1.318-1.221.7Zm-.005-1.572L104.611,50l0,1.4-1.222.7Zm-1.355,5.506,1.222-.7,0,1.32-1.221.706Zm0-1.487,1.221-.706,0,1.319-1.221.7Zm0-1.657,1.222-.7,0,1.318-1.221.705Zm0-1.572,1.221-.706,0,1.4-1.222.706ZM100.667,57l1.222-.7,0,1.32-1.221.706Zm0-1.487,1.221-.7,0,1.318-1.221.705Zm0-1.656,1.222-.7,0,1.318-1.221.7Zm0-1.573,1.221-.7,0,1.4-1.221.706ZM99.3,57.793l1.222-.7,0,1.319-1.222.706Zm0-1.486,1.222-.706,0,1.318-1.221.705Zm0-1.657,1.222-.7,0,1.318-1.222.705Zm0-1.573,1.221-.7,0,1.4-1.221.7ZM97.93,58.584l1.221-.705,0,1.32-1.222.705ZM97.925,57.1l1.222-.706,0,1.319-1.221.7Zm0-1.657,1.221-.7,0,1.318-1.222.705Zm-.005-1.572,1.222-.706,0,1.4-1.222.7Zm-1.353,5.5,1.221-.7,0,1.32-1.222.7Zm0-1.487,1.222-.706,0,1.319-1.222.7Zm0-1.657,1.221-.7,0,1.318-1.222.706Zm0-1.572,1.222-.706,0,1.4-1.222.705Z",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.137 54.452 95.926 54.33 95.946 61.417 96.157 61.539 96.137 54.452",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.254 74.128 109.647 73.775 104.344 76.836 104.952 77.189 110.254 74.128",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.105 75.527 100.498 75.174 100.507 79.052 101.114 79.405 101.105 75.527",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.942 73.311 104.335 72.958 100.498 75.174 101.105 75.527 104.942 73.311",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.811 82.466 95.204 82.113 95.206 82.743 95.813 83.096 95.811 82.466",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.114 79.405 100.507 79.052 95.204 82.113 95.811 82.466 101.114 79.405",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.105 75.527 101.114 79.405 95.811 82.466 95.813 83.096 110.256 74.758 110.254 74.128 104.952 77.189 104.942 73.311 101.105 75.527",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.97 80.514 101.041 79.975 101.042 80.215 101.971 80.754 101.97 80.514",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.996 78.19 105.067 77.65 101.041 79.975 101.97 80.514 105.996 78.19",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.97 80.514 101.971 80.754 105.997 78.43 105.996 78.19 101.97 80.514",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.476 76.691 101.485 79.736 104.715 77.871 104.706 74.826 101.476 76.691",
    style: {
      fill: "#97c6de"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.757 75.735 104.627 75.659 104.634 77.911 104.763 77.987 104.757 75.735",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.755 74.959 104.625 74.884 104.627 75.475 104.757 75.551 104.755 74.959",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.965 76.192 103.835 76.117 103.841 78.369 103.971 78.445 103.965 76.192",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.757 75.551 104.627 75.475 103.994 75.841 104.124 75.916 104.757 75.551",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.962 75.417 103.833 75.341 103.834 75.933 103.964 76.009 103.962 75.417",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.061 76.714 102.931 76.638 102.938 78.931 103.068 79.007 103.061 76.714",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.158 77.235 102.028 77.16 102.034 79.412 102.164 79.487 102.158 77.235",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.964 76.009 103.834 75.933 102.187 76.884 102.317 76.96 103.964 76.009",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.156 76.46 102.026 76.385 102.027 76.976 102.157 77.052 102.156 76.46",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.157 77.052 102.027 76.976 101.396 77.34 101.526 77.416 102.157 77.052",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.882 74.75 104.753 74.675 101.265 76.688 101.395 76.764 104.882 74.75",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.4,76.764l.009,3.163.129-.075-.006-2.252.631-.365.006,2.252.16-.091-.006-2.253.743-.429.007,2.293.16-.093-.007-2.292.744-.43.006,2.253.16-.093-.006-2.252.632-.365.006,2.252.128-.074-.009-3.163Zm2.727-1.439.633-.366,0,.592-.633.365Zm-1.807,1.043,1.648-.951v.592l-1.647.951Zm-.79.456.631-.364v.592l-.631.364Z",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.395 76.764 101.265 76.688 101.274 79.851 101.404 79.927 101.395 76.764",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.941 77.403 102.848 77.348 102.768 77.395 102.86 77.449 102.941 77.403",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.86 77.449 102.768 77.395 102.771 78.546 102.864 78.599 102.86 77.449",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.941 77.403 102.86 77.449 102.864 78.599 102.945 78.553 102.941 77.403",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.466 77.099 103.373 77.045 103.292 77.092 103.385 77.146 103.466 77.099",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.385 77.146 103.292 77.092 103.296 78.243 103.388 78.296 103.385 77.146",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.469 78.25 103.466 77.099 103.385 77.146 103.388 78.296 103.469 78.25",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.7 75.87 101.093 75.517 101.095 76.153 101.702 76.506 101.7 75.87",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.54 73.653 104.932 73.3 101.093 75.517 101.7 75.87 105.54 73.653",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.7 75.87 101.702 76.506 105.541 74.289 105.54 73.653 101.7 75.87",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.818 82.466 96.426 82.113 96.424 82.743 95.817 83.096 95.818 82.466",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.49 74.764 83.097 74.412 96.426 82.113 95.818 82.466 82.49 74.764",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.818 82.466 95.817 83.096 82.488 75.394 82.49 74.764 95.818 82.466",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.315 41.866 86.299 36.627 86.333 47.933 95.349 53.172 95.315 41.866",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.627 35.912 96.612 30.673 86.299 36.627 95.315 41.866 105.627 35.912",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.315 41.866 95.349 53.172 105.661 47.218 105.627 35.912 95.315 41.866",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.642 42.509 95.59 52.37 105.655 46.31 105.63 36.672 95.642 42.509",
    style: {
      fill: "#97c6de"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.635 45.848 105.44 45.735 105.442 46.348 105.637 46.461 105.635 45.848",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.637 46.461 105.442 46.348 104.27 47.024 104.465 47.138 105.637 46.461",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.633 45.103 105.438 44.99 105.44 45.605 105.635 45.718 105.633 45.103",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.635 45.718 105.44 45.605 104.268 46.281 104.463 46.395 105.635 45.718",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.631 44.36 105.436 44.247 105.437 44.86 105.633 44.973 105.631 44.36",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.088 46.741 103.892 46.628 103.894 47.241 104.089 47.355 104.088 46.741",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.633 44.973 105.437 44.86 104.265 45.537 104.461 45.65 105.633 44.973",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.629 43.618 105.434 43.504 105.435 44.117 105.631 44.231 105.629 43.618",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.086 45.997 103.89 45.883 103.892 46.498 104.087 46.612 104.086 45.997",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.631 44.231 105.435 44.117 104.263 44.794 104.459 44.907 105.631 44.231",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.627 42.873 105.432 42.759 105.433 43.374 105.629 43.488 105.627 42.873",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.083 45.254 103.888 45.14 103.89 45.754 104.085 45.867 104.083 45.254",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.629 43.488 105.433 43.374 104.261 44.051 104.457 44.165 105.629 43.488",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.625 42.13 105.43 42.016 105.431 42.629 105.626 42.743 105.625 42.13",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.081 44.511 103.886 44.397 103.888 45.011 104.083 45.124 104.081 44.511",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.626 42.743 105.431 42.629 104.259 43.306 104.454 43.42 105.626 42.743",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.623 41.387 105.427 41.274 105.429 41.887 105.624 42 105.623 41.387",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.079 43.767 103.884 43.653 103.886 44.268 104.081 44.381 104.079 43.767",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.624 42 105.429 41.887 104.257 42.564 104.452 42.677 105.624 42",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.621 40.643 105.425 40.529 105.427 41.144 105.622 41.257 105.621 40.643",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.077 43.024 103.882 42.91 103.884 43.523 104.079 43.637 104.077 43.024",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.622 41.257 105.427 41.144 104.255 41.821 104.45 41.934 105.622 41.257",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.619 39.9 105.423 39.786 105.425 40.399 105.62 40.513 105.619 39.9",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.075 42.281 103.88 42.167 103.881 42.78 104.077 42.894 104.075 42.281",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.62 40.513 105.425 40.399 104.253 41.076 104.448 41.189 105.62 40.513",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.616 39.156 105.421 39.043 105.423 39.656 105.618 39.77 105.616 39.156",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.073 41.536 103.877 41.423 103.879 42.037 104.075 42.151 104.073 41.536",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.618 39.77 105.423 39.656 104.251 40.333 104.446 40.446 105.618 39.77",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.614 38.412 105.419 38.299 105.421 38.913 105.616 39.027 105.614 38.412",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.071 40.793 103.875 40.68 103.877 41.293 104.073 41.406 104.071 40.793",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.616 39.027 105.421 38.913 104.249 39.59 104.444 39.703 105.616 39.027",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.612 37.669 105.417 37.556 105.419 38.169 105.614 38.282 105.612 37.669",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.069 40.05 103.873 39.937 103.875 40.55 104.071 40.664 104.069 40.05",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.089 47.355 103.894 47.241 97.209 51.101 97.405 51.214 104.089 47.355",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.614 38.282 105.419 38.169 104.247 38.845 104.442 38.959 105.614 38.282",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.61 36.926 105.415 36.812 105.416 37.426 105.612 37.539 105.61 36.926",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.066 39.306 103.871 39.192 103.873 39.807 104.068 39.92 104.066 39.306",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.087 46.612 103.892 46.498 97.207 50.358 97.402 50.471 104.087 46.612",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.612 37.539 105.416 37.426 104.244 38.102 104.44 38.216 105.612 37.539",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.027 50.818 96.832 50.704 96.833 51.318 97.029 51.431 97.027 50.818",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.064 38.563 103.869 38.449 103.871 39.063 104.066 39.176 104.064 38.563",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.085 45.867 103.89 45.754 97.205 49.613 97.4 49.727 104.085 45.867",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.025 50.073 96.83 49.96 96.831 50.575 97.027 50.688 97.025 50.073",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.029 51.431 96.833 51.318 95.539 52.065 95.734 52.178 97.029 51.431",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.062 37.82 103.867 37.706 103.869 38.319 104.064 38.433 104.062 37.82",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.083 45.124 103.888 45.011 97.203 48.87 97.398 48.984 104.083 45.124",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.023 49.33 96.828 49.217 96.829 49.83 97.024 49.944 97.023 49.33",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.027 50.688 96.831 50.575 95.537 51.322 95.732 51.435 97.027 50.688",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.081 44.381 103.886 44.268 97.201 48.127 97.396 48.241 104.081 44.381",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.021 48.588 96.825 48.474 96.827 49.087 97.022 49.201 97.021 48.588",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.024 49.944 96.829 49.83 95.535 50.577 95.73 50.691 97.024 49.944",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.079 43.637 103.884 43.523 97.198 47.383 97.394 47.496 104.079 43.637",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.019 47.843 96.823 47.729 96.825 48.344 97.02 48.458 97.019 47.843",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.022 49.201 96.827 49.087 95.533 49.834 95.728 49.948 97.022 49.201",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.077 42.894 103.881 42.78 97.196 46.64 97.392 46.753 104.077 42.894",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.017 47.1 96.821 46.987 96.823 47.6 97.018 47.713 97.017 47.1",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.02 48.458 96.825 48.344 95.53 49.092 95.726 49.205 97.02 48.458",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.075 42.151 103.879 42.037 97.194 45.897 97.39 46.01 104.075 42.151",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.015 46.357 96.819 46.244 96.821 46.857 97.016 46.97 97.015 46.357",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.018 47.713 96.823 47.6 95.528 48.347 95.724 48.461 97.018 47.713",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.073 41.406 103.877 41.293 97.192 45.153 97.388 45.266 104.073 41.406",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.012 45.612 96.817 45.499 96.819 46.114 97.014 46.227 97.012 45.612",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.016 46.97 96.821 46.857 95.526 47.604 95.722 47.718 97.016 46.97",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.071 40.664 103.875 40.55 97.19 44.409 97.386 44.523 104.071 40.664",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.01 44.869 96.815 44.756 96.817 45.369 97.012 45.483 97.01 44.869",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.014 46.227 96.819 46.114 95.524 46.861 95.719 46.975 97.014 46.227",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.068 39.92 103.873 39.807 97.188 43.666 97.383 43.78 104.068 39.92",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.008 44.127 96.813 44.013 96.814 44.626 97.01 44.74 97.008 44.127",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.012 45.483 96.817 45.369 95.522 46.117 95.717 46.23 97.012 45.483",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.066 39.176 103.871 39.063 97.186 42.922 97.381 43.035 104.066 39.176",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.006 43.382 96.811 43.268 96.812 43.883 97.008 43.997 97.006 43.382",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.01 44.74 96.814 44.626 95.52 45.374 95.715 45.487 97.01 44.74",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.064 38.433 103.869 38.319 97.184 42.179 97.379 42.293 104.064 38.433",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.004 42.639 96.808 42.525 96.81 43.139 97.006 43.252 97.004 42.639",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.008 43.997 96.812 43.883 95.518 44.631 95.713 44.744 97.008 43.997",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.002 41.896 96.806 41.783 96.808 42.396 97.004 42.509 97.002 41.896",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.006 43.252 96.81 43.139 95.516 43.886 95.711 44 97.006 43.252",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.004 42.509 96.808 42.396 95.514 43.143 95.709 43.257 97.004 42.509",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.813 36.03 105.618 35.917 95.305 41.87 95.501 41.984 105.813 36.03",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.5,41.984l.031,10.844,10.312-5.954-.031-10.844Zm8.962,4.541,1.172-.677,0,.613-1.172.677Zm0-.745,1.172-.677,0,.615-1.172.677Zm0-.743,1.172-.677,0,.613-1.172.677Zm0-.743,1.172-.676,0,.613-1.172.676Zm0-.745,1.172-.676,0,.615-1.172.677Zm0-.742,1.172-.677v.613l-1.172.677Zm0-.743,1.172-.677V42l-1.172.677Zm0-.745,1.172-.676v.614l-1.172.677Zm0-.743,1.171-.677,0,.614-1.172.676Zm0-.743,1.172-.677,0,.614-1.172.676Zm0-.744,1.172-.677,0,.615-1.172.676Zm0-.743,1.172-.677,0,.613-1.172.677Zm0-.743,1.172-.677,0,.613-1.172.677ZM97.4,50.6l6.685-3.86v.614l-6.684,3.859Zm0-.744L104.086,46v.615L97.4,50.471Zm0-.743,6.685-3.86,0,.613L97.4,49.727Zm0-.744,6.685-3.859,0,.613L97.4,48.984Zm0-.744,6.685-3.859,0,.614L97.4,48.241Zm0-.743,6.685-3.859,0,.613L97.394,47.5Zm0-.743,6.685-3.859,0,.613-6.685,3.859Zm0-.744,6.685-3.86,0,.615L97.39,46.01Zm0-.743,6.685-3.86,0,.613-6.685,3.86Zm0-.743,6.685-3.86,0,.614-6.685,3.859Zm0-.745,6.684-3.859,0,.614-6.685,3.86Zm0-.743,6.684-3.859,0,.613-6.685,3.859Zm0-.743,6.685-3.859,0,.613-6.685,3.86Zm-1.645,9.886,1.3-.747,0,.613-1.3.747Zm0-.744,1.3-.748,0,.615-1.3.747Zm0-.743,1.3-.748v.614l-1.294.747Zm0-.743,1.3-.747V49.2l-1.294.747Zm0-.745,1.3-.747v.615l-1.294.747Zm0-.743,1.3-.747v.613l-1.294.748Zm0-.743,1.3-.747v.613l-1.294.748Zm0-.744,1.294-.748,0,.615-1.3.748Zm0-.743,1.294-.748,0,.614-1.3.747Zm0-.743,1.294-.747,0,.613-1.3.747Zm0-.744,1.3-.748,0,.615-1.3.747Zm0-.743,1.3-.748,0,.613-1.3.748Zm0-.743L97,41.9l0,.613-1.3.748Z",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.501 41.984 95.305 41.87 95.336 52.715 95.532 52.828 95.501 41.984",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.492 30.698 86.272 25.331 86.306 36.638 95.526 42.004 95.492 30.698",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.768 24.724 96.579 19.368 86.267 25.322 95.455 30.678 105.768 24.724",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.455 30.678 95.489 41.984 105.802 36.03 105.768 24.724 95.455 30.678",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.782 31.321 95.73 41.182 105.796 35.121 105.77 25.484 95.782 31.321",
    style: {
      fill: "#97c6de"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.776 34.66 105.58 34.546 105.582 35.16 105.778 35.273 105.776 34.66",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.778 35.273 105.582 35.16 104.41 35.836 104.606 35.95 105.778 35.273",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.774 33.915 105.578 33.802 105.58 34.417 105.776 34.53 105.774 33.915",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.776 34.53 105.58 34.417 104.408 35.093 104.604 35.207 105.776 34.53",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.772 33.172 105.576 33.059 105.578 33.672 105.773 33.785 105.772 33.172",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.228 35.553 104.033 35.44 104.035 36.053 104.23 36.166 104.228 35.553",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.773 33.785 105.578 33.672 104.406 34.349 104.601 34.462 105.773 33.785",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.77 32.43 105.574 32.316 105.576 32.929 105.771 33.043 105.77 32.43",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.226 34.809 104.031 34.695 104.032 35.31 104.228 35.424 104.226 34.809",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.771 33.043 105.576 32.929 104.404 33.606 104.599 33.719 105.771 33.043",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.767 31.685 105.572 31.571 105.574 32.186 105.769 32.3 105.767 31.685",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.224 34.066 104.029 33.952 104.03 34.565 104.226 34.679 104.224 34.066",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.769 32.3 105.574 32.186 104.402 32.863 104.597 32.976 105.769 32.3",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.765 30.942 105.57 30.829 105.572 31.442 105.767 31.555 105.765 30.942",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.222 33.323 104.026 33.209 104.028 33.823 104.224 33.936 104.222 33.323",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.767 31.555 105.572 31.442 104.4 32.118 104.595 32.232 105.767 31.555",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.763 30.199 105.568 30.086 105.57 30.699 105.765 30.812 105.763 30.199",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.22 32.579 104.024 32.465 104.026 33.08 104.222 33.193 104.22 32.579",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.765 30.812 105.57 30.699 104.398 31.375 104.593 31.489 105.765 30.812",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.761 29.455 105.566 29.341 105.568 29.956 105.763 30.069 105.761 29.455",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.218 31.835 104.022 31.722 104.024 32.335 104.219 32.449 104.218 31.835",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.763 30.069 105.568 29.956 104.396 30.632 104.591 30.746 105.763 30.069",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.759 28.712 105.564 28.598 105.565 29.211 105.761 29.325 105.759 28.712",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.216 31.093 104.02 30.979 104.022 31.592 104.217 31.706 104.216 31.093",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.761 29.325 105.565 29.211 104.394 29.888 104.589 30.001 105.761 29.325",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.757 27.968 105.561 27.855 105.563 28.468 105.759 28.582 105.757 27.968",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.213 30.348 104.018 30.235 104.02 30.849 104.215 30.963 104.213 30.348",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.759 28.582 105.563 28.468 104.391 29.145 104.587 29.258 105.759 28.582",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.755 27.224 105.559 27.111 105.561 27.725 105.757 27.839 105.755 27.224",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.211 29.605 104.016 29.492 104.018 30.105 104.213 30.218 104.211 29.605",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.757 27.839 105.561 27.725 104.389 28.402 104.585 28.515 105.757 27.839",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.753 26.481 105.557 26.368 105.559 26.981 105.754 27.094 105.753 26.481",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.209 28.862 104.014 28.749 104.015 29.362 104.211 29.475 104.209 28.862",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.23 36.166 104.035 36.053 97.35 39.913 97.545 40.026 104.23 36.166",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.754 27.094 105.559 26.981 104.387 27.657 104.582 27.771 105.754 27.094",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.751 25.738 105.555 25.625 105.557 26.238 105.752 26.351 105.751 25.738",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.207 28.118 104.012 28.004 104.013 28.619 104.209 28.732 104.207 28.118",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.228 35.424 104.032 35.31 97.348 39.17 97.543 39.283 104.228 35.424",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.752 26.351 105.557 26.238 104.385 26.914 104.58 27.028 105.752 26.351",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.168 39.63 96.972 39.516 96.974 40.13 97.169 40.243 97.168 39.63",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.205 27.375 104.01 27.261 104.011 27.874 104.207 27.988 104.205 27.375",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.226 34.679 104.03 34.565 97.345 38.425 97.541 38.539 104.226 34.679",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.166 38.885 96.97 38.772 96.972 39.386 97.167 39.5 97.166 38.885",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.169 40.243 96.974 40.13 95.679 40.877 95.875 40.99 97.169 40.243",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.203 26.632 104.008 26.518 104.009 27.131 104.205 27.245 104.203 26.632",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.224 33.936 104.028 33.823 97.343 37.682 97.539 37.795 104.224 33.936",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.163 38.143 96.968 38.029 96.97 38.642 97.165 38.756 97.163 38.143",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.167 39.5 96.972 39.386 95.677 40.134 95.873 40.247 97.167 39.5",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.222 33.193 104.026 33.08 97.341 36.939 97.537 37.052 104.222 33.193",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.161 37.4 96.966 37.286 96.968 37.899 97.163 38.013 97.161 37.4",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.165 38.756 96.97 38.642 95.675 39.389 95.87 39.503 97.165 38.756",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.219 32.449 104.024 32.335 97.339 36.195 97.534 36.308 104.219 32.449",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.159 36.655 96.964 36.541 96.966 37.156 97.161 37.27 97.159 36.655",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.163 38.013 96.968 37.899 95.673 38.646 95.868 38.76 97.163 38.013",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.217 31.706 104.022 31.592 97.337 35.451 97.532 35.565 104.217 31.706",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.157 35.912 96.962 35.799 96.964 36.412 97.159 36.525 97.157 35.912",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.161 37.27 96.966 37.156 95.671 37.904 95.866 38.017 97.161 37.27",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.215 30.963 104.02 30.849 97.335 34.709 97.53 34.822 104.215 30.963",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.155 35.169 96.96 35.056 96.961 35.669 97.157 35.782 97.155 35.169",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.159 36.525 96.964 36.412 95.669 37.159 95.864 37.273 97.159 36.525",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.213 30.218 104.018 30.105 97.333 33.964 97.528 34.078 104.213 30.218",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.153 34.424 96.957 34.311 96.959 34.926 97.155 35.039 97.153 34.424",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.157 35.782 96.961 35.669 95.667 36.416 95.862 36.529 97.157 35.782",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.211 29.475 104.015 29.362 97.331 33.221 97.526 33.335 104.211 29.475",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.151 33.681 96.955 33.568 96.957 34.181 97.153 34.294 97.151 33.681",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.155 35.039 96.959 34.926 95.665 35.673 95.86 35.786 97.155 35.039",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.209 28.732 104.013 28.619 97.329 32.478 97.524 32.592 104.209 28.732",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.149 32.939 96.953 32.825 96.955 33.438 97.15 33.552 97.149 32.939",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.153 34.294 96.957 34.181 95.663 34.928 95.858 35.042 97.153 34.294",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.207 27.988 104.011 27.874 97.327 31.734 97.522 31.847 104.207 27.988",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.146 32.194 96.951 32.08 96.953 32.695 97.148 32.809 97.146 32.194",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.15 33.552 96.955 33.438 95.66 34.185 95.856 34.299 97.15 33.552",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.205 27.245 104.009 27.131 97.324 30.991 97.52 31.104 104.205 27.245",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.144 31.451 96.949 31.337 96.951 31.951 97.146 32.064 97.144 31.451",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.148 32.809 96.953 32.695 95.658 33.442 95.854 33.556 97.148 32.809",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.142 30.708 96.947 30.595 96.949 31.208 97.144 31.321 97.142 30.708",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.146 32.064 96.951 31.951 95.656 32.698 95.852 32.812 97.146 32.064",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.144 31.321 96.949 31.208 95.654 31.955 95.85 32.069 97.144 31.321",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "105.954 24.842 105.759 24.729 95.446 30.683 95.641 30.796 105.954 24.842",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.641,30.8l.031,10.844,10.313-5.954-.031-10.844Zm8.963,4.541,1.172-.677,0,.613-1.172.677Zm0-.745,1.172-.677,0,.615-1.172.677Zm0-.743,1.172-.677v.613l-1.172.677Zm0-.743,1.172-.676v.613l-1.172.676Zm0-.744,1.171-.677,0,.615-1.172.676Zm0-.743,1.172-.677,0,.613-1.172.677Zm0-.743,1.172-.677,0,.613-1.172.677Zm0-.745,1.172-.676,0,.614-1.172.677Zm0-.743,1.172-.676,0,.613L104.589,30Zm0-.743,1.172-.677,0,.614-1.172.676Zm0-.744,1.172-.677,0,.615-1.172.676Zm0-.743,1.172-.677v.613l-1.172.677Zm0-.743,1.172-.677v.613l-1.172.677Zm-7.036,13,6.685-3.86,0,.613-6.685,3.86Zm0-.745,6.685-3.859,0,.615-6.685,3.859Zm0-.743,6.685-3.859,0,.613-6.685,3.86Zm0-.743,6.685-3.859,0,.613L97.539,37.8Zm0-.744,6.685-3.859,0,.614-6.685,3.859Zm0-.743,6.685-3.86v.614l-6.685,3.859Zm0-.743,6.685-3.859v.613l-6.685,3.859Zm0-.744,6.684-3.86,0,.615L97.53,34.822Zm0-.743,6.685-3.86,0,.613-6.685,3.86Zm0-.743,6.685-3.86,0,.613-6.685,3.86Zm0-.745,6.685-3.859,0,.614-6.685,3.86Zm0-.743,6.685-3.859,0,.613-6.685,3.859Zm0-.743,6.685-3.859,0,.613L97.52,31.1Zm-1.645,9.886,1.3-.747v.613l-1.294.747Zm0-.744,1.3-.748V39.5l-1.294.747Zm0-.743,1.294-.747,0,.613-1.3.747Zm0-.743,1.294-.747,0,.613-1.3.747Zm0-.745,1.294-.747,0,.615-1.3.747Zm0-.743,1.294-.747,0,.613-1.3.747Zm0-.743,1.3-.747,0,.613-1.3.747Zm0-.744,1.3-.748,0,.615-1.3.747Zm0-.743,1.3-.748,0,.613-1.3.748Zm0-.743,1.294-.747,0,.613-1.294.747Zm0-.744,1.294-.748,0,.615-1.294.747Zm0-.743,1.294-.748,0,.613-1.294.748Zm0-.743,1.294-.748,0,.613-1.294.748Z",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.641 30.796 95.446 30.683 95.477 41.527 95.672 41.64 95.641 30.796",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.091 25.03 87.812 20.219 87.825 24.854 96.104 29.665 96.091 25.03",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.583 20.128 96.303 15.316 87.812 20.219 96.091 25.03 104.583 20.128",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.091 25.03 96.104 29.665 104.596 24.763 104.583 20.128 96.091 25.03",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.392 25.123 96.404 29.315 104.449 24.67 104.437 20.478 96.392 25.123",
    style: {
      fill: "#97c6de"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.466 23.735 104.328 23.655 104.33 24.518 104.468 24.598 104.466 23.735",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.468 24.598 104.33 24.518 103.531 24.979 103.669 25.059 104.468 24.598",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.463 22.762 104.325 22.682 104.327 23.544 104.465 23.624 104.463 22.762",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.57 24.252 103.433 24.172 103.435 25.035 103.573 25.115 103.57 24.252",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.465 23.624 104.327 23.544 103.529 24.005 103.667 24.086 104.465 23.624",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.573 25.115 103.435 25.035 102.636 25.496 102.774 25.576 103.573 25.115",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.568 23.279 103.43 23.199 103.432 24.061 103.57 24.141 103.568 23.279",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.677 24.768 102.539 24.687 102.541 25.551 102.679 25.631 102.677 24.768",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.57 24.141 103.432 24.061 102.633 24.522 102.771 24.602 103.57 24.141",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.46 21.679 104.322 21.599 104.324 22.461 104.462 22.541 104.46 21.679",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.679 25.631 102.541 25.551 101.742 26.012 101.88 26.092 102.679 25.631",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.462 22.541 104.324 22.461 103.526 22.922 103.663 23.002 104.462 22.541",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.674 23.795 102.536 23.715 102.539 24.577 102.677 24.657 102.674 23.795",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.782 25.284 101.644 25.204 101.646 26.068 101.784 26.148 101.782 25.284",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.677 24.657 102.539 24.577 101.74 25.038 101.878 25.118 102.677 24.657",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.565 22.196 103.427 22.116 103.429 22.978 103.567 23.058 103.565 22.196",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.46 21.569 104.321 21.489 103.523 21.95 103.661 22.03 104.46 21.569",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.457 20.651 104.319 20.571 104.321 21.489 104.46 21.569 104.457 20.651",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.784 26.148 101.646 26.068 100.847 26.529 100.985 26.609 101.784 26.148",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.567 23.058 103.429 22.978 102.63 23.439 102.768 23.519 103.567 23.058",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.779 24.312 101.641 24.232 101.643 25.094 101.781 25.174 101.779 24.312",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.887 25.801 100.749 25.721 100.751 26.584 100.889 26.665 100.887 25.801",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.781 25.174 101.643 25.094 100.845 25.555 100.983 25.635 101.781 25.174",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.671 22.712 102.533 22.632 102.535 23.494 102.673 23.574 102.671 22.712",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.564 22.086 103.426 22.006 102.628 22.467 102.766 22.547 103.564 22.086",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.562 21.168 103.424 21.088 103.426 22.006 103.564 22.086 103.562 21.168",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.889 26.665 100.751 26.584 99.952 27.045 100.09 27.126 100.889 26.665",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.673 23.574 102.535 23.494 101.737 23.955 101.875 24.035 102.673 23.574",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.884 24.829 100.746 24.749 100.748 25.611 100.886 25.691 100.884 24.829",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.993 26.317 99.855 26.237 99.857 27.1 99.995 27.181 99.993 26.317",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.886 25.691 100.748 25.611 99.95 26.072 100.087 26.152 100.886 25.691",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.776 23.229 101.638 23.149 101.64 24.011 101.778 24.091 101.776 23.229",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.671 22.602 102.533 22.521 101.734 22.983 101.872 23.063 102.671 22.602",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.668 21.684 102.53 21.604 102.533 22.521 102.671 22.602 102.668 21.684",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.995 27.181 99.857 27.1 99.059 27.561 99.197 27.642 99.995 27.181",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.778 24.091 101.64 24.011 100.842 24.472 100.98 24.552 101.778 24.091",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.99 25.345 99.852 25.265 99.855 26.126 99.993 26.207 99.99 25.345",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.098 26.834 98.96 26.754 98.962 27.617 99.1 27.697 99.098 26.834",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.993 26.207 99.855 26.126 99.056 26.588 99.194 26.668 99.993 26.207",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.881 23.746 100.743 23.665 100.745 24.527 100.883 24.608 100.881 23.746",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.776 23.118 101.638 23.038 100.839 23.499 100.977 23.58 101.776 23.118",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.773 22.2 101.635 22.12 101.638 23.038 101.776 23.118 101.773 22.2",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.1 27.697 98.962 27.617 98.163 28.078 98.301 28.158 99.1 27.697",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.883 24.608 100.745 24.527 99.947 24.989 100.084 25.069 100.883 24.608",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.095 25.861 98.957 25.781 98.96 26.643 99.098 26.723 99.095 25.861",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.203 27.351 98.065 27.27 98.067 28.134 98.205 28.214 98.203 27.351",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.098 26.723 98.96 26.643 98.161 27.104 98.299 27.184 99.098 26.723",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.987 24.262 99.849 24.182 99.852 25.043 99.99 25.124 99.987 24.262",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.881 23.635 100.743 23.555 99.944 24.016 100.082 24.096 100.881 23.635",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.878 22.717 100.74 22.637 100.743 23.555 100.881 23.635 100.878 22.717",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.205 28.214 98.067 28.134 97.269 28.595 97.407 28.675 98.205 28.214",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.99 25.124 99.852 25.043 99.053 25.504 99.191 25.585 99.99 25.124",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.2 26.378 98.062 26.298 98.064 27.16 98.203 27.24 98.2 26.378",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.309 27.867 97.171 27.787 97.173 28.65 97.311 28.73 97.309 27.867",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.203 27.24 98.064 27.16 97.266 27.621 97.404 27.701 98.203 27.24",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.092 24.779 98.954 24.698 98.957 25.56 99.094 25.64 99.092 24.779",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.987 24.151 99.849 24.071 99.05 24.532 99.188 24.612 99.987 24.151",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.984 23.233 99.846 23.153 99.849 24.071 99.987 24.151 99.984 23.233",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.311 28.73 97.173 28.65 96.375 29.111 96.513 29.191 97.311 28.73",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.094 25.64 98.957 25.56 98.158 26.021 98.296 26.101 99.094 25.64",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.306 26.894 97.168 26.814 97.171 27.676 97.309 27.756 97.306 26.894",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.309 27.756 97.171 27.676 96.372 28.137 96.51 28.217 97.309 27.756",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.197 25.295 98.059 25.215 98.061 26.077 98.199 26.157 98.197 25.295",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.092 24.668 98.954 24.588 98.155 25.049 98.293 25.129 99.092 24.668",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.089 23.75 98.951 23.67 98.954 24.588 99.092 24.668 99.089 23.75",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.199 26.157 98.061 26.077 97.263 26.538 97.401 26.618 98.199 26.157",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.303 25.811 97.165 25.731 97.168 26.593 97.306 26.673 97.303 25.811",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.197 25.185 98.059 25.104 97.26 25.566 97.398 25.646 98.197 25.185",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.194 24.267 98.056 24.187 98.059 25.104 98.197 25.185 98.194 24.267",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.306 26.673 97.168 26.593 96.369 27.054 96.507 27.134 97.306 26.673",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.303 25.701 97.165 25.62 96.366 26.082 96.504 26.162 97.303 25.701",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.3 24.783 97.162 24.703 97.165 25.62 97.303 25.701 97.3 24.783",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.723 20.208 104.586 20.128 96.094 25.03 96.232 25.11 104.723 20.208",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.232,25.11l.013,4.634,8.492-4.9-.014-4.634Zm7.435-.914.8-.461,0,.863-.8.461Zm0-.972.8-.462,0,.862-.8.462Zm0-1.083.8-.462,0,.862-.8.461Zm0-1.029.8-.461,0,.918-.8.461Zm-.886,3.6.8-.461,0,.863-.8.461Zm0-.973.8-.461,0,.862-.8.461Zm0-1.083.8-.461,0,.862-.8.461Zm0-1.028.8-.461,0,.918-.8.461Zm-.885,3.6.8-.461,0,.863-.8.461Zm0-.973.8-.461,0,.862-.8.461Zm0-1.083.8-.461,0,.862-.8.461Zm0-1.028.8-.461,0,.918-.8.461Zm-.886,3.6.8-.462,0,.864-.8.461Zm0-.973.8-.461,0,.862-.8.461Zm0-1.083.8-.461,0,.862-.8.461Zm0-1.028.8-.462,0,.918-.8.462Zm-.886,3.6.8-.461,0,.864-.8.461Zm0-.972.8-.461,0,.862-.8.461Zm0-1.083.8-.461,0,.862-.8.461Zm0-1.028.8-.462,0,.918-.8.461Zm-.885,3.6.8-.461,0,.864-.8.461Zm0-.972.8-.461,0,.862-.8.461Zm0-1.083.8-.461,0,.862-.8.461Zm0-1.029.8-.461,0,.918-.8.461ZM98.3,27.3l.8-.461,0,.863-.8.461Zm0-.972.8-.462,0,.862-.8.461Zm0-1.083.8-.461,0,.861-.8.461Zm0-1.029.8-.461,0,.918-.8.461Zm-.886,3.6.8-.461,0,.863-.8.461Zm0-.973.8-.461,0,.862-.8.461Zm0-1.083.8-.461,0,.862-.8.461Zm0-1.028.8-.461,0,.918-.8.461Zm-.885,3.6.8-.461,0,.863-.8.461Zm0-.973.8-.461,0,.862-.8.461Zm0-1.082.8-.462,0,.862-.8.461Zm0-1.029.8-.461,0,.918-.8.461Z",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.232 25.11 96.094 25.03 96.107 29.664 96.245 29.744 96.232 25.11",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.404 42.509 95.456 52.37 86.22 46.815 86.246 37.178 95.404 42.509",
    style: {
      fill: "#97c6de"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.24 46.354 86.436 46.24 86.434 46.853 86.239 46.967 86.24 46.354",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.239 46.967 86.434 46.853 87.606 47.53 87.411 47.643 86.239 46.967",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.242 45.609 86.438 45.496 86.436 46.11 86.241 46.224 86.242 45.609",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.241 46.224 86.436 46.11 87.608 46.787 87.413 46.9 86.241 46.224",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.245 44.866 86.44 44.753 86.438 45.366 86.243 45.479 86.245 44.866",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.788 47.247 87.984 47.134 87.982 47.747 87.786 47.86 87.788 47.247",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.243 45.479 86.438 45.366 87.61 46.042 87.415 46.156 86.243 45.479",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.247 44.123 86.442 44.01 86.44 44.623 86.245 44.736 86.247 44.123",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.79 46.502 87.986 46.389 87.984 47.004 87.788 47.117 87.79 46.502",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.245 44.736 86.44 44.623 87.612 45.299 87.417 45.413 86.245 44.736",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.249 43.378 86.444 43.265 86.442 43.88 86.247 43.994 86.249 43.378",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.792 45.76 87.988 45.646 87.986 46.259 87.791 46.373 87.792 45.76",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.247 43.994 86.442 43.88 87.614 44.556 87.419 44.67 86.247 43.994",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.251 42.636 86.446 42.522 86.445 43.135 86.249 43.249 86.251 42.636",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.795 45.017 87.99 44.903 87.988 45.516 87.793 45.63 87.795 45.017",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.249 43.249 86.445 43.135 87.617 43.812 87.421 43.926 86.249 43.249",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.253 41.893 86.448 41.779 86.447 42.393 86.251 42.506 86.253 41.893",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.797 44.272 87.992 44.158 87.99 44.774 87.795 44.887 87.797 44.272",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.251 42.506 86.447 42.393 87.619 43.069 87.423 43.183 86.251 42.506",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.255 41.148 86.45 41.035 86.449 41.65 86.253 41.763 86.255 41.148",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.799 43.529 87.994 43.416 87.992 44.029 87.797 44.142 87.799 43.529",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.253 41.763 86.449 41.65 87.621 42.326 87.425 42.44 86.253 41.763",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.257 40.405 86.452 40.292 86.451 40.905 86.256 41.018 86.257 40.405",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.801 42.786 87.996 42.673 87.994 43.286 87.799 43.399 87.801 42.786",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.256 41.018 86.451 40.905 87.623 41.582 87.428 41.695 86.256 41.018",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.259 39.662 86.455 39.549 86.453 40.162 86.258 40.275 86.259 39.662",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.803 42.042 87.998 41.928 87.996 42.543 87.801 42.656 87.803 42.042",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.258 40.275 86.453 40.162 87.625 40.839 87.43 40.952 86.258 40.275",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.261 38.918 86.457 38.804 86.455 39.419 86.26 39.532 86.261 38.918",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.805 41.299 88 41.185 87.998 41.798 87.803 41.912 87.805 41.299",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.26 39.532 86.455 39.419 87.627 40.096 87.432 40.209 86.26 39.532",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.263 38.175 86.459 38.061 86.457 38.674 86.262 38.788 86.263 38.175",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.807 40.556 88.002 40.442 88.001 41.055 87.805 41.169 87.807 40.556",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.786 47.86 87.982 47.747 93.837 51.101 93.642 51.214 87.786 47.86",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.262 38.788 86.457 38.674 87.629 39.351 87.434 39.464 86.262 38.788",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.266 37.432 86.461 37.318 86.459 37.931 86.264 38.045 86.266 37.432",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.809 39.811 88.005 39.698 88.003 40.312 87.807 40.426 87.809 39.811",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.788 47.117 87.984 47.004 93.839 50.358 93.644 50.471 87.788 47.117",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.264 38.045 86.459 37.931 87.631 38.608 87.436 38.722 86.264 38.045",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.019 50.818 94.215 50.704 94.213 51.318 94.018 51.431 94.019 50.818",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.811 39.068 88.007 38.955 88.005 39.568 87.809 39.682 87.811 39.068",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.791 46.373 87.986 46.259 93.841 49.613 93.646 49.727 87.791 46.373",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.021 50.073 94.217 49.96 94.215 50.575 94.02 50.688 94.021 50.073",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.018 51.431 94.213 51.318 95.507 52.065 95.312 52.178 94.018 51.431",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.813 38.325 88.009 38.212 88.007 38.825 87.812 38.939 87.813 38.325",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.793 45.63 87.988 45.516 93.843 48.87 93.648 48.984 87.793 45.63",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.023 49.33 94.219 49.217 94.217 49.83 94.022 49.944 94.023 49.33",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.02 50.688 94.215 50.575 95.509 51.322 95.314 51.435 94.02 50.688",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.795 44.887 87.99 44.774 93.845 48.127 93.65 48.241 87.795 44.887",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.026 48.588 94.221 48.474 94.219 49.087 94.024 49.201 94.026 48.588",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.022 49.944 94.217 49.83 95.512 50.577 95.316 50.691 94.022 49.944",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.797 44.142 87.992 44.029 93.848 47.383 93.652 47.496 87.797 44.142",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.028 47.843 94.223 47.729 94.221 48.344 94.026 48.458 94.028 47.843",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.024 49.201 94.219 49.087 95.514 49.834 95.318 49.948 94.024 49.201",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.799 43.399 87.994 43.286 93.85 46.64 93.654 46.753 87.799 43.399",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.03 47.1 94.225 46.987 94.223 47.6 94.028 47.713 94.03 47.1",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.026 48.458 94.221 48.344 95.516 49.092 95.32 49.205 94.026 48.458",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.801 42.656 87.996 42.543 93.852 45.897 93.657 46.01 87.801 42.656",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.032 46.357 94.227 46.244 94.226 46.857 94.03 46.97 94.032 46.357",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.028 47.713 94.223 47.6 95.518 48.347 95.322 48.461 94.028 47.713",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.803 41.912 87.998 41.798 93.854 45.153 93.659 45.266 87.803 41.912",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.034 45.612 94.229 45.499 94.228 46.114 94.032 46.227 94.034 45.612",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.03 46.97 94.226 46.857 95.52 47.604 95.325 47.718 94.03 46.97",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.805 41.169 88.001 41.055 93.856 44.409 93.661 44.523 87.805 41.169",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.036 44.869 94.231 44.756 94.23 45.369 94.034 45.483 94.036 44.869",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.032 46.227 94.228 46.114 95.522 46.861 95.327 46.975 94.032 46.227",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.807 40.426 88.003 40.312 93.858 43.666 93.663 43.78 87.807 40.426",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.038 44.127 94.233 44.013 94.232 44.626 94.037 44.74 94.038 44.127",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.034 45.483 94.23 45.369 95.524 46.117 95.329 46.23 94.034 45.483",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.809 39.682 88.005 39.568 93.86 42.922 93.665 43.035 87.809 39.682",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.04 43.382 94.236 43.268 94.234 43.883 94.039 43.997 94.04 43.382",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.037 44.74 94.232 44.626 95.526 45.374 95.331 45.487 94.037 44.74",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.812 38.939 88.007 38.825 93.862 42.179 93.667 42.293 87.812 38.939",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.042 42.639 94.238 42.525 94.236 43.139 94.041 43.252 94.042 42.639",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.039 43.997 94.234 43.883 95.528 44.631 95.333 44.744 94.039 43.997",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.045 41.896 94.24 41.783 94.238 42.396 94.043 42.509 94.045 41.896",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.041 43.252 94.236 43.139 95.53 43.886 95.335 44 94.041 43.252",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.043 42.509 94.238 42.396 95.533 43.143 95.337 43.257 94.043 42.509",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.062 36.536 86.258 36.422 95.741 41.87 95.545 41.984 86.062 36.536",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.062,36.536l-.03,10.844,9.483,5.448.03-10.844Zm1.349,11.107-1.172-.676v-.613l1.172.676Zm0-.743-1.172-.676v-.615l1.172.677Zm0-.744-1.172-.677,0-.613,1.172.677Zm0-.743-1.172-.677,0-.613,1.172.677Zm0-.743-1.172-.676,0-.616,1.172.677Zm0-.744-1.172-.677,0-.613,1.172.677Zm0-.743-1.172-.677,0-.613,1.172.676Zm0-.743-1.172-.677,0-.615,1.172.677Zm0-.745-1.172-.677v-.613l1.172.677Zm0-.743-1.172-.677v-.613l1.172.677Zm0-.743-1.172-.677v-.614l1.172.676Zm0-.745-1.172-.676v-.613l1.173.676Zm0-.742-1.172-.677,0-.613,1.172.677Zm6.206,12.492L87.786,47.86l0-.613L93.643,50.6Zm0-.743-5.856-3.354,0-.615,5.856,3.355Zm0-.744-5.855-3.354V45.76l5.856,3.354Zm0-.743L87.793,45.63l0-.613L93.65,48.37Zm0-.743L87.8,44.887l0-.615,5.855,3.354Zm0-.745L87.8,44.142l0-.613,5.855,3.354Zm0-.743L87.8,43.4l0-.613,5.855,3.354Zm0-.743L87.8,42.656l0-.614L93.658,45.4Zm0-.744L87.8,41.912l0-.613,5.855,3.354Zm0-.743-5.856-3.354,0-.613,5.855,3.354Zm0-.743-5.856-3.354,0-.615,5.856,3.354Zm0-.745-5.856-3.353,0-.614,5.856,3.354Zm0-.742-5.855-3.354v-.614l5.856,3.354Zm1.645,9.885-1.294-.747v-.613l1.295.747Zm0-.743-1.294-.747v-.615l1.3.748Zm0-.744-1.294-.747V49.33l1.3.748Zm0-.743L94.024,49.2l0-.613,1.294.747Zm0-.743-1.294-.747,0-.615,1.294.747Zm0-.744-1.294-.748,0-.613,1.294.747Zm0-.743-1.3-.748,0-.613,1.294.747Zm0-.743-1.3-.748,0-.615,1.295.748Zm0-.745-1.295-.747,0-.614,1.3.748Zm0-.743-1.294-.747v-.613l1.3.747Zm0-.743L94.039,44v-.615l1.295.748Zm0-.744-1.294-.748v-.613l1.3.748Zm0-.743-1.294-.748,0-.613,1.294.748Z",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.545 41.984 95.741 41.87 95.71 52.715 95.515 52.828 95.545 41.984",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.044 25.163 96.032 29.356 87.986 24.711 87.998 20.518 96.044 25.163",
    style: {
      fill: "#97c6de"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.97 23.776 88.108 23.695 88.106 24.559 87.968 24.639 87.97 23.776",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.968 24.639 88.106 24.559 88.904 25.02 88.766 25.1 87.968 24.639",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.973 22.803 88.111 22.723 88.108 23.585 87.97 23.665 87.973 22.803",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.865 24.292 89.003 24.212 89.001 25.075 88.863 25.156 88.865 24.292",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.97 23.665 88.108 23.585 88.907 24.046 88.769 24.126 87.97 23.665",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.863 25.156 89.001 25.075 89.799 25.536 89.661 25.617 88.863 25.156",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.868 23.32 89.006 23.24 89.004 24.102 88.865 24.182 88.868 23.32",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.759 24.808 89.897 24.728 89.894 25.591 89.756 25.672 89.759 24.808",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.865 24.182 89.004 24.102 89.802 24.563 89.664 24.643 88.865 24.182",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.976 21.72 88.114 21.64 88.111 22.502 87.973 22.582 87.976 21.72",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.756 25.672 89.894 25.591 90.693 26.053 90.555 26.133 89.756 25.672",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.973 22.582 88.111 22.502 88.91 22.963 88.772 23.043 87.973 22.582",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.762 23.836 89.9 23.756 89.897 24.617 89.759 24.698 89.762 23.836",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.654 25.325 90.792 25.245 90.79 26.108 90.651 26.188 90.654 25.325",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.759 24.698 89.897 24.617 90.696 25.079 90.558 25.159 89.759 24.698",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.871 22.237 89.009 22.156 89.007 23.018 88.869 23.099 88.871 22.237",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.976 21.609 88.114 21.529 88.913 21.991 88.775 22.071 87.976 21.609",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.979 20.691 88.117 20.611 88.114 21.529 87.976 21.609 87.979 20.691",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.651 26.188 90.79 26.108 91.588 26.569 91.45 26.65 90.651 26.188",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.869 23.099 89.007 23.018 89.805 23.48 89.667 23.56 88.869 23.099",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.657 24.353 90.795 24.272 90.792 25.134 90.654 25.214 90.657 24.353",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.549 25.842 91.687 25.761 91.684 26.625 91.546 26.705 91.549 25.842",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.654 25.214 90.792 25.134 91.591 25.595 91.453 25.676 90.654 25.214",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.765 22.753 89.903 22.673 89.9 23.534 89.762 23.615 89.765 22.753",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.871 22.126 89.009 22.046 89.808 22.507 89.67 22.587 88.871 22.126",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "88.874 21.208 89.012 21.128 89.009 22.046 88.871 22.126 88.874 21.208",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.546 26.705 91.684 26.625 92.483 27.086 92.345 27.166 91.546 26.705",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.762 23.615 89.9 23.534 90.699 23.996 90.561 24.076 89.762 23.615",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.552 24.869 91.69 24.789 91.687 25.651 91.549 25.731 91.552 24.869",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.443 26.358 92.581 26.278 92.578 27.141 92.44 27.221 92.443 26.358",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.549 25.731 91.687 25.651 92.486 26.112 92.348 26.192 91.549 25.731",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.66 23.27 90.798 23.189 90.795 24.051 90.657 24.132 90.66 23.27",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.765 22.642 89.903 22.562 90.702 23.023 90.564 23.103 89.765 22.642",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.767 21.724 89.906 21.644 89.903 22.562 89.765 22.642 89.767 21.724",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.44 27.221 92.578 27.141 93.377 27.602 93.239 27.682 92.44 27.221",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.657 24.132 90.795 24.051 91.594 24.512 91.456 24.593 90.657 24.132",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.445 25.385 92.583 25.305 92.581 26.167 92.443 26.247 92.445 25.385",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.338 26.875 93.476 26.794 93.473 27.658 93.335 27.738 93.338 26.875",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.443 26.247 92.581 26.167 93.38 26.628 93.242 26.708 92.443 26.247",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.555 23.786 91.693 23.706 91.69 24.568 91.552 24.648 91.555 23.786",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.66 23.159 90.798 23.079 91.597 23.54 91.459 23.62 90.66 23.159",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.663 22.241 90.801 22.161 90.798 23.079 90.66 23.159 90.663 22.241",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.335 27.738 93.473 27.658 94.272 28.119 94.134 28.199 93.335 27.738",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.552 24.648 91.69 24.568 92.489 25.029 92.351 25.109 91.552 24.648",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.341 25.902 93.479 25.822 93.476 26.684 93.338 26.764 93.341 25.902",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.233 27.391 94.371 27.311 94.368 28.174 94.23 28.255 94.233 27.391",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.338 26.764 93.476 26.684 94.275 27.145 94.137 27.225 93.338 26.764",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.448 24.302 92.586 24.222 92.584 25.084 92.446 25.164 92.448 24.302",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.555 23.676 91.693 23.596 92.492 24.057 92.354 24.137 91.555 23.676",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.558 22.758 91.696 22.678 91.693 23.596 91.555 23.676 91.558 22.758",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.23 28.255 94.368 28.174 95.167 28.636 95.029 28.716 94.23 28.255",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.446 25.164 92.584 25.084 93.383 25.545 93.245 25.625 92.446 25.164",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.235 26.419 94.373 26.339 94.371 27.201 94.233 27.281 94.235 26.419",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.127 27.907 95.265 27.827 95.262 28.691 95.124 28.771 95.127 27.907",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.233 27.281 94.371 27.201 95.17 27.662 95.032 27.742 94.233 27.281",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.344 24.819 93.482 24.739 93.479 25.601 93.341 25.681 93.344 24.819",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.449 24.192 92.587 24.111 93.386 24.573 93.248 24.653 92.449 24.192",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.451 23.274 92.589 23.194 92.587 24.111 92.449 24.192 92.451 23.274",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.124 28.771 95.262 28.691 96.061 29.152 95.923 29.232 95.124 28.771",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.341 25.681 93.479 25.601 94.278 26.062 94.14 26.142 93.341 25.681",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.129 26.935 95.267 26.855 95.265 27.716 95.127 27.797 95.129 26.935",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.127 27.797 95.265 27.716 96.064 28.178 95.926 28.258 95.127 27.797",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.238 25.336 94.377 25.256 94.374 26.118 94.236 26.198 94.238 25.336",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.344 24.709 93.482 24.628 94.281 25.09 94.143 25.17 93.344 24.709",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.346 23.791 93.484 23.71 93.482 24.628 93.344 24.709 93.346 23.791",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.236 26.198 94.374 26.118 95.173 26.579 95.035 26.659 94.236 26.198",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.132 25.852 95.27 25.772 95.268 26.634 95.13 26.714 95.132 25.852",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.239 25.225 94.377 25.145 95.176 25.606 95.038 25.686 94.239 25.225",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.242 24.307 94.38 24.227 94.377 25.145 94.239 25.225 94.242 24.307",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.13 26.714 95.268 26.634 96.067 27.095 95.929 27.175 95.13 26.714",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.133 25.741 95.271 25.661 96.069 26.122 95.931 26.202 95.133 25.741",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.135 24.823 95.273 24.743 95.271 25.661 95.133 25.741 95.135 24.823",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.712 20.248 87.85 20.168 96.342 25.071 96.204 25.151 87.712 20.248",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.712,20.248,87.7,24.882l8.491,4.9.014-4.634ZM88.766,25.1l-.8-.461,0-.863.8.461Zm0-.974-.8-.461,0-.862.8.461Zm0-1.083-.8-.461,0-.862.8.461Zm0-.972-.8-.462,0-.918.8.462Zm.886,3.546-.8-.461,0-.864.8.461Zm0-.974-.8-.461,0-.862.8.461Zm0-1.083-.8-.461,0-.862.8.461Zm0-.973-.8-.461,0-.918.8.462Zm.885,3.546-.8-.461,0-.864.8.462Zm0-.974-.8-.461,0-.862.8.461Zm0-1.083-.8-.461,0-.862.8.461Zm0-.973-.8-.461,0-.918.8.461Zm.886,3.547-.8-.462,0-.863.8.461Zm0-.974-.8-.462,0-.861.8.461Zm0-1.083-.8-.462,0-.861.8.461Zm0-.973-.8-.461,0-.918.8.461Zm.886,3.546-.8-.461,0-.863.8.461Zm0-.974-.8-.461,0-.862.8.462Zm0-1.083-.8-.461,0-.862.8.461Zm0-.972-.8-.461,0-.918.8.461Zm.885,3.545-.8-.461,0-.863.8.461Zm0-.974-.8-.461,0-.862.8.462Zm0-1.083-.8-.461,0-.862.8.462Zm0-.972-.8-.461,0-.918.8.461Zm.886,3.546-.8-.461,0-.863.8.461Zm0-.974-.8-.461,0-.862.8.461Zm0-1.083-.8-.461,0-.862.8.461Zm0-.972-.8-.461,0-.918.8.461Zm.886,3.546-.8-.461,0-.864.8.461Zm0-.974-.8-.461,0-.862.8.461Zm0-1.083-.8-.461,0-.862.8.461Zm0-.973-.8-.461,0-.918.8.462Zm.885,3.546-.8-.461,0-.864.8.462Zm0-.974-.8-.461,0-.862.8.461Zm0-1.083-.8-.461,0-.862.8.461Zm0-.973-.8-.461,0-.918.8.461Z",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.204 25.151 96.342 25.071 96.328 29.705 96.19 29.785 96.204 25.151",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.93 54.532 95.912 60.889 83.715 53.847 83.733 47.491 95.93 54.532",
    style: {
      fill: "#97c6de"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.691 52.429 83.9 52.307 83.896 53.616 83.687 53.738 83.691 52.429",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.687 53.738 83.896 53.616 85.107 54.315 84.898 54.437 83.687 53.738",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.695 50.955 83.904 50.833 83.9 52.14 83.691 52.262 83.695 50.955",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.048 53.213 85.257 53.091 85.253 54.4 85.044 54.521 85.048 53.213",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.691 52.262 83.9 52.14 85.111 52.839 84.902 52.96 83.691 52.262",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.044 54.521 85.253 54.4 86.464 55.099 86.255 55.22 85.044 54.521",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.052 51.738 85.261 51.617 85.257 52.923 85.048 53.045 85.052 51.738",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.403 53.995 86.612 53.873 86.608 55.182 86.399 55.303 86.403 53.995",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.048 53.045 85.257 52.923 86.468 53.622 86.259 53.744 85.048 53.045",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.7 49.313 83.909 49.191 83.905 50.498 83.696 50.619 83.7 49.313",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.399 55.303 86.608 55.182 87.819 55.881 87.61 56.003 86.399 55.303",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.696 50.619 83.905 50.498 85.116 51.197 84.907 51.319 83.696 50.619",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.407 52.52 86.616 52.399 86.612 53.705 86.403 53.827 86.407 52.52",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.759 54.778 87.969 54.656 87.965 55.965 87.756 56.087 87.759 54.778",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.403 53.827 86.612 53.705 87.823 54.405 87.614 54.526 86.403 53.827",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.056 50.096 85.266 49.974 85.262 51.281 85.053 51.403 85.056 50.096",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.7 49.145 83.909 49.023 85.12 49.723 84.911 49.845 83.7 49.145",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.704 47.754 83.913 47.632 83.909 49.023 83.7 49.145 83.704 47.754",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.756 56.087 87.965 55.965 89.176 56.664 88.966 56.786 87.756 56.087",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.053 51.403 85.262 51.281 86.473 51.98 86.263 52.102 85.053 51.403",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.764 53.304 87.973 53.182 87.969 54.489 87.76 54.611 87.764 53.304",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.116 55.562 89.326 55.44 89.322 56.749 89.112 56.87 89.116 55.562",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.76 54.611 87.969 54.489 89.18 55.188 88.971 55.309 87.76 54.611",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.411 50.879 86.62 50.757 86.617 52.064 86.408 52.185 86.411 50.879",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.057 49.929 85.266 49.807 86.477 50.506 86.268 50.628 85.057 49.929",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.061 48.537 85.27 48.416 85.266 49.807 85.057 49.929 85.061 48.537",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.112 56.87 89.322 56.749 90.533 57.448 90.323 57.569 89.112 56.87",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.408 52.185 86.617 52.064 87.828 52.762 87.619 52.884 86.408 52.185",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.12 54.087 89.33 53.966 89.326 55.272 89.117 55.394 89.12 54.087",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.471 56.344 90.68 56.222 90.677 57.531 90.468 57.652 90.471 56.344",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.117 55.394 89.326 55.272 90.537 55.971 90.327 56.093 89.117 55.394",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.768 51.662 87.977 51.541 87.974 52.847 87.765 52.968 87.768 51.662",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.412 50.711 86.621 50.59 87.832 51.288 87.623 51.41 86.412 50.711",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.416 49.319 86.625 49.198 86.621 50.59 86.412 50.711 86.416 49.319",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.468 57.652 90.677 57.531 91.888 58.23 91.678 58.352 90.468 57.652",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.765 52.968 87.974 52.847 89.185 53.546 88.975 53.668 87.765 52.968",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.475 54.869 90.684 54.748 90.681 56.054 90.472 56.176 90.475 54.869",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.828 57.127 92.037 57.005 92.034 58.314 91.824 58.436 91.828 57.127",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.472 56.176 90.681 56.054 91.892 56.754 91.683 56.875 90.472 56.176",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.125 52.445 89.334 52.324 89.331 53.63 89.121 53.752 89.125 52.445",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.769 51.494 87.978 51.373 89.189 52.072 88.98 52.194 87.769 51.494",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.773 50.103 87.982 49.981 87.978 51.373 87.769 51.494 87.773 50.103",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.824 58.436 92.034 58.314 93.244 59.013 93.035 59.135 91.824 58.436",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.121 53.752 89.331 53.63 90.541 54.33 90.332 54.451 89.121 53.752",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.832 55.653 92.041 55.531 92.038 56.838 91.829 56.96 91.832 55.653",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.185 57.911 93.394 57.789 93.39 59.098 93.181 59.219 93.185 57.911",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.829 56.96 92.038 56.838 93.249 57.537 93.039 57.658 91.829 56.96",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.48 53.228 90.689 53.106 90.685 54.413 90.476 54.534 90.48 53.228",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.126 52.278 89.335 52.156 90.546 52.855 90.336 52.977 89.126 52.278",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.129 50.886 89.339 50.765 89.335 52.156 89.126 52.278 89.129 50.886",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.181 59.219 93.39 59.098 94.601 59.797 94.392 59.918 93.181 59.219",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.476 54.534 90.685 54.413 91.897 55.112 91.687 55.233 90.476 54.534",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.189 56.436 93.398 56.315 93.395 57.621 93.185 57.743 93.189 56.436",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.54 58.693 94.749 58.571 94.745 59.88 94.536 60.001 94.54 58.693",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.185 57.743 93.395 57.621 94.605 58.32 94.396 58.442 93.185 57.743",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.837 54.011 92.046 53.89 92.042 55.196 91.833 55.318 91.837 54.011",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.48 53.06 90.69 52.939 91.901 53.637 91.692 53.759 90.48 53.06",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.485 51.668 90.694 51.547 90.69 52.939 90.48 53.06 90.485 51.668",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.536 60.001 94.745 59.88 95.956 60.579 95.747 60.701 94.536 60.001",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.833 55.318 92.042 55.196 93.253 55.895 93.044 56.017 91.833 55.318",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.544 57.218 94.753 57.097 94.749 58.403 94.54 58.525 94.544 57.218",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.54 58.525 94.749 58.403 95.961 59.103 95.751 59.224 94.54 58.525",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.194 54.794 93.403 54.673 93.399 55.979 93.19 56.101 93.194 54.794",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.837 53.843 92.047 53.722 93.258 54.421 93.048 54.543 91.837 53.843",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.841 52.452 92.051 52.33 92.047 53.722 91.837 53.843 91.841 52.452",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.19 56.101 93.399 55.979 94.61 56.679 94.401 56.8 93.19 56.101",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.549 55.577 94.758 55.455 94.754 56.762 94.545 56.883 94.549 55.577",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.194 54.627 93.403 54.505 94.614 55.204 94.405 55.326 93.194 54.627",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.198 53.235 93.407 53.114 93.403 54.505 93.194 54.627 93.198 53.235",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.545 56.883 94.754 56.762 95.965 57.461 95.756 57.582 94.545 56.883",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.549 55.409 94.758 55.288 95.969 55.986 95.76 56.108 94.549 55.409",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.553 54.017 94.762 53.896 94.758 55.288 94.549 55.409 94.553 54.017",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.3 47.082 83.509 46.96 96.382 54.392 96.173 54.514 83.3 47.082",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3,47.082l-.02,7.025,12.873,7.432.02-7.025Zm1.6,7.355-1.211-.7,0-1.309,1.21.7Zm0-1.477-1.211-.7,0-1.307,1.211.7Zm0-1.641-1.211-.7,0-1.306,1.21.7Zm0-1.474-1.211-.7,0-1.391,1.211.7Zm1.344,5.375-1.211-.7,0-1.308,1.21.7Zm0-1.476-1.211-.7,0-1.307,1.211.7Zm0-1.642-1.21-.7,0-1.307,1.211.7Zm0-1.474-1.211-.7,0-1.392,1.211.7ZM87.61,56,86.4,55.3,86.4,54l1.21.7Zm0-1.477-1.211-.7,0-1.307,1.211.7Zm0-1.642-1.211-.7,0-1.306,1.211.7Zm0-1.474-1.211-.7,0-1.392,1.211.7Zm1.343,5.376-1.21-.7,0-1.309,1.211.7Zm.005-1.477-1.211-.7,0-1.307,1.21.7Zm0-1.641-1.21-.7,0-1.306,1.211.7Zm.005-1.474-1.211-.7,0-1.391,1.211.7Zm1.343,5.375-1.211-.7,0-1.308,1.211.7Zm0-1.476-1.21-.7,0-1.307,1.211.7Zm0-1.642-1.211-.7,0-1.307,1.211.7Zm0-1.474-1.21-.7,0-1.392,1.211.7Zm1.342,5.375-1.21-.7,0-1.308,1.211.7Zm.005-1.477-1.211-.7,0-1.307,1.211.7Zm0-1.642-1.211-.7,0-1.306,1.211.7Zm0-1.474-1.211-.7,0-1.392,1.21.7Zm1.344,5.376-1.211-.7,0-1.309,1.211.7Zm0-1.477-1.21-.7,0-1.307,1.211.7Zm0-1.641-1.211-.7,0-1.307,1.211.7Zm0-1.474-1.211-.7,0-1.391,1.211.7Zm1.344,5.375-1.211-.7,0-1.308,1.211.7Zm0-1.476-1.211-.7,0-1.307,1.211.7Zm0-1.642-1.211-.7,0-1.307,1.211.7Zm0-1.474-1.211-.7,0-1.392,1.211.7ZM95.747,60.7,94.536,60l0-1.308,1.211.7Zm0-1.477-1.211-.7,0-1.307,1.211.7Zm0-1.642-1.211-.7,0-1.306,1.211.7Zm0-1.474-1.211-.7,0-1.392,1.211.7Z",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.173 54.514 96.382 54.392 96.362 61.418 96.153 61.539 96.173 54.514",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.487 31.347 95.539 41.207 86.303 35.652 86.328 26.015 95.487 31.347",
    style: {
      fill: "#97c6de"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.323 35.191 86.518 35.077 86.516 35.69 86.321 35.804 86.323 35.191",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.321 35.804 86.516 35.69 87.688 36.367 87.493 36.481 86.321 35.804",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.325 34.446 86.52 34.332 86.518 34.948 86.323 35.061 86.325 34.446",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.323 35.061 86.518 34.948 87.69 35.624 87.495 35.738 86.323 35.061",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.327 33.703 86.522 33.59 86.521 34.203 86.325 34.316 86.327 33.703",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.87 36.084 88.066 35.971 88.064 36.584 87.869 36.697 87.87 36.084",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.325 34.316 86.521 34.203 87.693 34.88 87.497 34.993 86.325 34.316",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.329 32.96 86.524 32.847 86.523 33.46 86.327 33.573 86.329 32.96",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.872 35.34 88.068 35.226 88.066 35.841 87.871 35.954 87.872 35.34",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.327 33.573 86.523 33.46 87.695 34.137 87.499 34.25 86.327 33.573",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.331 32.216 86.527 32.102 86.525 32.717 86.329 32.83 86.331 32.216",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.875 34.597 88.07 34.483 88.068 35.096 87.873 35.21 87.875 34.597",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.329 32.83 86.525 32.717 87.697 33.394 87.501 33.507 86.329 32.83",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.333 31.473 86.529 31.359 86.527 31.972 86.331 32.086 86.333 31.473",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.877 33.854 88.072 33.74 88.07 34.353 87.875 34.467 87.877 33.854",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.331 32.086 86.527 31.972 87.699 32.649 87.503 32.762 86.331 32.086",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.335 30.73 86.531 30.616 86.529 31.229 86.333 31.343 86.335 30.73",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.879 33.109 88.074 32.996 88.072 33.61 87.877 33.724 87.879 33.109",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.333 31.343 86.529 31.229 87.701 31.906 87.505 32.02 86.333 31.343",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.337 29.985 86.533 29.872 86.531 30.486 86.336 30.6 86.337 29.985",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.881 32.366 88.076 32.253 88.075 32.866 87.879 32.98 87.881 32.366",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.336 30.6 86.531 30.486 87.703 31.163 87.508 31.277 86.336 30.6",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.34 29.242 86.535 29.129 86.533 29.742 86.338 29.855 86.34 29.242",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.883 31.623 88.078 31.51 88.077 32.123 87.881 32.237 87.883 31.623",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.338 29.855 86.533 29.742 87.705 30.418 87.51 30.532 86.338 29.855",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.342 28.499 86.537 28.386 86.535 28.999 86.34 29.113 86.342 28.499",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.885 30.879 88.08 30.765 88.079 31.38 87.883 31.494 87.885 30.879",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.34 29.113 86.535 28.999 87.707 29.676 87.512 29.789 86.34 29.113",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.344 27.755 86.539 27.641 86.538 28.256 86.342 28.37 86.344 27.755",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.887 30.136 88.082 30.022 88.081 30.635 87.886 30.749 87.887 30.136",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.342 28.37 86.538 28.256 87.71 28.933 87.514 29.046 86.342 28.37",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.346 27.012 86.541 26.898 86.54 27.511 86.344 27.625 86.346 27.012",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.889 29.393 88.085 29.279 88.083 29.892 87.888 30.006 87.889 29.393",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.869 36.697 88.064 36.584 93.92 39.938 93.724 40.051 87.869 36.697",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.344 27.625 86.54 27.511 87.712 28.188 87.516 28.302 86.344 27.625",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.348 26.269 86.543 26.155 86.542 26.769 86.346 26.882 86.348 26.269",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.891 28.648 88.087 28.535 88.085 29.15 87.89 29.263 87.891 28.648",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.871 35.954 88.066 35.841 93.922 39.195 93.726 39.308 87.871 35.954",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.346 26.882 86.542 26.769 87.714 27.445 87.518 27.559 86.346 26.882",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.101 39.655 94.297 39.542 94.295 40.155 94.1 40.268 94.101 39.655",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.893 27.906 88.089 27.792 88.087 28.405 87.892 28.519 87.893 27.906",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.873 35.21 88.068 35.096 93.924 38.45 93.728 38.564 87.873 35.21",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.104 38.91 94.299 38.797 94.297 39.412 94.102 39.525 94.104 38.91",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.1 40.268 94.295 40.155 95.59 40.902 95.394 41.016 94.1 40.268",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.896 27.162 88.091 27.049 88.089 27.662 87.894 27.776 87.896 27.162",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.875 34.467 88.07 34.353 93.926 37.707 93.731 37.821 87.875 34.467",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.106 38.167 94.301 38.054 94.299 38.667 94.104 38.781 94.106 38.167",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.102 39.525 94.297 39.412 95.592 40.159 95.397 40.273 94.102 39.525",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.877 33.724 88.072 33.61 93.928 36.964 93.733 37.078 87.877 33.724",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.108 37.424 94.303 37.311 94.301 37.924 94.106 38.038 94.108 37.424",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.104 38.781 94.299 38.667 95.594 39.415 95.399 39.528 94.104 38.781",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.879 32.98 88.075 32.866 93.93 36.22 93.735 36.333 87.879 32.98",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.11 36.68 94.305 36.566 94.304 37.181 94.108 37.295 94.11 36.68",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.106 38.038 94.301 37.924 95.596 38.672 95.401 38.785 94.106 38.038",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.881 32.237 88.077 32.123 93.932 35.477 93.737 35.59 87.881 32.237",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.112 35.937 94.308 35.823 94.306 36.437 94.11 36.55 94.112 35.937",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.108 37.295 94.304 37.181 95.598 37.929 95.403 38.042 94.108 37.295",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.883 31.494 88.079 31.38 93.934 34.734 93.739 34.848 87.883 31.494",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.114 35.194 94.31 35.081 94.308 35.694 94.112 35.807 94.114 35.194",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.11 36.55 94.306 36.437 95.6 37.184 95.405 37.298 94.11 36.55",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.886 30.749 88.081 30.635 93.936 33.989 93.741 34.103 87.886 30.749",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.116 34.45 94.312 34.336 94.31 34.951 94.114 35.064 94.116 34.45",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.112 35.807 94.308 35.694 95.602 36.441 95.407 36.555 94.112 35.807",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.888 30.006 88.083 29.892 93.938 33.247 93.743 33.36 87.888 30.006",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.118 33.707 94.314 33.593 94.312 34.206 94.117 34.32 94.118 33.707",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.114 35.064 94.31 34.951 95.604 35.698 95.409 35.812 94.114 35.064",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.89 29.263 88.085 29.15 93.941 32.504 93.745 32.617 87.89 29.263",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.121 32.964 94.316 32.85 94.314 33.463 94.119 33.577 94.121 32.964",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.117 34.32 94.312 34.206 95.607 34.954 95.411 35.067 94.117 34.32",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.892 28.519 88.087 28.405 93.943 31.759 93.747 31.872 87.892 28.519",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.123 32.219 94.318 32.106 94.316 32.72 94.121 32.834 94.123 32.219",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.119 33.577 94.314 33.463 95.609 34.211 95.413 34.324 94.119 33.577",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "87.894 27.776 88.089 27.662 93.945 31.016 93.749 31.129 87.894 27.776",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.125 31.476 94.32 31.363 94.318 31.976 94.123 32.09 94.125 31.476",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.121 32.834 94.316 32.72 95.611 33.468 95.415 33.581 94.121 32.834",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.127 30.733 94.322 30.62 94.32 31.233 94.125 31.347 94.127 30.733",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.123 32.09 94.318 31.976 95.613 32.723 95.418 32.836 94.123 32.09",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.125 31.347 94.32 31.233 95.615 31.98 95.42 32.094 94.125 31.347",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "86.145 25.373 86.34 25.259 95.823 30.708 95.628 30.821 86.145 25.373",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.145,25.373l-.031,11.364L95.6,42.185l.031-11.364Zm1.348,11.108L86.321,35.8l0-.613,1.172.677Zm0-.743-1.172-.677,0-.615,1.172.677Zm0-.745-1.172-.677,0-.613,1.172.677Zm0-.743-1.172-.677,0-.613,1.172.677Zm0-.743-1.172-.677,0-.614,1.172.676Zm0-.745-1.172-.676,0-.613,1.172.676Zm0-.742-1.172-.677,0-.613,1.172.677Zm0-.743L86.336,30.6v-.615l1.173.677Zm0-.745-1.172-.677,0-.613,1.172.677Zm0-.743-1.172-.676,0-.614,1.172.677Zm0-.743-1.172-.676,0-.615,1.172.677Zm0-.744-1.172-.677,0-.613,1.172.677Zm0-.743-1.172-.677,0-.613,1.172.677Zm6.206,12.492L87.869,36.7v-.613l5.856,3.354Zm0-.743-5.855-3.354V35.34l5.856,3.354Zm0-.744L87.873,35.21l0-.613,5.855,3.354Zm0-.743-5.856-3.354,0-.613,5.855,3.354Zm0-.743-5.856-3.354,0-.615,5.855,3.354Zm0-.745L87.879,32.98l0-.614,5.855,3.354Zm0-.743-5.856-3.353,0-.614,5.855,3.354Zm0-.742-5.856-3.355,0-.614,5.856,3.354Zm0-.745-5.855-3.354v-.613l5.856,3.354Zm0-.743-5.855-3.354v-.613l5.856,3.354Zm0-.743L87.89,29.263v-.615L93.747,32Zm0-.745-5.855-3.353v-.613l5.856,3.353Zm0-.743-5.855-3.353,0-.614,5.855,3.354Zm1.645,9.887L94.1,40.268v-.613l1.3.747Zm0-.743-1.3-.748,0-.614,1.294.747Zm0-.745-1.3-.747,0-.614,1.294.748Zm0-.743-1.3-.747,0-.614,1.294.748Zm0-.743-1.3-.747,0-.615,1.294.748Zm0-.744-1.3-.748,0-.613,1.3.748Zm0-.743-1.3-.748,0-.613,1.3.748Zm0-.743-1.3-.748,0-.614,1.3.747Zm0-.745-1.294-.747v-.613l1.3.747Zm0-.743-1.294-.747,0-.613,1.294.747Zm0-.743-1.294-.747,0-.615,1.294.747Zm0-.745-1.3-.746,0-.614,1.294.747Zm0-.742-1.3-.747,0-.614,1.294.748Z",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.628 30.821 95.823 30.708 95.792 42.071 95.597 42.185 95.628 30.821",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.205 64.394 95.273 77.299 83.186 70.029 83.22 57.417 95.205 64.394",
    style: {
      fill: "#97c6de"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.212 69.425 83.468 69.277 83.466 70.079 83.21 70.228 83.212 69.425",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.21 70.228 83.466 70.079 84.999 70.965 84.744 71.113 83.21 70.228",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.215 68.451 83.471 68.302 83.468 69.107 83.213 69.255 83.215 68.451",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.213 69.255 83.468 69.107 85.002 69.992 84.747 70.141 83.213 69.255",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.218 67.479 83.473 67.33 83.471 68.132 83.216 68.281 83.218 67.479",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.238 70.595 85.493 70.446 85.491 71.249 85.236 71.397 85.238 70.595",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.216 68.281 83.471 68.132 85.005 69.018 84.749 69.167 83.216 68.281",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.221 66.507 83.476 66.358 83.474 67.16 83.218 67.309 83.221 66.507",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.241 69.62 85.496 69.472 85.494 70.276 85.238 70.425 85.241 69.62",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.218 67.309 83.474 67.16 85.008 68.046 84.752 68.194 83.218 67.309",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.223 65.532 83.479 65.384 83.477 66.188 83.221 66.337 83.223 65.532",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.243 68.648 85.499 68.499 85.497 69.302 85.241 69.45 85.243 68.648",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.221 66.337 83.477 66.188 85.011 67.073 84.755 67.222 83.221 66.337",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.226 64.559 83.482 64.411 83.48 65.214 83.224 65.362 83.226 64.559",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.246 67.676 85.502 67.527 85.5 68.33 85.244 68.478 85.246 67.676",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.224 65.362 83.48 65.214 85.013 66.099 84.758 66.248 83.224 65.362",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.229 63.587 83.485 63.439 83.482 64.241 83.227 64.39 83.229 63.587",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.249 66.701 85.505 66.553 85.502 67.358 85.247 67.506 85.249 66.701",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.227 64.39 83.482 64.241 85.016 65.127 84.76 65.275 83.227 64.39",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.232 62.613 83.487 62.465 83.485 63.269 83.229 63.418 83.232 62.613",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.252 65.729 85.507 65.58 85.505 66.383 85.249 66.531 85.252 65.729",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.229 63.418 83.485 63.269 85.019 64.154 84.763 64.303 83.229 63.418",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.234 61.64 83.49 61.492 83.488 62.295 83.232 62.443 83.234 61.64",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.254 64.757 85.51 64.608 85.508 65.41 85.252 65.559 85.254 64.757",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.232 62.443 83.488 62.295 85.022 63.18 84.766 63.329 83.232 62.443",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.237 60.668 83.493 60.52 83.49 61.322 83.235 61.47 83.237 60.668",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.257 63.782 85.513 63.634 85.51 64.438 85.255 64.587 85.257 63.782",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.235 61.47 83.49 61.322 85.024 62.208 84.769 62.356 83.235 61.47",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.24 59.694 83.496 59.545 83.493 60.35 83.238 60.498 83.24 59.694",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.26 62.81 85.515 62.661 85.513 63.464 85.258 63.612 85.26 62.81",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.238 60.498 83.493 60.35 85.027 61.236 84.772 61.384 83.238 60.498",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.243 58.722 83.498 58.573 83.496 59.376 83.241 59.524 83.243 58.722",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.263 61.838 85.518 61.689 85.516 62.492 85.26 62.64 85.263 61.838",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.236 71.397 85.491 71.249 93.154 75.638 92.899 75.786 85.236 71.397",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.241 59.524 83.496 59.376 85.03 60.261 84.774 60.409 83.241 59.524",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.245 57.749 83.501 57.601 83.499 58.403 83.243 58.552 83.245 57.749",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.265 60.864 85.521 60.715 85.519 61.519 85.263 61.668 85.265 60.864",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.238 70.425 85.494 70.276 93.157 74.665 92.901 74.814 85.238 70.425",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.243 58.552 83.499 58.403 85.033 59.288 84.777 59.437 83.243 58.552",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.393 75.268 93.648 75.119 93.646 75.922 93.39 76.07 93.393 75.268",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.268 59.891 85.524 59.743 85.522 60.545 85.266 60.694 85.268 59.891",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.241 69.45 85.497 69.302 93.16 73.691 92.904 73.84 85.241 69.45",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.395 74.294 93.651 74.145 93.649 74.95 93.393 75.098 93.395 74.294",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.39 76.07 93.646 75.922 95.34 76.9 95.084 77.049 93.39 76.07",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.271 58.918 85.527 58.77 85.524 59.573 85.269 59.721 85.271 58.918",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.244 68.478 85.5 68.33 93.163 72.719 92.907 72.868 85.244 68.478",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.398 73.321 93.654 73.173 93.652 73.975 93.396 74.124 93.398 73.321",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.393 75.098 93.649 74.95 95.343 75.928 95.087 76.076 93.393 75.098",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.247 67.506 85.502 67.358 93.165 71.747 92.91 71.895 85.247 67.506",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.401 72.349 93.656 72.2 93.654 73.003 93.399 73.151 93.401 72.349",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.396 74.124 93.652 73.975 95.346 74.953 95.09 75.102 93.396 74.124",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.249 66.531 85.505 66.383 93.168 70.772 92.912 70.921 85.249 66.531",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.404 71.375 93.659 71.226 93.657 72.03 93.401 72.179 93.404 71.375",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.399 73.151 93.654 73.003 95.348 73.981 95.093 74.13 93.399 73.151",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.252 65.559 85.508 65.41 93.171 69.8 92.915 69.949 85.252 65.559",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.407 70.402 93.662 70.254 93.66 71.056 93.404 71.205 93.407 70.402",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.401 72.179 93.657 72.03 95.351 73.009 95.096 73.157 93.401 72.179",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.255 64.587 85.51 64.438 93.174 68.828 92.918 68.976 85.255 64.587",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.409 69.43 93.665 69.281 93.662 70.084 93.407 70.232 93.409 69.43",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.404 71.205 93.66 71.056 95.354 72.034 95.098 72.183 93.404 71.205",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.258 63.612 85.513 63.464 93.176 67.853 92.921 68.002 85.258 63.612",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.412 68.456 93.668 68.307 93.665 69.111 93.41 69.26 93.412 68.456",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.407 70.232 93.662 70.084 95.357 71.062 95.101 71.211 93.407 70.232",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.26 62.64 85.516 62.492 93.179 66.881 92.923 67.029 85.26 62.64",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.415 67.483 93.67 67.335 93.668 68.137 93.412 68.286 93.415 67.483",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.41 69.26 93.665 69.111 95.359 70.09 95.104 70.238 93.41 69.26",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.263 61.668 85.519 61.519 93.182 65.909 92.926 66.057 85.263 61.668",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.417 66.511 93.673 66.362 93.671 67.165 93.415 67.313 93.417 66.511",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.412 68.286 93.668 68.137 95.362 69.115 95.107 69.264 93.412 68.286",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.266 60.694 85.522 60.545 93.185 64.934 92.929 65.083 85.266 60.694",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.42 65.537 93.676 65.388 93.674 66.192 93.418 66.341 93.42 65.537",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.415 67.313 93.671 67.165 95.365 68.143 95.109 68.291 93.415 67.313",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "85.269 59.721 85.524 59.573 93.188 63.962 92.932 64.11 85.269 59.721",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.423 64.564 93.678 64.416 93.676 65.218 93.421 65.367 93.423 64.564",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.418 66.341 93.674 66.192 95.368 67.17 95.112 67.319 93.418 66.341",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.426 63.592 93.681 63.443 93.679 64.246 93.424 64.394 93.426 63.592",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.421 65.367 93.676 65.218 95.37 66.196 95.115 66.345 93.421 65.367",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.424 64.394 93.679 64.246 95.373 65.224 95.118 65.372 93.424 64.394",
    style: {
      fill: "#767189"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "82.979 56.577 83.235 56.428 95.646 63.558 95.39 63.707 82.979 56.577",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.979,56.577l-.04,14.872,12.411,7.13.04-14.872Zm1.765,14.536-1.534-.885,0-.8,1.534.886Zm0-.972-1.534-.886,0-.8,1.534.886Zm0-.974-1.533-.886,0-.8,1.534.885Zm0-.973-1.534-.885,0-.8,1.533.885Zm0-.972-1.534-.885,0-.805,1.534.886Zm0-.974-1.534-.886,0-.8,1.534.886Zm0-.973-1.533-.885,0-.8,1.534.886Zm0-.972-1.534-.885,0-.8,1.533.885Zm0-.974-1.534-.886,0-.8,1.534.886Zm0-.973-1.534-.886,0-.8,1.534.886Zm0-.972L83.238,60.5l0-.8,1.534.885Zm0-.975-1.533-.885,0-.8,1.533.885Zm0-.972-1.534-.885,0-.8,1.534.886ZM92.9,75.786,85.236,71.4l0-.8L92.9,74.984Zm0-.972-7.663-4.389,0-.8L92.9,74.01Zm0-.974-7.663-4.39,0-.8,7.663,4.39Zm0-.972-7.663-4.39,0-.8,7.663,4.389Zm0-.973-7.663-4.389,0-.805,7.663,4.39Zm0-.974-7.663-4.39,0-.8,7.663,4.389Zm0-.972-7.663-4.39,0-.8,7.664,4.389Zm0-.973-7.663-4.389,0-.805,7.663,4.39Zm0-.974-7.663-4.39,0-.8L92.923,67.2Zm0-.973L85.26,62.64l0-.8,7.663,4.389Zm0-.972-7.663-4.389,0-.8,7.663,4.389Zm0-.974-7.663-4.389,0-.8,7.663,4.389Zm0-.973-7.663-4.389,0-.8,7.663,4.39Zm2.152,12.939L93.39,76.07l0-.8,1.694.978Zm0-.973L93.393,75.1l0-.8,1.694.978Zm0-.974L93.4,74.124l0-.8,1.694.979Zm0-.972L93.4,73.151l0-.8,1.694.978Zm0-.973-1.7-.978,0-.8,1.694.977Zm0-.974L93.4,71.205l0-.8,1.694.978Zm0-.972-1.694-.979,0-.8,1.694.978Zm0-.973L93.41,69.26l0-.8,1.694.978Zm0-.974-1.695-.978,0-.8,1.694.978Zm0-.973-1.694-.978,0-.8,1.695.978Zm0-.972-1.694-.978,0-.8,1.694.979Zm0-.974-1.694-.978,0-.8,1.694.978Zm0-.973-1.694-.978,0-.8,1.694.978Z",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.39 63.707 95.646 63.558 95.605 78.43 95.35 78.579 95.39 63.707",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.983 16.965 90.992 20.294 96.222 17.274 96.213 13.945 90.983 16.965",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.213 13.945 96.222 17.274 101.419 20.294 101.41 16.965 96.213 13.945",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.972 17.681 96.168 20.701 101.399 17.681 96.202 14.662 90.972 17.681",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.176 20.567 96.185 23.897 102.425 20.294 102.416 16.965 96.176 20.567",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.976 16.965 89.986 20.294 96.185 23.897 96.176 20.567 89.976 16.965",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.976,16.965l6.2,3.6,6.24-3.6-6.2-3.6Zm1.007,0,5.23-3.02,5.2,3.02-5.231,3.02Z",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.632 17.995 100.642 21.326 101.534 20.811 101.525 17.479 100.632 17.995",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "101.525 17.479 101.534 20.811 102.425 20.296 102.416 16.965 101.525 17.479",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.958 19.539 97.967 22.87 98.86 22.355 98.85 19.023 97.958 19.539",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.85 19.023 98.86 22.355 99.751 21.84 99.741 18.509 98.85 19.023",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "99.741 18.509 99.751 21.84 100.642 21.326 100.632 17.995 99.741 18.509",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.067 20.053 97.076 23.385 97.967 22.87 97.958 19.539 97.067 20.053",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "96.176 20.567 96.185 23.899 97.076 23.385 97.067 20.053 96.176 20.567",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.314 20.053 95.305 23.386 96.196 23.9 96.205 20.567 95.314 20.053",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "93.531 19.023 93.521 22.356 94.413 22.871 94.422 19.538 93.531 19.023",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "94.422 19.538 94.413 22.871 95.305 23.386 95.314 20.053 94.422 19.538",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.965 16.965 89.956 20.298 90.847 20.812 90.856 17.479 89.965 16.965",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "90.856 17.479 90.847 20.812 91.738 21.327 91.747 17.994 90.856 17.479",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "91.747 17.994 91.738 21.327 92.63 21.842 92.64 18.509 91.747 17.994",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "92.64 18.509 92.63 21.842 93.521 22.356 93.531 19.023 92.64 18.509",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "97.737 15.58 97.735 15.041 97.735 15.041 97.735 13.848 95.642 15.056 95.642 16.257 95.643 16.256 95.644 16.788 97.737 15.58",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.644 16.788 95.643 16.25 95.642 16.249 95.642 15.056 94.207 14.223 94.208 15.423 94.209 15.424 94.21 15.955 95.644 16.788",
    style: {
      fill: "#ebe7dd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "95.036 16.451 95.035 15.286 94.486 14.967 94.487 16.131 95.036 16.451",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.207,14.223l1.435.833,2.093-1.208L96.3,13.014Z",
    style: {
      fill: "#418ab7"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "133.247 214.953 230.425 158.766 111.713 90.081 14.534 146.269 133.247 214.953",
    style: {
      fill: "#00233b",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.247 204.798 230.425 148.611 111.713 79.927 14.534 136.114 133.247 204.798",
    style: {
      fill: "#c8e6ed"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.247 204.798 133.247 206.731 230.425 150.537 230.425 148.611 133.247 204.798",
    style: {
      fill: "#63aac0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "133.247 206.731 14.534 138.043 14.534 136.114 133.247 204.798 133.247 206.731",
    style: {
      fill: "#7cc5d2"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "102.86 114.336 169.446 152.78 213.837 127.151 147.251 88.707 102.86 114.336",
    style: {
      fill: "#00233b",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.86 106.67 169.446 145.114 213.837 119.485 147.251 81.041 102.86 106.67",
    style: {
      fill: "#55c1fc"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.446 145.837 169.446 145.114 213.837 119.485 213.837 120.208 169.446 145.837",
    style: {
      fill: "#558fbc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.5,66.458l-58.29-33.591a3.41,3.41,0,0,0-5.112,2.954V81.179l65.515,37.755.395,1.047.738-.394V72.075A6.484,6.484,0,0,0,210.5,66.458Z",
    style: {
      fill: "#84caf0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "169.446 145.837 102.86 107.393 102.86 106.67 169.446 145.114 169.446 145.837",
    style: {
      fill: "#558fbc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213,119.981,146.355,81.574V36.216a3.409,3.409,0,0,1,5.112-2.954l58.29,33.591A6.483,6.483,0,0,1,213,72.469Z",
    style: {
      fill: "#55c1fc"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.561 116.787 148.797 81.194 148.797 34.918 210.561 70.511 210.561 116.787",
    style: {
      fill: "#f5fbff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M150.086,90.252l-4.209-2.434c-.187-.109-.139-.311.106-.452l1.829-1.055a.88.88,0,0,1,.782-.061l4.209,2.435c.187.108.14.31-.1.452l-1.83,1.055A.883.883,0,0,1,150.086,90.252Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.369,93.308l-4.209-2.435c-.187-.108-.14-.31.1-.451l1.83-1.055a.88.88,0,0,1,.782-.061l4.209,2.435c.186.108.139.311-.106.452l-1.829,1.055A.883.883,0,0,1,155.369,93.308Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.651,96.364l-4.209-2.435c-.187-.108-.139-.31.106-.451l1.829-1.056a.883.883,0,0,1,.782-.06l4.209,2.435c.187.108.14.31-.1.452l-1.83,1.055A.883.883,0,0,1,160.651,96.364Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.934,99.42l-4.209-2.435c-.187-.108-.14-.31.105-.451l1.83-1.055a.88.88,0,0,1,.782-.061l4.209,2.435c.187.108.14.31-.105.452l-1.83,1.055A.883.883,0,0,1,165.934,99.42Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.216,102.476l-4.209-2.435c-.186-.108-.139-.31.106-.451l1.83-1.056a.883.883,0,0,1,.782-.06l4.208,2.435c.187.108.14.31-.1.452L172,102.416A.883.883,0,0,1,171.216,102.476Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.5,105.532,172.29,103.1c-.187-.108-.14-.31.105-.451l1.83-1.056a.883.883,0,0,1,.782-.06l4.209,2.435c.187.108.14.31-.105.452l-1.83,1.055A.883.883,0,0,1,176.5,105.532Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.782,108.588l-4.209-2.435c-.187-.108-.14-.31.1-.451l1.83-1.056a.881.881,0,0,1,.781-.06l4.209,2.435c.187.108.14.31-.1.452l-1.83,1.055A.881.881,0,0,1,181.782,108.588Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.064,111.644l-4.209-2.435c-.187-.108-.14-.31.106-.451l1.829-1.056a.883.883,0,0,1,.782-.06l4.209,2.435c.187.108.14.31-.105.452l-1.83,1.055A.883.883,0,0,1,187.064,111.644Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.347,114.7l-4.209-2.435c-.187-.108-.14-.31.1-.451l1.83-1.056a.883.883,0,0,1,.782-.06l4.209,2.435c.186.108.139.31-.106.452l-1.829,1.055A.883.883,0,0,1,192.347,114.7Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.629,117.756l-4.209-2.435c-.187-.108-.14-.31.106-.451l1.829-1.056a.883.883,0,0,1,.782-.06l4.209,2.435c.187.108.14.31-.1.452l-1.83,1.055A.883.883,0,0,1,197.629,117.756Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.912,120.812l-4.209-2.435c-.187-.108-.14-.31.1-.451l1.83-1.056a.883.883,0,0,1,.782-.06l4.209,2.435c.187.108.139.31-.106.452l-1.829,1.055A.883.883,0,0,1,202.912,120.812Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.333,92.9l-4.045-2.34c-.232-.134-.174-.385.13-.561l3.086-1.779a1.093,1.093,0,0,1,.971-.075l4.045,2.34c.232.135.174.386-.131.561l-3.085,1.78A1.093,1.093,0,0,1,145.333,92.9Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.616,95.955l-4.046-2.34c-.232-.134-.173-.385.131-.561l3.085-1.779a1.093,1.093,0,0,1,.971-.075l4.046,2.34c.232.135.173.386-.131.561l-3.085,1.78A1.1,1.1,0,0,1,150.616,95.955Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.9,99.011l-4.045-2.34c-.232-.134-.173-.385.131-.561l3.085-1.779a1.093,1.093,0,0,1,.971-.075l4.045,2.34c.232.135.174.386-.13.561l-3.086,1.78A1.093,1.093,0,0,1,155.9,99.011Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.181,102.067l-4.046-2.34c-.232-.134-.173-.385.131-.561l3.086-1.779a1.091,1.091,0,0,1,.97-.075l4.046,2.34c.232.135.173.386-.131.561l-3.085,1.78A1.1,1.1,0,0,1,161.181,102.067Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.464,105.123l-4.046-2.34c-.232-.134-.174-.385.131-.561l3.085-1.779a1.093,1.093,0,0,1,.971-.075l4.045,2.34c.232.135.174.386-.13.561l-3.086,1.78A1.091,1.091,0,0,1,166.464,105.123Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.746,108.179l-4.046-2.34c-.232-.134-.173-.385.131-.561l3.086-1.779a1.091,1.091,0,0,1,.97-.075l4.046,2.34c.232.134.173.386-.131.561l-3.085,1.78A1.1,1.1,0,0,1,171.746,108.179Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.029,111.235l-4.046-2.34c-.232-.134-.173-.385.131-.561l3.085-1.779a1.093,1.093,0,0,1,.971-.075l4.045,2.34c.232.135.174.386-.13.561L178,111.161A1.094,1.094,0,0,1,177.029,111.235Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.311,114.291l-4.045-2.34c-.232-.134-.174-.385.13-.561l3.086-1.779a1.091,1.091,0,0,1,.97-.075l4.046,2.34c.232.134.173.386-.131.561l-3.085,1.78A1.1,1.1,0,0,1,182.311,114.291Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.594,117.347l-4.046-2.34c-.232-.134-.173-.385.131-.561l3.085-1.779a1.093,1.093,0,0,1,.971-.075l4.046,2.34c.232.135.173.385-.131.561l-3.086,1.78A1.094,1.094,0,0,1,187.594,117.347Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.876,120.4l-4.045-2.34c-.232-.134-.174-.385.131-.561l3.085-1.779a1.093,1.093,0,0,1,.971-.075l4.045,2.34c.232.134.174.386-.131.561l-3.085,1.78A1.1,1.1,0,0,1,192.876,120.4Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.159,123.459l-4.046-2.34c-.232-.134-.173-.385.131-.561l3.086-1.78a1.094,1.094,0,0,1,.97-.074l4.046,2.34c.232.134.173.385-.131.561l-3.085,1.78A1.1,1.1,0,0,1,198.159,123.459Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.662,95.594l-4.045-2.341c-.232-.134-.174-.385.13-.56l3.086-1.78a1.1,1.1,0,0,1,.97-.075l4.046,2.341c.232.134.173.385-.131.56l-3.085,1.78A1.1,1.1,0,0,1,140.662,95.594Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.945,98.65,141.9,96.309c-.232-.134-.173-.385.131-.56l3.085-1.78a1.1,1.1,0,0,1,.971-.075l4.045,2.341c.232.134.174.385-.13.56l-3.086,1.78A1.1,1.1,0,0,1,145.945,98.65Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.227,101.706l-4.045-2.341c-.232-.134-.174-.385.13-.56l3.086-1.78a1.1,1.1,0,0,1,.97-.075l4.046,2.341c.232.134.174.385-.131.56l-3.085,1.78A1.1,1.1,0,0,1,151.227,101.706Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.51,104.762l-4.046-2.341c-.232-.134-.173-.385.131-.56l3.085-1.78a1.094,1.094,0,0,1,.971-.075l4.046,2.341c.232.134.173.385-.131.56l-3.086,1.78A1.1,1.1,0,0,1,156.51,104.762Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.792,107.818l-4.045-2.341c-.232-.134-.174-.385.13-.56l3.086-1.78a1.1,1.1,0,0,1,.971-.075l4.045,2.341c.232.134.173.385-.131.56l-3.085,1.78A1.1,1.1,0,0,1,161.792,107.818Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.075,110.873l-4.046-2.34c-.232-.134-.173-.385.131-.56l3.085-1.78a1.094,1.094,0,0,1,.971-.075l4.046,2.341c.232.134.173.385-.131.56l-3.085,1.78A1.093,1.093,0,0,1,167.075,110.873Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.357,113.93l-4.045-2.341c-.232-.134-.174-.385.131-.56l3.085-1.78a1.1,1.1,0,0,1,.971-.075l4.045,2.341c.232.134.174.385-.13.56l-3.086,1.78A1.1,1.1,0,0,1,172.357,113.93Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.64,116.985l-4.046-2.34c-.231-.134-.173-.385.131-.561l3.086-1.779a1.091,1.091,0,0,1,.97-.075l4.046,2.341c.232.134.173.385-.131.56l-3.085,1.78A1.093,1.093,0,0,1,177.64,116.985Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.923,120.042l-4.046-2.341c-.232-.134-.173-.385.131-.56l3.085-1.78a1.093,1.093,0,0,1,.971-.075l4.045,2.341c.232.134.174.385-.13.56l-3.086,1.78A1.1,1.1,0,0,1,182.923,120.042Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.205,123.1l-4.045-2.34c-.233-.134-.174-.385.13-.561l3.086-1.779a1.091,1.091,0,0,1,.97-.075l4.046,2.341c.232.134.173.385-.131.56l-3.085,1.78A1.093,1.093,0,0,1,188.205,123.1Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.488,126.154l-4.046-2.341c-.232-.134-.173-.385.131-.56l3.085-1.78a1.094,1.094,0,0,1,.971-.075l4.046,2.341c.231.134.173.385-.131.56l-3.086,1.78A1.1,1.1,0,0,1,193.488,126.154Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.991,98.288l-4.046-2.34c-.232-.135-.173-.386.131-.561l3.085-1.78a1.093,1.093,0,0,1,.971-.074l4.046,2.34c.232.134.173.385-.131.561l-3.085,1.779A1.094,1.094,0,0,1,135.991,98.288Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.273,101.344,137.228,99c-.232-.134-.173-.385.131-.56l3.085-1.78a1.1,1.1,0,0,1,.971-.074l4.045,2.34c.232.134.174.385-.13.561l-3.086,1.779A1.093,1.093,0,0,1,141.273,101.344Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.556,104.4l-4.046-2.34c-.232-.135-.173-.386.131-.561l3.086-1.78a1.091,1.091,0,0,1,.97-.074l4.046,2.34c.232.134.173.385-.131.561l-3.085,1.779A1.094,1.094,0,0,1,146.556,104.4Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.839,107.456l-4.046-2.341c-.232-.134-.174-.385.131-.56l3.085-1.78a1.093,1.093,0,0,1,.971-.074l4.046,2.34c.231.134.173.385-.131.561l-3.086,1.779A1.091,1.091,0,0,1,151.839,107.456Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.121,110.512l-4.045-2.34c-.232-.135-.174-.386.13-.561l3.086-1.78a1.091,1.091,0,0,1,.97-.074l4.046,2.34c.232.134.173.385-.131.561l-3.085,1.779A1.093,1.093,0,0,1,157.121,110.512Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.4,113.568l-4.046-2.341c-.232-.134-.173-.385.131-.56l3.085-1.78a1.093,1.093,0,0,1,.971-.074l4.045,2.34c.232.134.174.385-.13.56l-3.086,1.78A1.091,1.091,0,0,1,162.4,113.568Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.686,116.624l-4.045-2.341c-.232-.134-.174-.385.13-.56l3.086-1.78a1.091,1.091,0,0,1,.97-.074l4.046,2.34c.232.134.174.385-.131.561l-3.085,1.779A1.093,1.093,0,0,1,167.686,116.624Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.969,119.68l-4.046-2.341c-.232-.134-.173-.385.131-.56l3.085-1.78a1.1,1.1,0,0,1,.971-.075l4.046,2.341c.232.134.173.385-.131.56l-3.086,1.78A1.091,1.091,0,0,1,172.969,119.68Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.251,122.736l-4.045-2.341c-.232-.134-.174-.385.13-.56l3.086-1.78a1.093,1.093,0,0,1,.971-.074l4.045,2.34c.232.134.174.385-.131.561l-3.085,1.779A1.093,1.093,0,0,1,178.251,122.736Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.534,125.792l-4.046-2.341c-.232-.134-.173-.385.131-.56l3.086-1.78a1.1,1.1,0,0,1,.97-.075l4.046,2.341c.232.134.173.385-.131.56l-3.085,1.78A1.1,1.1,0,0,1,183.534,125.792Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.817,128.848l-4.046-2.341c-.232-.134-.174-.385.131-.56l3.085-1.78a1.093,1.093,0,0,1,.971-.074l4.045,2.34c.232.134.174.385-.13.561l-3.086,1.779A1.091,1.091,0,0,1,188.817,128.848Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.32,100.982l-4.046-2.34c-.232-.134-.173-.385.131-.561L130.49,96.3a1.093,1.093,0,0,1,.971-.075l4.046,2.34c.232.134.173.385-.131.561l-3.086,1.779A1.091,1.091,0,0,1,131.32,100.982Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.6,104.038l-4.045-2.34c-.232-.134-.174-.385.13-.561l3.086-1.779a1.093,1.093,0,0,1,.971-.075l4.045,2.34c.232.135.174.386-.131.561l-3.085,1.78A1.1,1.1,0,0,1,136.6,104.038Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.885,107.094l-4.046-2.34c-.232-.134-.173-.385.131-.561l3.085-1.78a1.1,1.1,0,0,1,.971-.074l4.046,2.34c.232.134.173.385-.131.561l-3.086,1.779A1.091,1.091,0,0,1,141.885,107.094Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.167,110.15l-4.045-2.34c-.232-.134-.174-.385.13-.561l3.086-1.779a1.093,1.093,0,0,1,.971-.075l4.045,2.34c.232.135.174.385-.131.561l-3.085,1.78A1.1,1.1,0,0,1,147.167,110.15Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.45,113.206l-4.046-2.34c-.232-.134-.173-.385.131-.561l3.085-1.779a1.094,1.094,0,0,1,.971-.075l4.046,2.34c.232.134.173.385-.131.561l-3.085,1.779A1.093,1.093,0,0,1,152.45,113.206Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.732,116.262l-4.045-2.34c-.232-.134-.173-.385.131-.561l3.085-1.779a1.093,1.093,0,0,1,.971-.075l4.045,2.34c.232.134.174.385-.13.561l-3.086,1.78A1.1,1.1,0,0,1,157.732,116.262Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.015,119.318l-4.046-2.34c-.231-.134-.173-.386.131-.561l3.086-1.779a1.091,1.091,0,0,1,.97-.075l4.046,2.34c.232.134.173.385-.131.561l-3.085,1.779A1.094,1.094,0,0,1,163.015,119.318Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.3,122.374l-4.046-2.34c-.232-.135-.173-.385.131-.561l3.085-1.78a1.1,1.1,0,0,1,.971-.074l4.045,2.34c.232.134.174.385-.13.561l-3.086,1.779A1.091,1.091,0,0,1,168.3,122.374Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.58,125.43l-4.045-2.34c-.232-.134-.174-.385.13-.561l3.086-1.779a1.091,1.091,0,0,1,.97-.075l4.046,2.34c.232.134.173.385-.131.561l-3.085,1.779A1.093,1.093,0,0,1,173.58,125.43Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.863,128.486l-4.046-2.34c-.232-.135-.173-.385.131-.561l3.085-1.78a1.1,1.1,0,0,1,.971-.074l4.046,2.34c.231.134.173.385-.131.561l-3.086,1.779A1.091,1.091,0,0,1,178.863,128.486Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.145,131.542,180.1,129.2c-.232-.134-.174-.385.13-.561l3.086-1.779a1.091,1.091,0,0,1,.97-.075l4.046,2.34c.232.134.174.385-.131.561l-3.085,1.779A1.093,1.093,0,0,1,184.145,131.542Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.648,103.677l-4.045-2.341c-.232-.134-.173-.385.131-.56L125.819,99a1.093,1.093,0,0,1,.971-.075l4.045,2.341c.232.134.174.385-.13.56l-3.086,1.78A1.1,1.1,0,0,1,126.648,103.677Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.931,106.733l-4.046-2.341c-.232-.134-.173-.385.131-.56l3.086-1.78a1.1,1.1,0,0,1,.97-.075l4.046,2.341c.232.134.173.385-.131.56l-3.085,1.78A1.1,1.1,0,0,1,131.931,106.733Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.214,109.788l-4.046-2.34c-.232-.134-.173-.385.131-.56l3.085-1.78a1.093,1.093,0,0,1,.971-.075l4.046,2.341c.231.134.173.385-.131.56l-3.086,1.78A1.091,1.091,0,0,1,137.214,109.788Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.839,128.084l-30.319-17.54c-.27-.156-.2-.449.153-.653l2.9-1.674a1.273,1.273,0,0,1,1.132-.087l30.319,17.539c.271.157.2.449-.152.654l-2.9,1.674A1.276,1.276,0,0,1,168.839,128.084Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.192,131.18l-4.046-2.34c-.232-.134-.174-.385.131-.561l3.085-1.779a1.093,1.093,0,0,1,.971-.075l4.045,2.341c.232.134.174.385-.13.56l-3.086,1.78A1.091,1.091,0,0,1,174.192,131.18Z",
    style: {
      fill: "#2e7da2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.474,134.236l-4.046-2.34c-.231-.134-.173-.385.131-.561l3.086-1.779a1.091,1.091,0,0,1,.97-.075l4.046,2.34c.232.135.173.386-.131.561l-3.085,1.78A1.093,1.093,0,0,1,179.474,134.236Z",
    style: {
      fill: "#2e7da2"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M150.086,90.117l-4.209-2.434c-.187-.109-.139-.311.106-.452l1.829-1.055a.88.88,0,0,1,.782-.061L152.8,88.55c.187.108.14.31-.1.452l-1.83,1.055A.879.879,0,0,1,150.086,90.117Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.369,93.173l-4.209-2.435c-.187-.108-.14-.31.1-.451l1.83-1.055a.88.88,0,0,1,.782-.061l4.209,2.435c.186.108.139.311-.106.452l-1.829,1.055A.879.879,0,0,1,155.369,93.173Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.651,96.229,156.442,93.8c-.187-.109-.139-.311.106-.452l1.829-1.056a.883.883,0,0,1,.782-.06l4.209,2.435c.187.108.14.31-.1.452l-1.83,1.055A.879.879,0,0,1,160.651,96.229Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.934,99.285l-4.209-2.435c-.187-.108-.14-.31.105-.451l1.83-1.055a.88.88,0,0,1,.782-.061l4.209,2.435c.187.108.14.311-.105.452l-1.83,1.055A.883.883,0,0,1,165.934,99.285Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.216,102.341l-4.209-2.434c-.186-.109-.139-.311.106-.452l1.83-1.056a.883.883,0,0,1,.782-.06l4.208,2.435c.187.108.14.31-.1.452L172,102.281A.883.883,0,0,1,171.216,102.341Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.5,105.4l-4.209-2.435c-.187-.108-.14-.31.105-.451l1.83-1.055a.88.88,0,0,1,.782-.061l4.209,2.435c.187.108.14.31-.105.452l-1.83,1.055A.883.883,0,0,1,176.5,105.4Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.782,108.453l-4.209-2.435c-.187-.108-.14-.31.1-.451l1.83-1.056a.881.881,0,0,1,.781-.06l4.209,2.435c.187.108.14.31-.1.452l-1.83,1.055A.881.881,0,0,1,181.782,108.453Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.064,111.509l-4.209-2.435c-.187-.108-.14-.31.106-.451l1.829-1.056a.883.883,0,0,1,.782-.06l4.209,2.435c.187.108.14.31-.105.452l-1.83,1.055A.883.883,0,0,1,187.064,111.509Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.347,114.565l-4.209-2.435c-.187-.108-.14-.31.1-.451l1.83-1.056a.883.883,0,0,1,.782-.06L195.064,113c.186.108.139.31-.106.452l-1.829,1.055A.883.883,0,0,1,192.347,114.565Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.629,117.621l-4.209-2.435c-.187-.108-.14-.31.106-.451l1.829-1.056a.883.883,0,0,1,.782-.06l4.209,2.435c.187.108.14.31-.1.452l-1.83,1.055A.883.883,0,0,1,197.629,117.621Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.912,120.677l-4.209-2.435c-.187-.108-.14-.31.1-.451l1.83-1.056a.883.883,0,0,1,.782-.06l4.209,2.435c.187.108.139.31-.106.452l-1.829,1.055A.883.883,0,0,1,202.912,120.677Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.333,92.764l-4.045-2.34c-.232-.134-.174-.385.13-.561l3.086-1.779a1.093,1.093,0,0,1,.971-.075l4.045,2.34c.232.135.174.386-.131.561L146.3,92.69A1.093,1.093,0,0,1,145.333,92.764Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.616,95.82l-4.046-2.34c-.232-.134-.173-.385.131-.561l3.085-1.779a1.093,1.093,0,0,1,.971-.075l4.046,2.341c.232.134.173.385-.131.56l-3.085,1.78A1.093,1.093,0,0,1,150.616,95.82Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.9,98.876l-4.045-2.34c-.232-.134-.173-.385.131-.561l3.085-1.779a1.093,1.093,0,0,1,.971-.075l4.045,2.34c.232.135.174.386-.13.561l-3.086,1.78A1.093,1.093,0,0,1,155.9,98.876Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.181,101.932l-4.046-2.34c-.232-.134-.173-.385.131-.561l3.086-1.779a1.091,1.091,0,0,1,.97-.075l4.046,2.34c.232.135.173.386-.131.561l-3.085,1.78A1.1,1.1,0,0,1,161.181,101.932Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.464,104.988l-4.046-2.34c-.232-.134-.174-.385.131-.561l3.085-1.779a1.093,1.093,0,0,1,.971-.075l4.045,2.34c.232.135.174.386-.13.561l-3.086,1.78A1.091,1.091,0,0,1,166.464,104.988Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.746,108.044,167.7,105.7c-.232-.134-.173-.385.131-.561l3.086-1.779a1.091,1.091,0,0,1,.97-.075l4.046,2.34c.232.135.173.386-.131.561l-3.085,1.78A1.1,1.1,0,0,1,171.746,108.044Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.029,111.1l-4.046-2.34c-.232-.134-.173-.385.131-.561l3.085-1.779a1.093,1.093,0,0,1,.971-.075l4.045,2.34c.232.135.174.386-.13.561L178,111.026A1.091,1.091,0,0,1,177.029,111.1Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.311,114.156l-4.045-2.34c-.232-.134-.174-.385.13-.561l3.086-1.779a1.091,1.091,0,0,1,.97-.075l4.046,2.34c.232.134.173.386-.131.561l-3.085,1.78A1.1,1.1,0,0,1,182.311,114.156Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.594,117.212l-4.046-2.34c-.232-.134-.173-.385.131-.561l3.085-1.779a1.093,1.093,0,0,1,.971-.075l4.046,2.34c.232.135.173.386-.131.561l-3.086,1.78A1.094,1.094,0,0,1,187.594,117.212Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.876,120.268l-4.045-2.34c-.232-.134-.174-.385.131-.561l3.085-1.779a1.093,1.093,0,0,1,.971-.075l4.045,2.34c.232.134.174.386-.131.561l-3.085,1.78A1.1,1.1,0,0,1,192.876,120.268Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.159,123.324l-4.046-2.34c-.232-.134-.173-.385.131-.561l3.086-1.779a1.091,1.091,0,0,1,.97-.075l4.046,2.34c.232.135.173.385-.131.561l-3.085,1.78A1.1,1.1,0,0,1,198.159,123.324Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.662,95.459l-4.045-2.341c-.232-.134-.174-.385.13-.56l3.086-1.78a1.1,1.1,0,0,1,.97-.075l4.046,2.341c.232.134.173.385-.131.56l-3.085,1.78A1.1,1.1,0,0,1,140.662,95.459Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.945,98.515,141.9,96.174c-.232-.134-.173-.385.131-.56l3.085-1.78a1.1,1.1,0,0,1,.971-.075l4.045,2.341c.232.134.174.385-.13.56l-3.086,1.78A1.091,1.091,0,0,1,145.945,98.515Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.227,101.571l-4.045-2.341c-.232-.134-.174-.385.13-.56l3.086-1.78a1.1,1.1,0,0,1,.97-.075l4.046,2.341c.232.134.174.385-.131.56L152.2,101.5A1.1,1.1,0,0,1,151.227,101.571Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.51,104.627l-4.046-2.341c-.232-.134-.173-.385.131-.56l3.085-1.78a1.1,1.1,0,0,1,.971-.075l4.046,2.341c.232.134.173.385-.131.56l-3.086,1.78A1.1,1.1,0,0,1,156.51,104.627Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.792,107.683l-4.045-2.341c-.232-.134-.174-.385.13-.56l3.086-1.78a1.1,1.1,0,0,1,.971-.075l4.045,2.341c.232.134.173.385-.131.56l-3.085,1.78A1.1,1.1,0,0,1,161.792,107.683Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.075,110.739l-4.046-2.341c-.232-.134-.173-.385.131-.56l3.085-1.78a1.094,1.094,0,0,1,.971-.075l4.046,2.341c.232.134.173.385-.131.56l-3.085,1.78A1.1,1.1,0,0,1,167.075,110.739Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.357,113.8l-4.045-2.341c-.232-.134-.174-.385.131-.56l3.085-1.78a1.1,1.1,0,0,1,.971-.075l4.045,2.341c.232.134.174.385-.13.56l-3.086,1.78A1.1,1.1,0,0,1,172.357,113.8Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.64,116.851l-4.046-2.341c-.231-.134-.173-.385.131-.56l3.086-1.78a1.091,1.091,0,0,1,.97-.075l4.046,2.341c.232.134.173.385-.131.56l-3.085,1.78A1.1,1.1,0,0,1,177.64,116.851Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.923,119.907l-4.046-2.341c-.232-.134-.173-.385.131-.56l3.085-1.78a1.1,1.1,0,0,1,.971-.075l4.045,2.341c.232.134.174.385-.13.56l-3.086,1.78A1.1,1.1,0,0,1,182.923,119.907Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.205,122.963l-4.045-2.341c-.233-.134-.174-.385.13-.561l3.086-1.779a1.091,1.091,0,0,1,.97-.075l4.046,2.341c.232.134.173.385-.131.56l-3.085,1.78A1.1,1.1,0,0,1,188.205,122.963Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.488,126.019l-4.046-2.341c-.232-.134-.173-.385.131-.56l3.085-1.78a1.094,1.094,0,0,1,.971-.075l4.046,2.341c.231.134.173.385-.131.56l-3.086,1.78A1.1,1.1,0,0,1,193.488,126.019Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.991,98.153l-4.046-2.34c-.232-.135-.173-.386.131-.561l3.085-1.78a1.093,1.093,0,0,1,.971-.074l4.046,2.34c.232.134.173.385-.131.561l-3.085,1.779A1.094,1.094,0,0,1,135.991,98.153Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.273,101.209l-4.045-2.34c-.232-.135-.173-.385.131-.561l3.085-1.78a1.1,1.1,0,0,1,.971-.074l4.045,2.34c.232.134.174.385-.13.561l-3.086,1.779A1.093,1.093,0,0,1,141.273,101.209Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.556,104.265l-4.046-2.34c-.232-.135-.173-.386.131-.561l3.086-1.78a1.091,1.091,0,0,1,.97-.074l4.046,2.34c.232.134.173.385-.131.561l-3.085,1.779A1.094,1.094,0,0,1,146.556,104.265Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.839,107.321l-4.046-2.341c-.232-.134-.174-.385.131-.56l3.085-1.78a1.1,1.1,0,0,1,.971-.074l4.046,2.34c.231.134.173.385-.131.561l-3.086,1.779A1.091,1.091,0,0,1,151.839,107.321Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.121,110.377l-4.045-2.34c-.232-.135-.174-.386.13-.561l3.086-1.78a1.091,1.091,0,0,1,.97-.074l4.046,2.34c.232.134.173.385-.131.561l-3.085,1.779A1.093,1.093,0,0,1,157.121,110.377Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.4,113.433l-4.046-2.341c-.232-.134-.173-.385.131-.56l3.085-1.78a1.093,1.093,0,0,1,.971-.074l4.045,2.34c.232.134.174.385-.13.561l-3.086,1.779A1.091,1.091,0,0,1,162.4,113.433Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.686,116.489l-4.045-2.34c-.232-.135-.174-.386.13-.561l3.086-1.78a1.091,1.091,0,0,1,.97-.074l4.046,2.34c.232.134.174.385-.131.561l-3.085,1.779A1.093,1.093,0,0,1,167.686,116.489Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.969,119.545l-4.046-2.341c-.232-.134-.173-.385.131-.56l3.085-1.78a1.093,1.093,0,0,1,.971-.074l4.046,2.34c.232.134.173.385-.131.561l-3.086,1.779A1.091,1.091,0,0,1,172.969,119.545Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.251,122.6l-4.045-2.34c-.232-.135-.174-.386.13-.561l3.086-1.78a1.093,1.093,0,0,1,.971-.074l4.045,2.34c.232.134.174.385-.131.561l-3.085,1.779A1.093,1.093,0,0,1,178.251,122.6Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.534,125.657l-4.046-2.341c-.232-.134-.173-.385.131-.56l3.086-1.78a1.1,1.1,0,0,1,.97-.075l4.046,2.341c.232.134.173.385-.131.56l-3.085,1.78A1.094,1.094,0,0,1,183.534,125.657Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.817,128.713l-4.046-2.341c-.232-.134-.174-.385.131-.56l3.085-1.78a1.093,1.093,0,0,1,.971-.074L193,126.3c.232.134.174.385-.13.561l-3.086,1.779A1.091,1.091,0,0,1,188.817,128.713Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.32,100.847l-4.046-2.34c-.232-.134-.173-.385.131-.561l3.085-1.779a1.093,1.093,0,0,1,.971-.075l4.046,2.34c.232.135.173.385-.131.561l-3.086,1.78A1.094,1.094,0,0,1,131.32,100.847Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.6,103.9l-4.045-2.34c-.232-.134-.174-.385.13-.561l3.086-1.779a1.093,1.093,0,0,1,.971-.075l4.045,2.34c.232.135.174.386-.131.561l-3.085,1.78A1.093,1.093,0,0,1,136.6,103.9Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.885,106.959l-4.046-2.34c-.232-.134-.173-.385.131-.561l3.085-1.779a1.094,1.094,0,0,1,.971-.075l4.046,2.34c.232.134.173.385-.131.561l-3.086,1.78A1.094,1.094,0,0,1,141.885,106.959Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.167,110.015l-4.045-2.34c-.232-.134-.174-.385.13-.561l3.086-1.779a1.093,1.093,0,0,1,.971-.075l4.045,2.34c.232.135.174.386-.131.561l-3.085,1.78A1.1,1.1,0,0,1,147.167,110.015Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.45,113.071l-4.046-2.34c-.232-.134-.173-.385.131-.561l3.085-1.779a1.094,1.094,0,0,1,.971-.075l4.046,2.34c.232.134.173.385-.131.561L153.421,113A1.093,1.093,0,0,1,152.45,113.071Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.732,116.127l-4.045-2.34c-.232-.134-.173-.385.131-.561l3.085-1.779a1.093,1.093,0,0,1,.971-.075l4.045,2.34c.232.135.174.385-.13.561l-3.086,1.78A1.1,1.1,0,0,1,157.732,116.127Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.015,119.183l-4.046-2.34c-.231-.134-.173-.385.131-.561l3.086-1.779a1.091,1.091,0,0,1,.97-.075l4.046,2.34c.232.134.173.385-.131.561l-3.085,1.779A1.094,1.094,0,0,1,163.015,119.183Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.3,122.239l-4.046-2.34c-.232-.134-.173-.385.131-.561l3.085-1.779a1.093,1.093,0,0,1,.971-.075l4.045,2.34c.232.135.174.385-.13.561l-3.086,1.78A1.094,1.094,0,0,1,168.3,122.239Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.58,125.3l-4.045-2.34c-.232-.134-.174-.385.13-.561l3.086-1.779a1.091,1.091,0,0,1,.97-.075l4.046,2.34c.232.134.173.385-.131.561l-3.085,1.779A1.093,1.093,0,0,1,173.58,125.3Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.863,128.351l-4.046-2.34c-.232-.135-.173-.385.131-.561l3.085-1.779A1.094,1.094,0,0,1,179,123.6l4.046,2.34c.231.134.173.385-.131.561l-3.086,1.779A1.091,1.091,0,0,1,178.863,128.351Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.145,131.407l-4.045-2.34c-.232-.134-.174-.385.13-.561l3.086-1.779a1.091,1.091,0,0,1,.97-.075l4.046,2.34c.232.134.174.385-.131.561l-3.085,1.779A1.093,1.093,0,0,1,184.145,131.407Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.648,103.542,122.6,101.2c-.232-.134-.173-.385.131-.56l3.085-1.78a1.093,1.093,0,0,1,.971-.075l4.045,2.341c.232.134.174.385-.13.56l-3.086,1.78A1.1,1.1,0,0,1,126.648,103.542Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.931,106.6l-4.046-2.341c-.232-.134-.173-.385.131-.56l3.086-1.78a1.1,1.1,0,0,1,.97-.075l4.046,2.341c.232.134.173.385-.131.56l-3.085,1.78A1.1,1.1,0,0,1,131.931,106.6Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.214,109.654l-4.046-2.341c-.232-.134-.173-.385.131-.56l3.085-1.78a1.093,1.093,0,0,1,.971-.075l4.046,2.341c.231.134.173.385-.131.56l-3.086,1.78A1.1,1.1,0,0,1,137.214,109.654Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.839,127.949l-30.319-17.54c-.27-.156-.2-.449.153-.653l2.9-1.674a1.273,1.273,0,0,1,1.132-.087l30.319,17.539c.271.157.2.449-.152.654l-2.9,1.674A1.273,1.273,0,0,1,168.839,127.949Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.192,131.046l-4.046-2.341c-.232-.134-.174-.385.131-.561l3.085-1.779a1.093,1.093,0,0,1,.971-.075l4.045,2.341c.232.134.174.385-.13.56l-3.086,1.78A1.1,1.1,0,0,1,174.192,131.046Z",
    style: {
      fill: "#418ab7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.474,134.1l-4.046-2.34c-.231-.134-.173-.385.131-.561l3.086-1.779a1.091,1.091,0,0,1,.97-.075l4.046,2.34c.232.135.173.386-.131.561l-3.085,1.78A1.093,1.093,0,0,1,179.474,134.1Z",
    style: {
      fill: "#418ab7"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "137.735 82.413 137.735 49.233 118.367 38.051 118.367 71.231 137.735 82.413",
    style: {
      fill: "#6acdf0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.735 82.413 138.196 82.143 138.196 48.964 137.735 49.233 137.735 82.413",
    style: {
      fill: "#3db5d4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.196 48.964 118.829 37.782 118.367 38.051 137.735 49.233 138.196 48.964",
    style: {
      fill: "#aeecff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "119.221 70.152 136.474 80.114 136.474 50.22 119.221 40.258 119.221 70.152",
    style: {
      fill: "#f4ffff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "120.972 65.04 134.723 72.98 134.723 72.131 120.972 64.191 120.972 65.04",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "124.216 60.968 131.479 65.161 131.479 64.636 124.216 60.442 124.216 60.968",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.972 66.3 134.723 74.239 134.723 73.39 120.972 65.451 120.972 66.3",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.972 67.559 134.723 75.498 134.723 74.649 120.972 66.71 120.972 67.559",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.972 68.818 134.723 76.758 134.723 75.909 120.972 67.969 120.972 68.818",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120.972 70.078 134.723 78.017 134.723 77.168 120.972 69.229 120.972 70.078",
    style: {
      fill: "#c4c4c4"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M130.977,67.521a1.6,1.6,0,0,0,.726,1.254c.4.232.726.046.726-.416a1.6,1.6,0,0,0-.726-1.254C131.3,66.874,130.977,67.06,130.977,67.521Z",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.407,66.037a1.6,1.6,0,0,0,.726,1.254c.4.232.726.045.726-.416a1.6,1.6,0,0,0-.726-1.254C128.732,65.39,128.407,65.576,128.407,66.037Z",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.836,64.553a1.6,1.6,0,0,0,.726,1.254c.4.231.726.045.726-.416a1.6,1.6,0,0,0-.726-1.254C126.161,63.905,125.836,64.092,125.836,64.553Z",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.266,63.068a1.6,1.6,0,0,0,.726,1.255c.4.231.725.045.725-.416a1.6,1.6,0,0,0-.725-1.254C123.591,62.421,123.266,62.607,123.266,63.068Z",
    style: {
      fill: "#c4c4c4"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "121.745 50.452 121.745 55.195 133.949 62.275 133.949 57.247 128.044 51.552 121.745 50.452",
    style: {
      fill: "#ed9b27"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "191.214 113.3 191.214 80.12 171.847 68.938 171.847 102.118 191.214 113.3",
    style: {
      fill: "#6acdf0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.214 113.3 191.676 113.03 191.676 79.851 191.214 80.12 191.214 113.3",
    style: {
      fill: "#3db5d4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "191.676 79.851 172.308 68.669 171.847 68.938 191.214 80.12 191.676 79.851",
    style: {
      fill: "#aeecff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "172.701 101.039 189.954 111.001 189.954 81.107 172.701 71.145 172.701 101.039",
    style: {
      fill: "#f4ffff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "174.452 95.927 188.202 103.867 188.202 103.018 174.452 95.078 174.452 95.927",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "177.696 91.855 184.959 96.048 184.959 95.523 177.696 91.329 177.696 91.855",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.452 97.187 188.202 105.126 188.202 104.277 174.452 96.338 174.452 97.187",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.452 98.446 188.202 106.385 188.202 105.536 174.452 97.597 174.452 98.446",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.452 99.705 188.202 107.645 188.202 106.796 174.452 98.856 174.452 99.705",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.452 100.965 188.202 108.904 188.202 108.055 174.452 100.116 174.452 100.965",
    style: {
      fill: "#c4c4c4"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M184.457,98.408a1.6,1.6,0,0,0,.726,1.254c.4.232.726.046.726-.416a1.6,1.6,0,0,0-.726-1.254C184.782,97.761,184.457,97.947,184.457,98.408Z",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.887,96.924a1.6,1.6,0,0,0,.725,1.254c.4.232.726.045.726-.416a1.6,1.6,0,0,0-.726-1.254C182.212,96.276,181.887,96.463,181.887,96.924Z",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.316,95.44a1.6,1.6,0,0,0,.726,1.254c.4.231.726.045.726-.416a1.6,1.6,0,0,0-.726-1.254C179.641,94.792,179.316,94.978,179.316,95.44Z",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.745,93.955a1.6,1.6,0,0,0,.726,1.255c.4.231.726.045.726-.416a1.6,1.6,0,0,0-.726-1.255C177.07,93.308,176.745,93.494,176.745,93.955Z",
    style: {
      fill: "#c4c4c4"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "175.026 80.93 175.026 85.673 187.23 92.753 187.23 87.725 181.325 82.03 175.026 80.93",
    style: {
      fill: "#ed9b27"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "146.063 94.672 146.063 61.492 126.695 50.31 126.695 83.49 146.063 94.672",
    style: {
      fill: "#6acdf0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.063 94.672 146.525 94.403 146.525 61.223 146.063 61.492 146.063 94.672",
    style: {
      fill: "#3db5d4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "146.525 61.223 127.157 50.041 126.695 50.31 146.063 61.492 146.525 61.223",
    style: {
      fill: "#aeecff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "127.402 82.289 144.655 92.251 144.655 62.357 127.402 52.395 127.402 82.289",
    style: {
      fill: "#f4ffff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "129.154 77.178 142.904 85.117 142.904 84.268 129.154 76.329 129.154 77.178",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "132.397 73.105 139.66 77.299 139.66 76.773 132.397 72.579 132.397 73.105",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.154 78.437 142.904 86.376 142.904 85.528 129.154 77.588 129.154 78.437",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.154 79.696 142.904 87.636 142.904 86.787 129.154 78.847 129.154 79.696",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.154 80.956 142.904 88.895 142.904 88.046 129.154 80.107 129.154 80.956",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "129.154 82.215 142.904 90.154 142.904 89.306 129.154 81.366 129.154 82.215",
    style: {
      fill: "#c4c4c4"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M139.159,79.659a1.6,1.6,0,0,0,.726,1.254c.4.231.725.045.725-.416a1.6,1.6,0,0,0-.725-1.254C139.484,79.011,139.159,79.2,139.159,79.659Z",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.588,78.174a1.6,1.6,0,0,0,.726,1.255c.4.231.726.045.726-.416a1.6,1.6,0,0,0-.726-1.255C136.913,77.527,136.588,77.713,136.588,78.174Z",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.017,76.69a1.6,1.6,0,0,0,.726,1.254c.4.232.726.046.726-.416a1.6,1.6,0,0,0-.726-1.254C134.343,76.043,134.017,76.229,134.017,76.69Z",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.447,75.206a1.6,1.6,0,0,0,.726,1.254c.4.232.726.045.726-.416a1.6,1.6,0,0,0-.726-1.254C131.772,74.558,131.447,74.745,131.447,75.206Z",
    style: {
      fill: "#c4c4c4"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "129.561 62.106 129.561 66.849 141.765 73.929 141.765 68.9 135.86 63.206 129.561 62.106",
    style: {
      fill: "#ed9b27"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "171.847 109.568 171.847 76.388 152.479 65.206 152.479 98.386 171.847 109.568",
    style: {
      fill: "#6acdf0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "171.847 109.568 172.308 109.299 172.308 76.119 171.847 76.388 171.847 109.568",
    style: {
      fill: "#3db5d4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "172.308 76.119 152.941 64.937 152.479 65.206 171.847 76.388 172.308 76.119",
    style: {
      fill: "#aeecff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "153.186 97.185 170.439 107.147 170.439 77.253 153.186 67.291 153.186 97.185",
    style: {
      fill: "#f4ffff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "154.937 92.074 168.687 100.013 168.687 99.164 154.937 91.225 154.937 92.074",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "158.181 88.001 165.444 92.195 165.444 91.669 158.181 87.475 158.181 88.001",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.937 93.333 168.687 101.273 168.687 100.424 154.937 92.484 154.937 93.333",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.937 94.593 168.687 102.532 168.687 101.683 154.937 93.744 154.937 94.593",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.937 95.852 168.687 103.791 168.687 102.942 154.937 95.003 154.937 95.852",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.937 97.111 168.687 105.051 168.687 104.202 154.937 96.262 154.937 97.111",
    style: {
      fill: "#c4c4c4"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M164.942,94.555a1.6,1.6,0,0,0,.726,1.254c.4.231.726.045.726-.416a1.6,1.6,0,0,0-.726-1.254C165.267,93.907,164.942,94.094,164.942,94.555Z",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.372,93.07a1.6,1.6,0,0,0,.726,1.255c.4.231.726.045.726-.416a1.6,1.6,0,0,0-.726-1.254C162.7,92.423,162.372,92.609,162.372,93.07Z",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.8,91.586a1.6,1.6,0,0,0,.726,1.254c.4.232.726.046.726-.416a1.6,1.6,0,0,0-.726-1.254C160.126,90.939,159.8,91.125,159.8,91.586Z",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.231,90.1a1.6,1.6,0,0,0,.726,1.254c.4.232.725.045.725-.416a1.6,1.6,0,0,0-.725-1.254C157.556,89.455,157.231,89.641,157.231,90.1Z",
    style: {
      fill: "#c4c4c4"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "155.826 77.498 155.826 82.241 168.03 89.321 168.03 84.292 162.124 78.598 155.826 77.498",
    style: {
      fill: "#ed9b27"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "152.475 105.854 152.475 72.674 133.107 61.492 133.107 94.672 152.475 105.854",
    style: {
      fill: "#6acdf0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.475 105.854 152.936 105.585 152.936 72.405 152.475 72.674 152.475 105.854",
    style: {
      fill: "#3db5d4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "152.936 72.405 133.569 61.223 133.107 61.492 152.475 72.674 152.936 72.405",
    style: {
      fill: "#aeecff"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "133.814 93.471 151.067 103.433 151.067 73.539 133.814 63.577 133.814 93.471",
    style: {
      fill: "#f4ffff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "135.565 88.36 149.316 96.299 149.316 95.45 135.565 87.511 135.565 88.36",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.809 84.287 146.072 88.481 146.072 87.955 138.809 83.761 138.809 84.287",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.565 89.619 149.316 97.559 149.316 96.71 135.565 88.77 135.565 89.619",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.565 90.878 149.316 98.818 149.316 97.969 135.565 90.029 135.565 90.878",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.565 92.138 149.316 100.077 149.316 99.228 135.565 91.289 135.565 92.138",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.565 93.397 149.316 101.336 149.316 100.488 135.565 92.548 135.565 93.397",
    style: {
      fill: "#c4c4c4"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M145.57,90.841A1.6,1.6,0,0,0,146.3,92.1c.4.231.726.045.726-.416a1.6,1.6,0,0,0-.726-1.254C145.9,90.193,145.57,90.379,145.57,90.841Z",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,89.356a1.6,1.6,0,0,0,.726,1.255c.4.231.726.045.726-.416a1.6,1.6,0,0,0-.726-1.255C143.325,88.709,143,88.9,143,89.356Z",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.429,87.872a1.6,1.6,0,0,0,.726,1.254c.4.232.726.046.726-.416a1.6,1.6,0,0,0-.726-1.254C140.754,87.225,140.429,87.411,140.429,87.872Z",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.859,86.388a1.6,1.6,0,0,0,.726,1.254c.4.232.725.045.725-.416a1.6,1.6,0,0,0-.725-1.254C138.184,85.74,137.859,85.927,137.859,86.388Z",
    style: {
      fill: "#c4c4c4"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "136.689 74.812 136.689 79.555 148.893 86.634 148.893 81.606 142.988 75.912 136.689 74.812",
    style: {
      fill: "#ed9b27"
    }
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M132.131,165.179l26.275-15.17a1.7,1.7,0,0,1,1.7,0l16.915,9.766a1.344,1.344,0,0,1,0,2.329l-10.346,5.973a4.942,4.942,0,0,1-4.945,0h0l-14.164,8.177a1.34,1.34,0,0,1-1.344,0l-14.089-8.134A1.7,1.7,0,0,1,132.131,165.179Z",
    style: {
      fill: "#00233b",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.131,162.955l26.275-15.17a1.7,1.7,0,0,1,1.7,0l16.915,9.765a1.345,1.345,0,0,1,0,2.33l-10.346,5.973a4.947,4.947,0,0,1-4.945,0h0l-14.164,8.177a1.344,1.344,0,0,1-1.344,0L132.131,165.9A1.7,1.7,0,0,1,132.131,162.955Z",
    style: {
      fill: "#ed9b27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.131,162.437l26.275-15.17a1.7,1.7,0,0,1,1.7,0l16.915,9.766a1.344,1.344,0,0,1,0,2.329l-10.346,5.973a4.947,4.947,0,0,1-4.945,0h0l-14.164,8.177a1.34,1.34,0,0,1-1.344,0l-14.089-8.134A1.7,1.7,0,0,1,132.131,162.437Z",
    style: {
      fill: "#f7c12a"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M132.131,159.557l26.275-15.17a1.7,1.7,0,0,1,1.7,0l16.915,9.766a1.344,1.344,0,0,1,0,2.329l-10.346,5.973a4.942,4.942,0,0,1-4.945,0h0l-14.164,8.177a1.34,1.34,0,0,1-1.344,0L132.131,162.5A1.7,1.7,0,0,1,132.131,159.557Z",
    style: {
      fill: "#ed9b27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.131,159.039l26.275-15.17a1.7,1.7,0,0,1,1.7,0l16.915,9.766a1.344,1.344,0,0,1,0,2.329l-10.346,5.973a4.942,4.942,0,0,1-4.945,0h0l-14.164,8.178a1.344,1.344,0,0,1-1.344,0l-14.089-8.135A1.7,1.7,0,0,1,132.131,159.039Z",
    style: {
      fill: "#f7c12a"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M132.131,156.159l26.275-15.17a1.7,1.7,0,0,1,1.7,0l16.915,9.766a1.344,1.344,0,0,1,0,2.329l-10.346,5.974a4.947,4.947,0,0,1-4.945,0h0l-14.164,8.177a1.344,1.344,0,0,1-1.344,0L132.131,159.1A1.7,1.7,0,0,1,132.131,156.159Z",
    style: {
      fill: "#ed9b27"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.131,155.642l26.275-15.171a1.7,1.7,0,0,1,1.7,0l16.915,9.766a1.345,1.345,0,0,1,0,2.33l-10.346,5.973a4.947,4.947,0,0,1-4.945,0h0l-14.164,8.177a1.344,1.344,0,0,1-1.344,0l-14.089-8.134A1.7,1.7,0,0,1,132.131,155.642Z",
    style: {
      fill: "#f7c12a"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "60.527 110.001 54.238 106.351 54.238 115.804 60.527 119.444 60.527 110.001",
    style: {
      fill: "#f7c12a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "55.788 105.478 54.238 106.351 60.527 110.001 62.085 109.123 55.788 105.478",
    style: {
      fill: "#f7da32"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "62.085 109.123 60.527 110.001 60.527 119.444 62.085 118.541 62.085 109.123",
    style: {
      fill: "#ed9b27"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "67.595 106.008 61.306 102.358 61.306 119.897 67.595 123.537 67.595 106.008",
    style: {
      fill: "#f7c12a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "62.856 101.485 61.306 102.358 67.595 106.008 69.154 105.13 62.856 101.485",
    style: {
      fill: "#f7da32"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.154 105.13 67.595 106.008 67.595 123.537 69.154 122.634 69.154 105.13",
    style: {
      fill: "#ed9b27"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "74.663 100.649 68.374 96.998 68.374 123.991 74.664 127.631 74.663 100.649",
    style: {
      fill: "#f7c12a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "69.924 96.125 68.374 96.998 74.663 100.649 76.222 99.77 69.924 96.125",
    style: {
      fill: "#f7da32"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.222 99.77 74.663 100.649 74.664 127.631 76.222 126.728 76.222 99.77",
    style: {
      fill: "#ed9b27"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "81.731 94.8 75.442 91.149 75.442 128.084 81.731 131.724 81.731 94.8",
    style: {
      fill: "#f7c12a"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "76.993 90.277 75.442 91.149 81.731 94.8 83.29 93.922 76.993 90.277",
    style: {
      fill: "#f7da32"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.29 93.922 81.731 94.8 81.731 131.724 83.29 130.821 83.29 93.922",
    style: {
      fill: "#ed9b27"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 97.555,
    cy: 156.858,
    rx: 9.641,
    ry: 18.248,
    transform: "translate(-73.13 227.483) rotate(-80.6)",
    style: {
      fill: "#00233b",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M96.761,158.6s-.81,2.721,1.3,3.3,2.475-.594,3.227-.98,5.455-2.831,6.338-3.941-1.788-2.8-5.912-.183Z",
    style: {
      fill: "#113f54"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.189,153.782s-1,2.5.944,3.231,2.651-1.249,3.228-1.616a26.133,26.133,0,0,0,3.808-2.825c.929-.973-.467-3.1-4.585-.977Z",
    style: {
      fill: "#113f54"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.033,114.109s-.569,16.993-.406,20.243c-1.707,3.981-1.893,15.944-1.434,19.755,0,.6,4.6.7,4.6-1.431a145.762,145.762,0,0,1,2.344-15.508c.5-1.679,2.179-7.205,2.179-7.205V114.109l-5.417-.8Z",
    style: {
      fill: "#1f5779"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.428,107.435s-3.325,1.446-5.8-2.176,2.113-2.988,2.113-2.988l3.169,1.878Z",
    style: {
      fill: "#1c516e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.48,158.319c.05.693,5.458,1.634,5.458-.808s.268-13.517.993-18.129,2.654-12.751,1.948-18.114-.812-7.473-.922-8.815H96.019s.881,22.914.881,25.027S96.222,154.739,96.48,158.319Z",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.087,86.732a4.9,4.9,0,0,0-4.562-.678c-2.307.784-4.009,3.463-4.009,7.813s2.357,5.694,2.357,12.1-2.324,7.963-1.951,12.785,14.722,6.745,16.713,4.063c1.5-2.519-1.6-13.9-1.178-17.39s2.254-11.259,1.4-13.384C105.279,90.583,100.744,87.4,97.087,86.732Z",
    style: {
      fill: "#2a6690"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.381,103.7c1.839,3.8,3.314,3.983,4.047,3.737,1.1-.369,1.609-1.769.94-4.776s-2.883-12.412-6.074-11.12C101.006,92.871,103.543,99.9,105.381,103.7Z",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M96.05,84.01V86.8c0,.894,2.514,2.024,4.713,1V85.446s2.492.352,3.033,0,1.03-8.172-.46-9.084C100.9,74.476,94.8,75.271,94.8,79.053,94.8,80.245,96.05,81.708,96.05,84.01Z",
    style: {
      fill: "#f3976b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.383,78.984c.726.845,5.08.045,6.7-.905s5.146-3.685,3.657-6.367-2.206.244-4.659.786S90.738,74.744,94.383,78.984Z",
    style: {
      fill: "#6b4434"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.739,78.079c-.371,1.814,1.6,6.687,2.419,6.687,1.761-.025,3.3-2.809,4.713-3.313s2.683-3.555,1.5-4.251S93.739,78.079,93.739,78.079Z",
    style: {
      fill: "#6b4434"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.86,88.723c.077.425-2.046,2.331-5.459.821s-1.455-2.611-1.455-2.611l2.765,1.478,1.95.066Z",
    style: {
      fill: "#225a7c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.05,86.483s.771,1.956,4.713,1.008a1.725,1.725,0,0,1,1.1,1.232c-1.016,1.395-6.42.894-7.056-1.611A1.422,1.422,0,0,1,96.05,86.483Z",
    style: {
      fill: "#b4d8ef"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.348,82.227c-.433-.264-1.251-1.444-.427-1.873a.957.957,0,0,1,1.219.694",
    style: {
      fill: "#f3976b"
    }
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "201.209 76.182 219.634 86.771 219.634 108.792 201.209 98.133 201.209 76.182",
    style: {
      fill: "#b9ccdf"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.634 86.771 221.02 85.943 221.02 107.964 219.634 108.792 219.634 86.771",
    style: {
      fill: "#a5bacc"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.209 76.182 202.62 75.368 221.02 85.943 219.634 86.771 201.209 76.182",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "202.766 78.938 218.078 87.737 218.077 106.036 202.766 97.179 202.766 78.938",
    style: {
      fill: "#f3f5ff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "203.884 91.36 203.884 96.315 206.657 97.919 206.657 92.954 203.884 91.36",
    style: {
      fill: "#f7ac40"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "202.481 95.063 202.481 95.543 203.35 96.046 203.35 95.563 202.481 95.063",
    style: {
      fill: "#b9ccdf"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.481 93.222 202.481 93.702 203.35 94.205 203.35 93.722 202.481 93.222",
    style: {
      fill: "#b9ccdf"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.481 91.381 202.481 91.861 203.35 92.364 203.35 91.881 202.481 91.381",
    style: {
      fill: "#b9ccdf"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.481 89.54 202.481 90.02 203.35 90.524 203.35 90.04 202.481 89.54",
    style: {
      fill: "#b9ccdf"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.481 87.699 202.481 88.179 203.35 88.683 203.35 88.199 202.481 87.699",
    style: {
      fill: "#b9ccdf"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.481 85.858 202.481 86.339 203.35 86.842 203.35 86.358 202.481 85.858",
    style: {
      fill: "#b9ccdf"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.481 84.017 202.481 84.498 203.35 85.001 203.35 84.517 202.481 84.017",
    style: {
      fill: "#b9ccdf"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "202.481 82.177 202.481 82.657 203.35 83.16 203.35 82.676 202.481 82.177",
    style: {
      fill: "#b9ccdf"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "207.318 89.205 207.318 98.306 210.092 99.911 210.092 90.799 207.318 89.205",
    style: {
      fill: "#f7ac40"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.752 92.433 210.752 100.298 213.526 101.903 213.526 94.027 210.752 92.433",
    style: {
      fill: "#f7ac40"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.186 89.654 214.186 102.29 216.96 103.894 216.96 91.248 214.186 89.654",
    style: {
      fill: "#f7ac40"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "136.938 18.952 155.363 29.541 155.362 51.561 136.938 40.903 136.938 18.952",
    style: {
      fill: "#b9ccdf"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.363 29.541 156.749 28.712 156.749 50.733 155.362 51.561 155.363 29.541",
    style: {
      fill: "#a5bacc"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.938 18.952 138.348 18.137 156.749 28.712 155.363 29.541 136.938 18.952",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "138.495 21.707 153.806 30.507 153.805 48.805 138.495 39.949 138.495 21.707",
    style: {
      fill: "#f3f5ff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "138.209 37.832 138.209 38.312 139.079 38.816 139.079 38.332 138.209 37.832",
    style: {
      fill: "#b9ccdf"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.209 35.991 138.209 36.471 139.079 36.975 139.079 36.491 138.209 35.991",
    style: {
      fill: "#b9ccdf"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.209 34.15 138.209 34.63 139.079 35.134 139.079 34.65 138.209 34.15",
    style: {
      fill: "#b9ccdf"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.209 32.309 138.209 32.79 139.079 33.293 139.079 32.809 138.209 32.309",
    style: {
      fill: "#b9ccdf"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.209 30.468 138.209 30.949 139.079 31.452 139.079 30.968 138.209 30.468",
    style: {
      fill: "#b9ccdf"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.209 28.627 138.209 29.108 139.079 29.611 139.079 29.127 138.209 28.627",
    style: {
      fill: "#b9ccdf"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.209 26.787 138.209 27.267 139.079 27.77 139.079 27.286 138.209 26.787",
    style: {
      fill: "#b9ccdf"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.209 24.946 138.209 25.426 139.079 25.929 139.079 25.446 138.209 24.946",
    style: {
      fill: "#b9ccdf"
    }
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M151.131,33.333c-.583-.337-1.057-.066-1.059.6a2.1,2.1,0,0,0,.279.981l-4.263,4.051a1.958,1.958,0,0,0-.548-.5.724.724,0,0,0-.77-.057l-2.316-3.042a1.088,1.088,0,0,0,.039-.287,2.318,2.318,0,0,0-1.052-1.822c-.583-.337-1.057-.067-1.059.6a2.32,2.32,0,0,0,1.052,1.823.785.785,0,0,0,.673.1l2.388,3.137a1.1,1.1,0,0,0-.014.145,2.315,2.315,0,0,0,1.053,1.823c.583.337,1.057.067,1.059-.6a2.031,2.031,0,0,0-.219-.863l4.284-4.071a1.885,1.885,0,0,0,.466.4c.583.337,1.057.067,1.059-.6A2.317,2.317,0,0,0,151.131,33.333Z",
    style: {
      fill: "#55c1fc"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "243.032 147.295 213.727 163.896 195.05 153.091 224.353 136.495 243.032 147.295",
    style: {
      fill: "#ed9b27"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "219.464 163.498 219.464 164.151 248.77 147.374 248.77 146.896 219.464 163.498",
    style: {
      fill: "#d5d5d5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "248.77 146.896 219.464 163.498 200.787 152.693 230.09 136.096 248.77 146.896",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.464 163.498 219.464 164.151 200.787 153.346 200.787 152.693 219.464 163.498",
    style: {
      fill: "#d5d5d5"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "229.889 137.868 241.173 144.376 240.678 144.656 229.394 138.148 229.889 137.868",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "228.717 138.533 240 145.041 239.506 145.32 228.222 138.813 228.717 138.533",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.988 140.077 241.526 149.046 241.032 149.325 225.494 140.357 225.988 140.077",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "224.913 140.688 240.451 149.656 239.956 149.936 224.418 140.968 224.913 140.688",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.837 141.298 239.375 150.266 238.881 150.546 223.343 141.578 223.837 141.298",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "222.762 141.908 238.299 150.877 237.805 151.157 222.267 142.189 222.762 141.908",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.686 142.519 237.224 151.487 236.73 151.767 221.192 142.799 221.686 142.519",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "220.611 143.129 236.149 152.098 235.654 152.378 220.116 143.41 220.611 143.129",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.535 143.74 235.073 152.708 234.578 152.988 219.041 144.02 219.535 143.74",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "218.46 144.35 233.998 153.319 233.503 153.598 217.965 144.63 218.46 144.35",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "217.384 144.961 232.922 153.929 232.428 154.209 216.89 145.24 217.384 144.961",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.309 145.571 231.846 154.539 231.352 154.819 215.814 145.851 216.309 145.571",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "215.233 146.181 230.771 155.15 230.277 155.43 214.739 146.461 215.233 146.181",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214.158 146.792 229.696 155.76 229.201 156.04 213.663 147.072 214.158 146.792",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213.082 147.402 228.62 156.371 228.125 156.651 212.588 147.683 213.082 147.402",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "212.006 148.013 227.544 156.981 227.05 157.261 211.512 148.293 212.006 148.013",
    style: {
      fill: "#c4c4c4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.931 148.623 226.469 157.592 225.975 157.871 210.437 148.903 210.931 148.623",
    style: {
      fill: "#c4c4c4"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowroomReserveProject);
export default __webpack_public_path__ + "static/media/showroom_reserve_project.ee2592e3effa82e18dac4418143338c1.svg";
export { ForwardRef as ReactComponent };